import GraficaDia from '@/components/GraficaDia.vue';
import GraficaDiaFinal from '@/components/GraficaDiaFinal.vue';
import { datosEditadosSimulados } from './mockData';
const DayPlan = {
    components: { GraficaDia, GraficaDiaFinal },
    data() {
        return {
            cargando: false,

            esEdicionModo: false,
            cargandoEdicion: !!localStorage.getItem('intentandoEditar'),
            mensajeLoader: 'Procesando...',
            servicioEdicion: null,
            nombreProgramaEdicion: '',

            dialoggraf: false,
            dialoggrafdes: false,
            dialoggrafres: false,
            contadorReasignaciones: 0,
            loading: false,
            graficaSeleccionada: null,
            tab: 0,
            tablaKey: 0,
            servicioId: null,
            servicios: [],
            escenarios: [],
            nombreEscenarioSeleccionado: null,
            ventanas: [],
            diasDisponibles: [],
            planDiaModelo: [],
            tipoEscenario: 'transacciones',
            tipo_escenario: [
                { text: 'Transacciones Entrantes', value: 'transacciones' },
                { text: 'Transacciones Salientes', value: 'horas' },
                { text: 'Agentes', value: 'agentes' }
            ],
            parametros: {
                tmg: 325,
                nivel: 85,
                umbral: 20,
                horas_x_fte_semanal: 48,
            },
            diasEnOrden: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
            matrizAsignacion: [], // aquí irá nuestra matriz dinámica
            turnosServicio: [], // se llenará con los turnos por servicio
            resumenMaximos: [],
            resumenRealFinal: {},
            headersResumen: [
                { text: 'Turno', value: 'turno' },
                { text: 'Agentes requeridos', value: 'requerido' }
            ],
            items: [],
            headers: [],
            //graficas
            graficasPorDiaPreeliminar: {},
            maxEjeYPreeliminar: 0,
            maxEjeYDescansos: 0,
            maxEjeYRecesos: 0,
            maxEjeYFinal: 0,
            graficasPorDiaDescansos: {},
            graficasPorDiaRecesos: {},
            graficasPorDiaFinal: {},

            programacionConDescansos: {},
            itemsConDescanso: [],
            programacionSemanal: [],
            programacionSemanalFinal: [],
            detallesPorAgente: [],
            detalleRealFinal: [],
            headersAgente: [
                { text: 'Agente', value: 'nombre' },
                { text: 'Turno', value: 'horario' },
                { text: 'Jornada', value: 'jornada' },
                { text: 'Recesos', value: 'recesos' },
                { text: 'Días', value: 'dias' }
            ],
            itemsAgente: [],
            diasUnicosRecesos: [],
            columnasReceso: [],
            descansosTransformados: [],
            descansosFinales: [],

            itemsTablaResumen: [],
            dailyBackup: {},
            historyStack: [],
            redoStack: [],
            maxHistory: 20,
            headersTablaResumen: [],
            diasUnicosResumen: [],

            escenariosFiltrados: [],
            valoresOriginales: {},
            headersResumenEficiencia: [
                { text: 'Día Semana', value: 'dia' },
                { text: 'Numero Operadores', value: 'operadores' },
                { text: 'Pronostico de carga de trabajo semanal requerido', value: 'requeridos' },
                { text: 'Pronostico de carga de trabajo semanal requerido + Reductores', value: 'requeridosConReductores' },
                { text: 'Planificacion de horas brutas (Programacion)', value: 'programacion' },
                { text: 'Eficiencia Sin Reductores', value: 'eficienciaSinReductores' },
                { text: 'Eficiencia Con Reductores', value: 'eficienciaConReductores' },
                { text: 'Reductores', value: 'reductores' },
                { text: 'Planif. sin Reductores', value: 'planifSinReductores' },
                { text: 'Exceso o deficit de produccion estimada', value: 'excesoDeficit' },
            ],
            headerFTEs: [
                { text: 'Jornada Neta', value: 'jornada', align: 'start' },
                { text: 'Agentes', value: 'agentes', align: 'end' },
                { text: 'Horas Semanales Eq.', value: 'totalHoras', align: 'end' },
                { text: 'Total FTE', value: 'fte', align: 'end' },
            ],
            dialogNombreProgramacion: false,
            nombreProgramacion: '',
            actualizando: false,
            recesosEsperados: null,

            dialogAplicarSemana: false,
            diasSeleccionados: [],
            valorTemporal: '',
            tipoTemporal: '',
            diaTemporal: '',
            agenteTemporal: null,

            arrastrando: false,
            valorArrastrado: "",
            indiceOrigen: null,
            diaOrigen: "",
            campoOrigen: "",
            items: [],
            isFieldValid: true,
            mostrarModalTurnos: false,
            turnoSeleccionado: null,
            celdaActiva: null,

            valorEditado: null,
            valorOriginal: null,
            tiposReceso: ['receso60', 'receso30', 'receso15'],
            dialogEliminarMasivo: {
                visible: false,
                nombre: "",
            },
            dialogEliminarIndividual: {
                visible: false,
                nombreAgente: '',
                indice: -1,
            },
            isSaving: false,
            nivelOptimizacion: 0.5,

            ordenActual: { key: '', dir: 'asc' }, // Para rastrear el orden

            /////////////////////
            objetivoRQ: 95,
            objetivoEficiencia: 95,
            tipoMapaRequeridos: 'pico',
            tipoMapaAsignados: 'pico',

            //nuevos datos
            mostrarModalCambioDescanso: false,
            nuevoDiaDescanso: null,
        }
    },
    created() {
        if (this.cargandoEdicion) {
            this.mensajeLoader = 'Preparando entorno de edición...';
        }
    },
    async mounted() {
        await this.cargarServicios();
        window.addEventListener('keydown', this.handleKeydown);

        const sEdicion = localStorage.getItem('servicioEdicion');
        const nEdicion = localStorage.getItem('nombreProgramaEdicion');

        if (sEdicion && nEdicion) {
            this.esEdicionModo = true;
            this.nombreProgramacion = nEdicion;
            this.servicioEdicion = sEdicion;
            this.nombreProgramaEdicion = nEdicion;
            //this.servicioId = sEdicion;

            // Limpiamos el LocalStorage de inmediato para que si el usuario 
            // entra a "Nueva Programación" después, no se cargue lo anterior
            localStorage.removeItem('servicioEdicion');
            localStorage.removeItem('nombreProgramaEdicion');
            localStorage.removeItem('intentandoEditar');

            // Ejecutamos la carga
            this.cargarDatosParaEdicion();
        } else {
            // Si no hay edición, apagamos el loader que encendimos en el data()
            this.cargandoEdicion = false;
        }

        //console.log(this.servicios);
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.handleKeydown);
    },
    watch: {
        servicioId(val) {
            if (val) {
                this.cargarVentanaServicio();
                this.cargarTurnos();
            }
        },
        graficasPorDiaFinal: {
            handler(nuevoValor) {
                const dias = Object.keys(nuevoValor);
                if (dias.length > 0 && !this.graficaSeleccionada) {
                    this.graficaSeleccionada = dias[0];
                }
            },
            immediate: true
        },
        /*itemsTablaResumen: {
            handler() {
                this.generarDatosGraficasPorDiaFinal();
            },
            deep: true
        }*/

    },
    computed: {
        diasOpciones() {
            // Filtramos para que no pueda elegir el mismo día que acaba de activar
            return this.diasUnicos.filter(d => d.toLowerCase() !== this.diaTemporal.toLowerCase());
        },
        resumenPicosPorDia(data) {
            if (!this.graficasPorDiaFinal || Object.keys(this.graficasPorDiaFinal).length === 0) return {};

            const resumen = {
                porDia: {},
                global: { max: 0, min: Infinity } // Para el Comportamiento Semanal
            };
            const valor = data;

            const todosLosValores = [];

            this.dias.forEach((dia) => {
                const valores = this.graficasPorDiaFinal[dia]?.valor || [];
                const nums = valores.map(v => parseFloat(v)).filter(v => !isNaN(v));

                if (nums.length > 0) {
                    const pico = Math.max(...nums);
                    const minimo = Math.min(...nums);

                    resumen.porDia[dia] = {
                        pico,
                        minimo,
                        promedio: nums.reduce((a, b) => a + b, 0) / nums.length
                    };

                    todosLosValores.push(...nums);
                }
            });

            if (todosLosValores.length > 0) {
                resumen.global.max = Math.max(...todosLosValores);
                resumen.global.min = Math.min(...todosLosValores);
            }

            return resumen;
        },
        resumenRequeridos() {
            // Mapeamos los datos de graficasPorDiaFinal para que solo pase el array de requeridos
            const data = {};
            this.dias.forEach(d => { data[d] = this.graficasPorDiaFinal[d]?.requeridos });
            return this.generarResumenDia(data);
        },
        resumenAsignados() {
            const data = {};
            this.dias.forEach(d => { data[d] = this.graficasPorDiaFinal[d]?.asignados });
            return this.generarResumenDia(data);
        },
        diasUnicos() {
            const dias = [...new Set(this.planDiaModelo.map(item => item.dia_semana))];
            return this.diasEnOrden.filter(d => dias.includes(d));
        },
        headersPorCampo() {
            const baseHeader = [{ text: 'Intervalo', value: 'intervalo' }];
            const headersDinamicos = this.diasUnicos.map(dia => ({ text: dia, value: dia }));

            return {
                volumen: [...baseHeader, ...headersDinamicos],
                requeridos: [...baseHeader, ...headersDinamicos],
                programados: [...baseHeader, ...headersDinamicos],
                diferencia: [...baseHeader, ...headersDinamicos]
            };
        },
        // Items agrupados por intervalo para cada tipo
        matrizPorCampo() {
            const resultado = {
                volumen: [],
                requeridos: [],
                programados: [],
                diferencia: []
            };

            // Agrupar todos los campos en una sola pasada
            const agrupado = {};

            this.planDiaModelo.forEach(item => {
                const intervalo = `${item.intervalo_inicio.slice(0, 5)} - ${item.intervalo_fin.slice(0, 5)}`;
                const dia = item.dia_semana;

                if (!agrupado[intervalo]) {
                    agrupado[intervalo] = {
                        intervalo,
                        volumen: {},
                        requeridos: {},
                        programados: {},
                        diferencia: {}
                    };
                }

                agrupado[intervalo].volumen[dia] = item.volumen;
                agrupado[intervalo].requeridos[dia] = item.requeridos;
                agrupado[intervalo].programados[dia] = item.programados;
                agrupado[intervalo].diferencia[dia] = item.diferencia;
            });

            // Convertir agrupado a listas de objetos por campo
            Object.entries(agrupado).forEach(([intervalo, datos]) => {
                const filaVol = { intervalo };
                const filaReq = { intervalo };
                const filaProg = { intervalo };
                const filaDif = { intervalo };

                this.diasUnicos.forEach(dia => {
                    filaVol[dia] = datos.volumen[dia] ?? null;
                    filaReq[dia] = datos.requeridos[dia] ?? null;
                    filaProg[dia] = datos.programados[dia] ?? null;
                    filaDif[dia] = datos.diferencia[dia] ?? null;
                });

                resultado.volumen.push(filaVol);
                resultado.requeridos.push(filaReq);
                resultado.programados.push(filaProg);
                resultado.diferencia.push(filaDif);
            });
            //console.log('resultado', resultado);
            return resultado;
        },
        headersMatriz() {
            return [
                { text: 'Turno', value: 'turno' },
                ...this.diasDisponibles.map(dia => ({ text: dia, value: dia }))
            ]
        },
        ///despues de todo
        dias() {
            return Object.keys(this.graficasPorDiaFinal);
        },
        intervalos() {
            const primerDia = this.dias[0];
            if (
                primerDia &&
                this.graficasPorDiaFinal[primerDia] &&
                Array.isArray(this.graficasPorDiaFinal[primerDia].intervalos)
            ) {
                return this.graficasPorDiaFinal[primerDia].intervalos;
            }
            return [];

        },
        headersfinal() {
            return [
                { text: "Intervalo", value: "intervalo" },
                ...this.dias.map((dia) => ({ text: dia, value: dia })),
            ];
        },
        programadosData() {
            return this.intervalos.map((intervalo, idx) => {
                const fila = { intervalo };
                this.dias.forEach((dia) => {
                    fila[dia] = this.graficasPorDiaFinal[dia]?.programados[idx] ?? "-";
                });
                return fila;
            });
        },
        requeridosData() {
            return this.intervalos.map((intervalo, idx) => {
                const fila = { intervalo };
                this.dias.forEach((dia) => {
                    fila[dia] = this.graficasPorDiaFinal[dia]?.requeridos[idx] ?? "-";
                });
                return fila;
            });
        },
        asignadosData() {
            return this.intervalos.map((intervalo, idx) => {
                const fila = { intervalo };
                this.dias.forEach((dia) => {
                    fila[dia] = this.graficasPorDiaFinal[dia]?.asignados[idx] ?? "-";
                });
                return fila;
            });
        },
        diferenciaData() {
            return this.intervalos.map((intervalo, idx) => {
                const fila = { intervalo };
                this.dias.forEach((dia) => {
                    fila[dia] = this.graficasPorDiaFinal[dia]?.diferencia[idx] ?? "-";
                });
                //console.log(fila);
                return fila;

            });
        },
        tablaResumenPorDia() {
            const servicio = this.servicios.find(s => s.id === this.servicioId);
            if (!servicio) return [];

            const calcularSemanasDelMes = (inicio, fin) => {
                const fechaInicio = new Date(inicio);
                const fechaFin = new Date(fin);
                const diferenciaEnDias = (fechaFin - fechaInicio) / (1000 * 60 * 60 * 24) + 1;
                return diferenciaEnDias / 7;
            };

            const semanasDelMes = calcularSemanasDelMes(servicio.fecha_vigencia_inicio, servicio.fecha_vigencia_fin);

            const resumen = [];

            let sumaOperadores = 0;
            let totalRequeridos = 0;
            let totalRequeridosConReductores = 0;
            let totalProgramacion = 0;
            let sumaEficienciaSinReductores = 0;
            let sumaEficienciaConReductores = 0;
            let diasContados = 0;

            this.dias.forEach(dia => {
                const datos = this.graficasPorDiaFinal[dia];
                const items = this.itemsTablaResumen;
                if (!datos || !items) return;

                const sumaAsignados = datos.asignados.reduce((acc, val) => acc + val, 0);
                const sumaRequeridos = datos.requeridos.reduce((acc, val) => acc + val, 0);
                const sumaProgramados = datos.programados.reduce((acc, val) => acc + val, 0);
                //console.log(sumaAsignados);
                //console.log(sumaRequeridos);
                //console.log(sumaProgramados);

                const nombreDia = dia.toLowerCase();
                const operadores = items.filter(item => {
                    const horario = item[`${nombreDia}_horario`];
                    return horario && horario !== "DS";
                }).length;

                /**OPERACIONES DE EFICIENCIA */
                const requeridos = sumaRequeridos / 2;
                const requeridosConReductores = sumaProgramados / 2;
                const programacion = sumaAsignados / 2;
                //nuevos datos
                const reductor = requeridosConReductores - requeridos;
                const requeridosSinReductores = programacion - reductor;

                /*const eficienciaSin = programacion > 0
                    ? (requeridos / programacion) * 100
                    : 0;

                const ajuste = requeridosConReductores - requeridos;
                const eficienciaCon = (programacion - ajuste) > 0
                    ? (requeridos / (programacion - ajuste)) * 100
                    : 0;*/
                const eficienciaSinBase = requeridosSinReductores > 0
                    ? (requeridos / requeridosSinReductores) * 100
                    : 0;
                const eficienciaSin = Math.min(eficienciaSinBase, 100);

                const eficienciaConBase = programacion > 0
                    ? (requeridos / programacion) * 100
                    : 0;
                const eficienciaCon = Math.min(eficienciaConBase, 100);

                const reductores = requeridosConReductores - requeridos;
                const planifSinReductores = programacion - reductores;
                const excesoDeficit = planifSinReductores - requeridos;

                /**TERMINA OPERACIONES DE EFICIENCIA */

                // Acumulamos para totales y promedio simple
                sumaOperadores += operadores;
                totalRequeridos += requeridos;
                totalRequeridosConReductores += requeridosConReductores;
                totalProgramacion += programacion;
                sumaEficienciaSinReductores += requeridos * eficienciaSin;
                sumaEficienciaConReductores += requeridos * eficienciaCon;
                diasContados++;

                resumen.push({
                    dia,
                    operadores,
                    requeridos: requeridos.toFixed(2) + " h",
                    requeridosConReductores: requeridosConReductores.toFixed(2) + " h",
                    programacion: programacion.toFixed(2) + " h",
                    eficienciaSinReductores: eficienciaSin.toFixed(2) + "%",
                    eficienciaConReductores: eficienciaCon.toFixed(2) + "%",
                    reductores: reductores,
                    planifSinReductores: planifSinReductores,
                    excesoDeficit: excesoDeficit
                });
            });

            // Promedio simple de operadores
            const promedioOperadores = diasContados > 0
                ? Math.round(sumaOperadores / diasContados)
                : 0;

            // Eficiencias ponderadas
            const eficienciaSinPonderadaRaw = totalRequeridos > 0
                ? (sumaEficienciaSinReductores / totalRequeridos)
                : "0%";
            const eficienciaSinPonderada = Math.min(eficienciaSinPonderadaRaw, 100).toFixed(2) + "%";

            const eficienciaConPonderadaRaw = totalRequeridos > 0
                ? (sumaEficienciaConReductores / totalRequeridos)
                : "0%";
            const eficienciaConPonderada = Math.min(eficienciaConPonderadaRaw, 100).toFixed(2) + "%";

            const reductoresPonderados = totalRequeridosConReductores - totalRequeridos;
            const planifSinReductoresPonderados = totalProgramacion - reductoresPonderados;
            const excesoDeficitPonderados = totalRequeridos - planifSinReductoresPonderados;

            // Fila final
            resumen.push({
                dia: "Ponderado",
                operadores: promedioOperadores,
                requeridos: totalRequeridos.toFixed(2) + " h",
                requeridosConReductores: totalRequeridosConReductores.toFixed(2) + " h",
                programacion: totalProgramacion.toFixed(2) + " h",
                eficienciaSinReductores: eficienciaSinPonderada,
                eficienciaConReductores: eficienciaConPonderada,
                reductores: reductoresPonderados,
                planifSinReductores: planifSinReductoresPonderados,
                excesoDeficit: excesoDeficitPonderados
            });
            // Fila de total mensual
            resumen.push({
                dia: "Mensual",
                operadores: "", // opcional
                requeridos: (totalRequeridos * semanasDelMes).toFixed(2) + " h",
                requeridosConReductores: (totalRequeridosConReductores * semanasDelMes).toFixed(2) + " h",
                programacion: (totalProgramacion * semanasDelMes).toFixed(2) + " h",
                eficienciaSinReductores: "",
                eficienciaConReductores: ""
            });

            return resumen;
        },
        resumenFTEsCalculado() {
            //return this.totalAgentesUnicos();
            const dataAgentes = this.totalAgentesUnicos();

            const resumenTabla = this.tablaResumenPorDia;

            const filaPonderada = resumenTabla.find(item => item.dia === 'Ponderado');

            let totalProgramacionHoras = 0;

            if (filaPonderada && filaPonderada.programacion) {
                const programacionStr = filaPonderada.programacion.replace(' h', '');
                totalProgramacionHoras = parseFloat(programacionStr);
            }

            const HORAS_X_FTE_SEMANAL = parseFloat(this.parametros.horas_x_fte_semanal);
            let fteCliente = 0;

            if (totalProgramacionHoras > 0) {
                fteCliente = totalProgramacionHoras / HORAS_X_FTE_SEMANAL;
            }

            return {
                detalle: dataAgentes.detalle,
                resumenTotal: {
                    agentes: dataAgentes.resumenTotal.agentes,
                    totalHoras: dataAgentes.resumenTotal.totalHoras,
                    fte: fteCliente.toFixed(2)
                }
            };
        },
        datosTablaHorizontal() {
            const resumen = this.resumenFTEsCalculado;
            const headers = resumen.detalle.map(item => item.jornada);
            const agentes = resumen.detalle.map(item => item.agentes);

            return {
                headersJornada: headers,
                valoresAgentes: agentes,
                resumenTotal: resumen.resumenTotal
            };
        },

        nombresEscenariosFiltrados() {
            if (!this.servicioId || !this.tipoEscenario || !this.escenarios.length) {
                return [];
            }

            // 1. Filtrar escenarios por servicio y tipo
            const escenariosFiltrados = this.escenarios.filter(e =>
                e.servicio_id === this.servicioId &&
                e.tipo === this.tipoEscenario
            );

            // 2. Extraer los nombres únicos (para evitar duplicados)
            const nombresUnicos = [...new Set(escenariosFiltrados.map(e => e.nombre))];

            return nombresUnicos;
        },
        todosSeleccionados: {
            get() {
                return this.itemsTablaResumen.length > 0 &&
                    this.itemsTablaResumen.every(item => item.selected);
            },
            set(value) {
                this.itemsTablaResumen.forEach(item => {
                    item.selected = value;
                });
            }
        },

        agentesSeleccionados() {
            return this.itemsTablaResumen.filter(item => item.selected);
        }
    },

    methods: {
        async cargarDatosParaEdicion() {
            try {
                this.mensajeLoader = 'Recuperando planeación guardada...';
                this.cargandoEdicion = true;

                //const data = datosEditadosSimulados;
                const response = await this.$axios.get('obtenerDatosParaEdicion', {
                    params: {
                        id_servicio: this.servicioEdicion,
                        nombre_programacion: this.nombreProgramaEdicion,
                        nombre_datos: 'ConfiguracionEdicion'
                    }
                });

                if (!response.data || !response.data.items) {
                    throw new Error("No se encontró la configuración de esta planeación");
                }

                const data = response.data.items;
                //console.log(data);


                this.servicioId = data.servicioId;
                await Promise.all([
                    this.cargarEscenarios(),
                    this.cargarVentanaServicio(),
                    this.cargarTurnos()
                ]);
                this.tipoEscenario = data.tipoEscenario;
                this.nombreEscenarioSeleccionado = data.nombreEscenarioSeleccionado;
                this.objetivoRQ = data.objetivoRQ;
                this.objetivoEficiencia = data.objetivoEficiencia;
                this.parametrosUtilizados = data.parametrosUtilizados;

                this.parametros.horas_x_fte_semanal = data.horas_x_fte_semanal;
                this.parametros.nivel = data.nivel_servicio;
                this.parametros.umbral = data.umbral_nds;

                this.planDiaModelo = data.planDiaModelo;
                this.matrizAsignacion = data.matrizAsignacion;

                this.nivelOptimizacion = data.nivelOptimizacion;
                this.programacionSemanal = data.programacionSemanal;
                this.detallesPorAgente = data.detallesPorAgente;

                this.items = data.itemsProgramaSemanal;
                this.headers = data.headersProgramaSemanal;
                this.resumenMaximos = data.resumenMaximos;
                this.generarDatosGraficasPorDiaPreeliminar();

                this.itemsConDescanso = data.itemsConDescanso;
                this.generarDatosGraficasPorDiaDescansos();

                this.programacionSemanalFinal = data.programacionSemanalFinal;
                this.descansosFinales = data.descansosFinales;
                this.descansosTransformados = data.descansosTransformados;
                this.columnasReceso = data.columnasReceso;
                this.generarDatosGraficasPorDiaRecesos();

                this.itemsTablaResumen = data.itemsTablaResumen;
                this.diasUnicosResumen = data.diasUnicosResumen;
                this.generarDatosGraficasPorDiaFinal();

                this.$toast.success('Edición cargada: Programa semanal listo.');
            } catch (error) {
                console.error("Error al cargar la edición:", error);
                if (error.response && error.response.status === 404) {
                    // Este es el caso específico que pediste
                    this.$toast.warning('Este servicio no tiene datos de programación guardada con ese nombre.');
                } else if (error.response && error.response.status === 500) {
                    this.$toast.error('Error interno del servidor al recuperar los datos.');
                } else {
                    this.$toast.error('Error de conexión o datos corruptos.');
                }
            } finally {
                // 6. Apagamos el loader pase lo que pase
                this.cargandoEdicion = false;
            }

        },
        obtenerTotalMatrizVolumen(dia) {
            if (!this.matrizPorCampo.volumen || this.matrizPorCampo.volumen.length === 0) return 0;

            let total = 0;

            this.matrizPorCampo.volumen.forEach(fila => {
                const valor = parseFloat(fila[dia]);
                if (!isNaN(valor)) {
                    total += valor;
                }
            });

            return total;
        },
        obtenerTotalAgentes(matriz, dia) {
            if (!matriz || matriz.length === 0) return 0;

            let total = 0;
            matriz.forEach(fila => {
                if (fila.intervalo && fila.intervalo.includes('Total')) return;

                const valor = parseFloat(fila[dia]);
                if (!isNaN(valor)) {
                    total += valor;
                }
            });

            // Retornamos el total redondeado hacia arriba para coincidir con el formato de la tabla
            return Math.ceil(total/2) ;
        },
        generarResumenDia(fuenteDatos) {
            if (!fuenteDatos || Object.keys(fuenteDatos).length === 0) return {};

            const resumen = {
                porDia: {},
                global: { max: 0, min: Infinity }
            };

            const todosLosValores = [];

            this.dias.forEach((dia) => {
                // fuenteDatos[dia] contendrá 'requeridos' o 'asignados' según pases el parámetro
                const valores = fuenteDatos[dia] || [];
                const nums = valores.map(v => parseFloat(v)).filter(v => !isNaN(v));

                if (nums.length > 0) {
                    const pico = Math.max(...nums);
                    const minimo = Math.min(...nums);

                    resumen.porDia[dia] = {
                        pico,
                        minimo,
                        promedio: nums.reduce((a, b) => a + b, 0) / nums.length
                    };
                    todosLosValores.push(...nums);
                }
            });

            if (todosLosValores.length > 0) {
                resumen.global.max = Math.max(...todosLosValores);
                resumen.global.min = Math.min(...todosLosValores);
            }
            return resumen;
        },
        ordenarPorColumna(campo, tipo = null) {
            let key;

            // Si tipo es null, asumimos que estamos ordenando por la columna 'agente'
            if (tipo === null) {
                key = campo; // 'agente'
            } else {
                key = `${campo.toLowerCase()}_${tipo}`;
            }

            // Lógica de Toggle (Ascendente / Descendente)
            if (this.ordenActual.key === key) {
                this.ordenActual.dir = this.ordenActual.dir === 'asc' ? 'desc' : 'asc';
            } else {
                this.ordenActual.key = key;
                this.ordenActual.dir = 'asc';
            }

            const direccion = this.ordenActual.dir === 'asc' ? 1 : -1;

            this.itemsTablaResumen.sort((a, b) => {
                let valorA = a[key] ? String(a[key]) : '';
                let valorB = b[key] ? String(b[key]) : '';

                // Si es la columna agente, orden alfabético puro
                if (key === 'agente') {
                    return valorA.localeCompare(valorB) * direccion;
                }

                // Lógica para horarios y recesos (mandar especiales al final)
                const esEspecial = (v) => v === 'DS' || v === '—' || v === '';
                if (esEspecial(valorA) && !esEspecial(valorB)) return 1;
                if (!esEspecial(valorA) && esEspecial(valorB)) return -1;

                return valorA.localeCompare(valorB, undefined, { numeric: true, sensitivity: 'base' }) * direccion;
            });
        },
        getColorEficiencia(valorStr) {
            if (valorStr === "-" || valorStr === null || valorStr === undefined) return '';

            const valor = parseFloat(valorStr);
            // Convertimos el objetivo de eficiencia (ej. 95 a 0.95)
            const h7 = parseFloat(this.objetivoEficiencia) / 100;

            if (!h7 || h7 === 0) return '';

            // Convertimos el valor de la celda a decimal para comparar (ej. 92 a 0.92)
            const factorV = valor / 100;

            // --- Aplicación de Reglas (De mayor a menor para no pisar condiciones) ---

            // 1. VERDE: >= (1 * h7)
            if (factorV >= (1 * h7)) {
                return 'excel-verde';
            }
            // 2. AMARILLO: >= (0.95 * h7)
            else if (factorV >= (0.95 * h7)) {
                return 'excel-amarillo';
            }
            // 3. ROJO: >= (0.9 * h7)
            else if (factorV >= (0.9 * h7)) {
                return 'excel-rojo';
            }
            // 4. GRIS: < (0.9 * h7)
            else {
                return 'excel-gris';
            }                   // Crítico/Bajo
        },
        getHeatMapColor2(valor) {
            if (valor === "-" || isNaN(valor) || valor === null) return 'transparent';

            const n = parseFloat(valor);

            // Códigos exactos que me pasaste
            const colorMin = { r: 255, g: 140, b: 117 }; // #FF8C75 (Rojo/Naranja)
            const colorMed = { r: 255, g: 230, b: 153 }; // #FFE699 (Amarillo)
            const colorMax = { r: 160, g: 224, b: 192 }; // #A0E0C0 (Verde Azulado)


            const valMin = -2;  // Valor para el Rojo total
            const valMed = 7;   // Valor para el Amarillo total
            const valMax = 18;  // Valor para el Verde total

            let r, g, b;

            if (n <= valMin) return `rgb(${colorMin.r}, ${colorMin.g}, ${colorMin.b})`;
            if (n >= valMax) return `rgb(${colorMax.r}, ${colorMax.g}, ${colorMax.b})`;

            if (n < valMed) {
                // Interpolación de Rojo a Amarillo
                const p = (n - valMin) / (valMed - valMin);
                r = Math.floor(colorMin.r + p * (colorMed.r - colorMin.r));
                g = Math.floor(colorMin.g + p * (colorMed.g - colorMin.g));
                b = Math.floor(colorMin.b + p * (colorMed.b - colorMin.b));
            } else {
                // Interpolación de Amarillo a Verde
                const p = (n - valMed) / (valMax - valMed);
                r = Math.floor(colorMed.r + p * (colorMax.r - colorMed.r));
                g = Math.floor(colorMed.g + p * (colorMax.g - colorMed.g));
                b = Math.floor(colorMed.b + p * (colorMax.b - colorMed.b));
            }

            return `rgb(${r}, ${g}, ${b})`;
        },
        getHeatMapColor3(valor) {
            if (valor === "-" || isNaN(valor) || valor === null) return 'transparent';

            const n = parseFloat(valor);
            const n3 = parseFloat(this.objetivoRQ) / 100; // 95 / 100 = 0.95

            if (!n3 || n3 === 0) return 'transparent';

            const factorFila = (n + 100) / 100;

            // 1. ROJO: >= (1.1 * N3)
            if (factorFila >= (1.1 * n3)) {
                return 'excel-rojo';
            }
            // 2. VERDE: >= (1 * N3)
            else if (factorFila >= (1 * n3)) {
                return 'excel-verde';
            }
            // 3. AMARILLO: >= (0.95 * n3)
            else if (factorFila >= (0.95 * n3)) {
                return 'excel-amarillo';
            }
            // 4. GRIS: < (0.95 * n3) 
            else {
                return 'excel-gris';
            }
        },
        getHeatMapColor(valor, dia, intervaloIdx) {
            if (valor === "-" || isNaN(valor) || valor === null) return 'transparent';

            // 1. Obtenemos los valores de las otras tablas para ese mismo punto (día e índice)
            const asignados = this.graficasPorDiaFinal[dia]?.asignados[intervaloIdx] || 0;
            const programados = this.graficasPorDiaFinal[dia]?.programados[intervaloIdx] || 0;
            const n3 = parseFloat(this.objetivoRQ) / 100;

            if (programados === 0) return 'excel-gris';

            // 2. La fórmula del cliente: Porcentaje de cumplimiento
            const factorCumplimiento = asignados / programados;

            // 3. Aplicamos los umbrales del Objetivo RQ
            // ROJO: >= 110%
            if (factorCumplimiento >= 1.10 * n3) {
                return 'excel-rojo';
            }
            // VERDE: >= 100%
            else if (factorCumplimiento >= 1.00 * n3) {
                return 'excel-verde';
            }
            // AMARILLO: >= 95%
            else if (factorCumplimiento >= 0.95 * n3) {
                return 'excel-amarillo';
            }
            // GRIS: < 95%
            else {
                return 'excel-gris';
            }
        },
        getPicoEstacionesColor(valor, dia, resumenData) {
            if (valor === "-" || isNaN(valor) || valor === null || dia === 'intervalo') return 'transparent';

            const valorNumerico = parseFloat(valor);

            // CAMBIO AQUÍ: Accedemos a .porDia
            const resumenGlobal = resumenData;
            if (!resumenGlobal || !resumenGlobal.porDia || !resumenGlobal.porDia[dia]) {
                return 'transparent';
            }

            const { pico, promedio } = resumenGlobal.porDia[dia];

            // Regla 1: ROJO (Pico máximo)
            // Usamos un pequeño margen para evitar errores de decimales en JS
            if (Math.abs(valorNumerico - pico) < 0.01) {
                return 'excel-rojo';
            }

            // Regla 2: AMARILLO (>= Promedio)
            if (valorNumerico >= promedio) {
                return 'excel-amarillo';
            }

            // Regla 3: VERDE (< Promedio)
            return 'excel-verde';
        },
        getMapaCalorColor(valor, dia, modo, resumenData) {
            if (valor === "-" || isNaN(valor) || valor === null || dia === 'intervalo') return {};

            const val = parseFloat(valor);
            const resumen = resumenData;
            if (!resumen || !resumen.porDia[dia]) return {};

            let min, max;

            if (modo === 'semanal') {
                // Usa el rango de TODA la tabla
                min = resumen.global.min;
                max = resumen.global.max;
            } else {
                // Modo 'diario': Usa el rango de la columna actual
                min = resumen.porDia[dia].minimo;
                max = resumen.porDia[dia].pico;
            }

            if (max === min) return { backgroundColor: 'rgb(255, 255, 132)' };

            const percent = (val - min) / (max - min);
            return this.calcularInterpolacionRGB(percent);
        },

        // Función auxiliar para no repetir código de colores
        calcularInterpolacionRGB(percent) {
            let r, g, b;
            if (percent < 0.5) {
                const localP = percent * 2;
                r = Math.floor(107 + (255 - 107) * localP);
                g = Math.floor(174 + (255 - 174) * localP);
                b = Math.floor(111 + (132 - 111) * localP);
            } else {
                const localP = (percent - 0.5) * 2;
                r = Math.floor(255 + (248 - 255) * localP);
                g = Math.floor(255 + (105 - 255) * localP);
                b = Math.floor(132 + (107 - 132) * localP);
            }
            return { backgroundColor: `rgb(${r}, ${g}, ${b})`, color: 'black' };
        },
        totalAgentesUnicos() {
            const listaAgentes = this.itemsTablaResumen || [];
            //console.log(listaAgentes);
            const servicio = this.servicios.find(s => s.id === this.servicioId);
            const diasSemana = ["lunes", "martes", "miércoles", "jueves", "viernes", "sábado", "domingo"];
            const HORAS_X_FTE_SEMANAL = 48;

            let parametrosDescansos = servicio?.auxiliares || [];
            if (typeof servicio?.auxiliares === 'string') {
                try {
                    parametrosDescansos = JSON.parse(servicio.auxiliares);
                } catch (e) {
                    parametrosDescansos = [];
                }
            }
            if (!Array.isArray(parametrosDescansos)) parametrosDescansos = [];

            const resumenFTE = {};
            let agentesUnicosTotales = 0;

            listaAgentes.forEach(agente => {
                const duracionesBrutas = {};
                const duracionesNetas = {};
                let diasTrabajados = 0;

                diasSemana.forEach(dia => {
                    const horario = agente[`${dia}_horario`];

                    if (horario && horario !== 'DS' && horario !== '—') {
                        diasTrabajados++;

                        const jornadaBrutaDiaria = this.calcularDuracionJornada(horario);
                        const jornadaNetaDiaria = this.calcularJornadaNeta(horario, parametrosDescansos);

                        if (jornadaBrutaDiaria > 0) {
                            const jornadaBrutaKey = jornadaBrutaDiaria.toFixed(2);
                            duracionesBrutas[jornadaBrutaKey] = (duracionesBrutas[jornadaBrutaKey] || 0) + 1;
                        }
                        if (jornadaNetaDiaria > 0) {
                            const jornadaNetaKey = jornadaNetaDiaria.toFixed(2);
                            duracionesNetas[jornadaNetaKey] = (duracionesNetas[jornadaNetaKey] || 0) + 1;
                        }
                    }
                });

                let jornadaEstándarBrutaH = 0;
                let jornadaEstándarNetaH = 0;
                let maxFrecuencia = 0;

                Object.keys(duracionesNetas).forEach(duracionStr => {
                    const frecuencia = duracionesNetas[duracionStr];
                    if (frecuencia > maxFrecuencia) {
                        maxFrecuencia = frecuencia;
                        jornadaEstándarNetaH = parseFloat(duracionStr);
                    }
                });

                jornadaEstándarBrutaH = jornadaEstándarNetaH + (jornadaEstándarNetaH > 0 ? 0.25 : 0);

                if (jornadaEstándarBrutaH > 0 && jornadaEstándarNetaH > 0) {
                    const claveJornada = jornadaEstándarNetaH.toFixed(2) + " h";

                    const horasSemanalesEquiv = jornadaEstándarBrutaH * diasTrabajados;

                    const fteAgente = horasSemanalesEquiv / HORAS_X_FTE_SEMANAL;

                    if (!resumenFTE[claveJornada]) {
                        resumenFTE[claveJornada] = { agentes: 0, totalHoras: 0, totalFTE: 0 };
                    }

                    resumenFTE[claveJornada].agentes += 1;
                    resumenFTE[claveJornada].totalHoras += horasSemanalesEquiv;
                    resumenFTE[claveJornada].totalFTE += fteAgente;
                    agentesUnicosTotales++;
                }
            });

            const resultadoFinal = Object.keys(resumenFTE).map(key => {
                const data = resumenFTE[key];
                return {
                    jornada: key,
                    agentes: data.agentes,
                    totalHoras: data.totalHoras.toFixed(2),
                    fte: data.totalFTE.toFixed(2)
                };
            }).sort((a, b) => parseFloat(a.jornada) - parseFloat(b.jornada));

            //console.log("✅ Total de Agentes Únicos en la Programación:", agentesUnicosTotales);
            //console.table(resultadoFinal);

            const totalFTEs = resultadoFinal.reduce((sum, item) => sum + parseFloat(item.fte), 0);
            const totalHoras = resultadoFinal.reduce((sum, item) => sum + parseFloat(item.totalHoras), 0);

            return {
                detalle: resultadoFinal,
                resumenTotal: {
                    agentes: agentesUnicosTotales,
                    totalHoras: totalHoras.toFixed(2),
                    fte: totalFTEs.toFixed(2)
                }
            };
        },
        tiempoStringAHoraDecimal(tiempoStr) {
            if (!tiempoStr) return 0;
            const [h, m, s] = tiempoStr.split(':').map(Number);
            return h + (m / 60) + (s / 3600);
        },
        calcularDuracionJornada(horarioStr) {
            if (!horarioStr || horarioStr === 'DS' || horarioStr === '—') {
                return 0;
            }

            try {
                const [inicioStr, finStr] = horarioStr.split('–');

                const tiempoAMinutos = (tiempoStr) => {
                    const [horas, minutos] = tiempoStr.split(':').map(Number);
                    return (horas * 60) + minutos;
                };

                const minutosInicio = tiempoAMinutos(inicioStr);
                let minutosFin = tiempoAMinutos(finStr);

                if (minutosFin < minutosInicio) {
                    minutosFin += (24 * 60);
                }

                const duracionMinutos = minutosFin - minutosInicio;

                return duracionMinutos / 60;

            } catch (e) {
                return 0;
            }
        },
        calcularJornadaNeta(horarioStr, parametrosServicio) {
            if (!horarioStr || horarioStr === 'DS') {
                return 0;
            }

            let jornadaBrutaH = this.calcularDuracionJornada(horarioStr);
            let jornadaNetaH = jornadaBrutaH;

            const recesosAplicables = this.obtenerRecesos(jornadaBrutaH, parametrosServicio);

            recesosAplicables.forEach(premisa => {
                const reduccionH = this.tiempoStringAHoraDecimal(premisa.duracion);
                jornadaNetaH -= reduccionH;
            });

            return Math.max(0, jornadaNetaH);
        },
        confirmarEliminacionMasiva() {
            if (this.agentesSeleccionados === 0) return;

            this.dialogEliminarMasivo = {
                visible: true,
                nombre: `${this.agentesSeleccionados.length} agente(s)`,
            };
        },
        eliminarMultiplesAgentes() {
            this.dialogEliminarMasivo.visible = false;
            this.isSaving = true;

            this.itemsTablaResumen = this.itemsTablaResumen.filter(item => !item.selected);
            //console.log(this.itemsTablaResumen);

            this.renombrarAgentes();
            this.recordHistory();
            this.generarDatosGraficasPorDiaFinal();

            this.isSaving = false;
        },
        confirmarEliminacionIndividual(index) {
            const agenteAeliminar = this.itemsTablaResumen[index];

            this.dialogEliminarIndividual = {
                visible: true,
                nombreAgente: agenteAeliminar.agente,
                indice: index,
            };
        },
        handleKeydown(event) {
            const isCtrlKey = event.ctrlKey || event.metaKey;

            if (isCtrlKey) {
                const focusedElement = document.activeElement;

                const isEditable = focusedElement && (
                    focusedElement.tagName === 'INPUT' ||
                    focusedElement.tagName === 'TEXTAREA' ||
                    focusedElement.getAttribute('contenteditable') === 'true'
                );

                if (isEditable && (event.keyCode === 67 || event.keyCode === 86 || event.keyCode === 88)) {
                    return;
                }

                if (event.key === 'z' || event.key === 'Z') {
                    event.preventDefault();
                    this.undo();
                } else if (event.key === 'y' || event.key === 'Y') {
                    event.preventDefault();
                    this.redo();
                }
            }
        },
        iniciarEdicionEnCelda(item, dia, tipo) {
            this.celdaActiva = null;

            this.celdaActiva = item.agente + '-' + dia + '-' + tipo;

            const campo = dia.toLowerCase() + '_' + tipo;
            this.valorEditado = item[campo];

            this.valorOriginal = item[campo];

            this.agenteTemporal = item;
            this.diaTemporal = dia;
            this.tipoTemporal = tipo;
        },
        cancelarEdicion() {
            if (this.celdaActiva && this.valorOriginal !== null) {

                this.valorEditado = this.valorOriginal;

                this.celdaActiva = null;

                this.valorOriginal = null;
            }
        },
        manejarFinEdicionEnCelda1(item, dia, tipo) {

            console.log(this.valorEditado);
            console.log(this.valorOriginal);
            if (this.celdaActiva !== item.agente + '-' + dia + '-' + tipo) {
                return;
            }

            const nuevoValor = this.valorEditado;
            const campo = dia.toLowerCase() + '_' + tipo;
            const valorParaValidar = (nuevoValor || '').trim();

            let isValid = true;

            if (tipo === 'horario') {
                isValid = this.validarHorarioReceso(valorParaValidar) === true;
            } else {
                const regexReceso = /^(2[0-3]|[0-1]?\d):[0-5]\d–(2[0-3]|[0-1]?\d):[0-5]\d$|^—$|^DS$/i;
                isValid = regexReceso.test(valorParaValidar);
            }

            if (!isValid) {
                return;
            }

            this.$set(item, campo, valorParaValidar);

            this.celdaActiva = null;

            if (tipo === 'horario') {
                if (valorParaValidar.toUpperCase() === 'DS') {
                    const diaBase = dia.toLowerCase();

                    const tiposReceso = ['receso60', 'receso30', 'receso15'];
                    tiposReceso.forEach(recesoTipo => {
                        const claveReceso = diaBase + '_' + recesoTipo;
                        this.$set(item, claveReceso, 'DS');
                    });
                    this.recordHistory();
                    return;
                }
                this.diasUnicos.forEach(d => {
                    const claveDia = d.toLowerCase() + '_horario';
                    this.$set(item, claveDia, valorParaValidar);
                });

                this.ejecutarPipelineAsignacion();
                this.recordHistory();

                // Si usas tableKey, agrégalo aquí
                // this.$nextTick(() => { this.tableKey += 1; }); 

            } else {
                this.valorTemporal = valorParaValidar;
                this.guardarValor(item, dia, tipo);
            }
        },
        manejarFinEdicionEnCelda(item, dia, tipo) {
            if (this.celdaActiva !== item.agente + '-' + dia + '-' + tipo) return;

            const nuevoValor = (this.valorEditado || '').trim();
            const valorAnterior = this.valorOriginal;
            const campo = dia.toLowerCase() + '_' + tipo;

            let isValid = (tipo === 'horario')
                ? this.validarHorarioReceso(nuevoValor) === true
                : /^(2[0-3]|[0-1]?\d):[0-5]\d–(2[0-3]|[0-1]?\d):[0-5]\d$|^—$|^DS$/i.test(nuevoValor);
            if (!isValid) return;

            this.$set(item, campo, nuevoValor);
            this.celdaActiva = null;

            if (tipo === 'horario') {
                const esDS = nuevoValor.toUpperCase() === 'DS';
                const antesEraDS = valorAnterior && valorAnterior.toUpperCase() === 'DS';

                if (esDS) {
                    const tiposReceso = ['receso60', 'receso30', 'receso15'];
                    tiposReceso.forEach(r => this.$set(item, dia.toLowerCase() + '_' + r, 'DS'));

                    this.diasUnicos.forEach(d => {
                        const nombreDia = d.toLowerCase();
                        const campoHorario = nombreDia + '_horario';

                        if (nombreDia !== dia.toLowerCase() && item[campoHorario] === 'DS') {

                            const horariosSemana = this.diasUnicos
                                .map(diaBusqueda => item[diaBusqueda.toLowerCase() + '_horario'])
                                .filter(h => h && h !== 'DS' && h !== '—');

                            const horarioParaRestaurar = horariosSemana.length > 0 ? horariosSemana[0] : '07:00–13:00';

                            this.$set(item, campoHorario, horarioParaRestaurar);


                            tiposReceso.forEach(r => this.$set(item, nombreDia + '_' + r, '—'));
                        }
                    });

                    this.ejecutarPipelineAsignacion(true);
                }
                else if (antesEraDS && !esDS) {
                    const horariosDeOtrosDias = this.diasUnicos
                        .filter(d => d.toLowerCase() !== dia.toLowerCase())
                        .map(d => item[d.toLowerCase() + '_horario'])
                        .filter(h => h && h.toUpperCase() !== 'DS' && h !== '—');

                    const horarioBase = horariosDeOtrosDias.length > 0 ? horariosDeOtrosDias[0] : null;


                    const tiposReceso = ['receso60', 'receso30', 'receso15'];
                    tiposReceso.forEach(r => this.$set(item, dia.toLowerCase() + '_' + r, '—'));

                    if (nuevoValor === horarioBase) {
                        this.agenteTemporal = item;
                        this.diaTemporal = dia;
                        this.mostrarModalCambioDescanso = true;

                    }
                    else {
                        this.diasUnicos.forEach(d => {
                            const claveDia = d.toLowerCase() + '_horario';

                            if (item[claveDia] !== 'DS') {
                                this.$set(item, claveDia, nuevoValor);
                            }
                        });

                        this.ejecutarPipelineAsignacion(true);
                    }

                }
                else {
                    this.ejecutarPipelineAsignacion(true);
                }
                this.recordHistory();
            } else {
                this.valorTemporal = nuevoValor;
                this.guardarValor(item, dia, tipo);
                this.generarResumen();
            }
        },
        confirmarCambioDescanso() {
            if (!this.nuevoDiaDescanso) return;

            const diaNuevo = this.nuevoDiaDescanso.toLowerCase();
            const agente = this.agenteTemporal;

            this.$set(agente, `${diaNuevo}_horario`, 'DS');

            const tiposReceso = ['receso60', 'receso30', 'receso15'];
            tiposReceso.forEach(r => {
                this.$set(agente, `${diaNuevo}_${r}`, 'DS');
            });


            this.mostrarModalCambioDescanso = false;
            this.ejecutarPipelineAsignacion(true);

            this.nuevoDiaDescanso = null;
        },

        guardarValor(item, dia, tipo) {
            this.diasSeleccionados = [];
            this.dialogAplicarSemana = true;


        },
        aplicarValorADias() {
            const campo = this.tipoTemporal;
            const valor = this.valorTemporal;
            const agente = this.agenteTemporal;

            this.diasSeleccionados.forEach(d => {
                agente[d.toLowerCase() + '_' + campo] = valor;
            });

            this.dialogAplicarSemana = false;
            if (campo !== 'horario') {
                this.actualizarGraficas();
            }
            this.recordHistory();
        },

        cancelarAplicacion() {
            this.dialogAplicarSemana = false;
            this.actualizarGraficas();
        },
        iniciarArrastre(index, dia, campo, valor) {
            this.arrastrando = true;
            this.valorArrastrado = valor;
            this.indiceOrigen = index;
            this.diaOrigen = dia;
            this.campoOrigen = campo;
            document.body.style.cursor = 'copy';

            window.addEventListener("mouseup", this.detenerArrastre);
        },
        manejarMouseOver(index, dia, campo) {

            if (this.arrastrando && campo === this.campoOrigen) {
                const key = dia.toLowerCase() + '_' + campo;
                this.$set(this.itemsTablaResumen[index], key, this.valorArrastrado);
            }
        },
        detenerArrastre() {
            this.arrastrando = false;
            document.body.style.cursor = 'default';
            window.removeEventListener("mouseup", this.detenerArrastre);
            this.actualizarGraficas();
        },
        validarHorarioReceso(value) {
            const regexHorarioReceso = /^(2[0-3]|[0-1]?\d):[0-5]\d–(2[0-3]|[0-1]?\d):[0-5]\d$|^DS$/;
            if (regexHorarioReceso.test(value)) {
                return true;
            }
            return 'El formato debe ser HH:mm–HH:mm o "DS".';
        },
        formatearGuionEnInput() {
            const valor = this.valorEditado || '';

            if (valor.trim() === '-') {
                this.valorEditado = '—';
                return;
            }

            let corregido = valor.replace(/-/g, '–');

            const esPosibleRango = /\d{1,2}:\d{2}–\d{1,2}:\d{2}/.test(corregido);

            if (corregido.includes('—') && esPosibleRango) {
                corregido = corregido.replace(/—/g, '–');
            }

            if (valor !== corregido) {
                this.valorEditado = corregido;
            }
        },
        ///////////////////////////////////////////////////////////////////////////////////
        async cargarServicios() {
            try {
                const usuarioId = this.$store.state.id;
                const res = await this.$axios.get(`list-services?usuario=${usuarioId}`);
                this.servicios = res.data;
            } catch (err) {
                console.error('Error al cargar servicios:', err);
                this.$toast.error('No se pudieron cargar los servicios');
            }

        },
        actualizarGraficas() {
            if (this.actualizando) return;
            this.actualizando = true;

            setTimeout(() => {
                this.generarDatosGraficasPorDiaFinal();
                this.actualizando = false;
            }, 300);
        },


        borrarDiaCompleto(dia) {
            this.guardarDailyBackup(dia);
            const diaKey = dia.toLowerCase();
            this.itemsTablaResumen.forEach(item => {
                item[`${diaKey}_horario`] = "";
                this.tiposReceso.forEach(tipo => {
                    const campoKey = `${diaKey}_${tipo}`;
                    this.$set(item, campoKey, "");
                });
            });
            this.generarDatosGraficasPorDiaFinal();
        },
        borrarHorariosDelDia(dia) {
            this.guardarDailyBackup(dia);
            const diaKey = dia.toLowerCase();
            this.itemsTablaResumen.forEach(item => {
                this.$set(item, `${diaKey}_horario`, "");
            });
            this.generarDatosGraficasPorDiaFinal();
        },
        borrarRecesosDelDia(dia) {
            this.guardarDailyBackup(dia);
            const diaKey = dia.toLowerCase();
            this.itemsTablaResumen.forEach(item => {
                this.tiposReceso.forEach(tipo => {
                    const campoKey = `${diaKey}_${tipo}`;
                    this.$set(item, campoKey, "");
                });
            });
            this.generarDatosGraficasPorDiaFinal();
        },
        guardarDailyBackup(dia) {
            const diaKey = dia.toLowerCase();

            const clavesAGuardar = [`${diaKey}_horario`, ...this.tiposReceso.map(t => `${diaKey}_${t}`)];

            const backupData = this.itemsTablaResumen.map(item => {
                const itemBackup = {
                    agente: item.agente,
                };
                clavesAGuardar.forEach(clave => {
                    itemBackup[clave] = item[clave];
                });
                return itemBackup;
            });


            this.$set(this.dailyBackup, diaKey, backupData);
        },
        restaurarDia(dia) {
            const diaKey = dia.toLowerCase();
            const backup = this.dailyBackup[diaKey];

            if (!backup) {
                this.$toast.warning(`No hay datos previos para restaurar en ${dia}.`);
                return;
            }

            const clavesARestaurar = [`${diaKey}_horario`, ...this.tiposReceso.map(t => `${diaKey}_${t}`)];

            this.itemsTablaResumen.forEach(item => {
                const backupItem = backup.find(b => b.agente === item.agente);

                if (backupItem) {
                    clavesARestaurar.forEach(clave => {
                        this.$set(item, clave, backupItem[clave] || '');
                    });
                }
            });

            this.$delete(this.dailyBackup, diaKey);

            this.generarDatosGraficasPorDiaFinal();
            this.$toast.success(`Datos de ${dia} restaurados.`);
        },
        recordHistory() {
            this.redoStack = [];

            const currentState = JSON.parse(JSON.stringify(this.itemsTablaResumen));

            this.historyStack.push(currentState);
            //console.log(this.historyStack);

            if (this.historyStack.length > this.maxHistory) {
                this.historyStack.shift();
            }
        },
        undo() {
            if (this.historyStack.length <= 1) return;

            const currentState = this.historyStack.pop();
            this.redoStack.push(currentState);

            const previousState = this.historyStack[this.historyStack.length - 1];
            this.itemsTablaResumen = JSON.parse(JSON.stringify(previousState));

            this.generarDatosGraficasPorDiaFinal();

        },
        redo() {
            if (this.redoStack.length === 0) return;

            const nextState = this.redoStack.pop();
            this.historyStack.push(nextState);

            this.itemsTablaResumen = JSON.parse(JSON.stringify(nextState));

            this.generarDatosGraficasPorDiaFinal();

        },

        agregarAgente() {
            this.turnoSeleccionado = null;
            this.mostrarModalTurnos = true;
        },
        confirmarAsignacion() {
            if (!this.turnoSeleccionado) return;

            this.mostrarModalTurnos = false;

            const turno = this.turnoSeleccionado;

            const horarioDefecto = `${turno.intervalo_inicio.substring(0, 5)}–${turno.intervalo_fin.substring(0, 5)}`;

            const nuevoAgente = {
                agente: `Agente ${this.itemsTablaResumen.length + 1}`
            };
            const sufijosReceso = ['receso60', 'receso30', 'receso15'];

            this.diasUnicos.forEach(dia => {
                const key = dia.toLowerCase();

                nuevoAgente[`${key}_horario`] = horarioDefecto;

                sufijosReceso.forEach(sufijo => {
                    nuevoAgente[`${key}_${sufijo}`] = "—";
                });
            });

            this.itemsTablaResumen.push(nuevoAgente);
            //console.log(this.itemsTablaResumen);

            this.ejecutarPipelineAsignacion();

            this.$nextTick(() => {
                this.hacerScrollVerticalAlFinal();
            });
        },
        async ejecutarPipelineAsignacion1() {
            //console.log(this.itemsTablaResumen);
            const programacionActual = this.convertirItemsARawProgramacion(this.itemsTablaResumen);
            const ordenado = this.ordenarProgramacionPorTurno(programacionActual);
            //console.log(ordenado);


            await this.generarProgramacionConDescansos(ordenado, true);
            console.log(this.programacionSemanalFinal);

            this.asignarHorarioDeRecesoPorDemanda3(this.programacionSemanalFinal);
            this.$nextTick(() => {
                this.generarResumen();
            });
            /*this.$nextTick(() => {
                console.log("entre al nextTick");
                this.asignarHorarioDeRecesoPorDemanda3(this.programacionSemanalFinal)
                this.$nextTick(() => {
                    this.generarResumen();
                });
            });*/
        },
        async ejecutarPipelineAsignacion(esEdicionManual = false) {
            const programacionActual = this.convertirItemsARawProgramacion(this.itemsTablaResumen);
            const ordenado = this.ordenarProgramacionPorTurno(programacionActual);

            // Le pasamos el flag de edición manual
            await this.generarProgramacionConDescansos(ordenado, esEdicionManual);

            this.asignarHorarioDeRecesoPorDemanda3(this.programacionSemanalFinal);

            this.$nextTick(() => {
                this.generarResumen();
            });
        },
        aplicarResultadosProgramacion() {

            const agentesMap = new Map(this.itemsTablaResumen.map(item => [item.agente, item]));

            Object.entries(this.programacionConDescansos).forEach(([nombreAgente, semana]) => {
                if (agentesMap.has(nombreAgente)) {
                    const agenteItem = agentesMap.get(nombreAgente);
                    Object.entries(semana).forEach(([dia, horario]) => {
                        const key = dia.toLowerCase();

                        agenteItem[`${key}_horario`] = horario;

                        agenteItem[`${key}_receso60`] = "";
                        agenteItem[`${key}_receso30`] = "";
                        agenteItem[`${key}_receso15`] = "";
                    });
                }
            });


            this.detalleRealFinal.forEach(detalle => {
                const nombreAgente = detalle.nombre;
                const dia = detalle.dia;

                if (agentesMap.has(nombreAgente)) {
                    const agenteItem = agentesMap.get(nombreAgente);
                    const key = dia.toLowerCase();

                    detalle.recesos.forEach(receso => {
                        let sufijo = '';
                        if (receso.tipo.includes('60')) sufijo = 'receso60';
                        else if (receso.tipo.includes('30')) sufijo = 'receso30';
                        else if (receso.tipo.includes('15')) sufijo = 'receso15';

                        if (sufijo) {
                            agenteItem[`${key}_${sufijo}`] = receso.duracion;
                        }
                    });
                }
            });

            this.itemsTablaResumen = Array.from(agentesMap.values());
        },
        convertirItemsARawProgramacion(items) {
            const programacion = {};
            const diasCompletos = this.diasUnicos;

            items.forEach(item => {
                const agenteNombre = item.agente;
                programacion[agenteNombre] = {};

                diasCompletos.forEach(dia => {
                    const key = dia.toLowerCase();
                    const horarioKey = `${key}_horario`;

                    let horarioValor = item[horarioKey];

                    if (horarioValor && horarioValor !== "DS" && horarioValor !== "—") {
                        horarioValor = horarioValor.replace(/[–—]/g, '-');

                        horarioValor = horarioValor.split('-').map(t => t.length === 5 ? `${t}:00` : t).join('-');
                    }

                    programacion[agenteNombre][dia] = horarioValor || "—";
                });
            });

            return programacion;
        },
        hacerScrollVerticalAlFinal() {
            const container = this.$refs.tablaResumenContainer;

            if (container) {
                container.scrollTo({
                    top: container.scrollHeight,
                    behavior: 'smooth'
                });
            }
        },
        hacerScrollAlFinal() {
            const container = this.$refs.tablaResumenContainer;

            if (container) {
                container.scrollTo({
                    top: container.scrollWidth,
                    behavior: 'smooth'
                });
                const cardTextContainer = this.$refs.cardTextContainer || container.closest('.v-card__text');
                if (cardTextContainer) {
                    cardTextContainer.scrollTop = cardTextContainer.scrollHeight;
                }
            }
        },
        ejecutarEliminacionIndividual() {
            if (this.dialogEliminarIndividual.indice === -1) return;
            this.itemsTablaResumen.splice(this.dialogEliminarIndividual.indice, 1);

            this.renombrarAgentes();
            this.recordHistory();
            this.generarDatosGraficasPorDiaFinal();

            this.dialogEliminarIndividual.visible = false;
            this.dialogEliminarIndividual.indice = -1;
        },
        renombrarAgentes() {
            this.itemsTablaResumen.forEach((item, index) => {
                item.agente = `agente${String(index + 1).padStart(2, '0')}`;
            });
        },

        async cargarEscenarios() {
            const res = await this.$axios.get(`escenarios/${this.servicioId}`);
            this.escenarios = res.data;
        },
        async cargarVentanaServicio() {
            const res = await this.$axios.get(`ventana-servicio/${this.servicioId}`);
            this.ventanas = res.data;
            this.diasDisponibles = res.data.map(v => v.dia_semana);
        },
        async cargarTurnos() {
            const res = await this.$axios.get(`turnos-servicio/${this.servicioId}`);
            this.turnosServicio = res.data;

            //console.log(this.turnosServicio);
        },
        manejarGuardado() {
            if (this.esEdicionModo) {
                this.confirmarGuardarEntregables(true);
            } else {
                this.dialogNombreProgramacion = true;
            }
        },

        async confirmarGuardarEntregables(esActualizacion = false) {
            const nombre = this.nombreProgramacion.trim();
            if (!nombre) {
                this.$toast.error('Debes ingresar un nombre para la programación');
                return;
            }

            try {
                if (!esActualizacion) {
                    const res = await this.$axios.post('verificar-nombre-programacion', {
                        nombre_programacion: nombre
                    });

                    if (res.data.existe) {
                        this.$toast.error('Ya existe una programación con ese nombre. Por favor elige otro.');
                        return;
                    }
                }
                this.dialogNombreProgramacion = false;
                await this.guardarEntregables();
            } catch (error) {
                console.error(error);
                this.$toast.error('Error al verificar el nombre');
            }
        },
        async guardarEntregables() {
            this.cargandoEdicion = true;
            this.mensajeLoader = 'Guardando programacion...';
            const idServicio = this.servicioId;
            const tipoEscenario = this.tipoEscenario;
            try {
                const snapshotParaEditar = {
                    // Origen
                    servicioId: this.servicioId,
                    tipoEscenario: this.tipoEscenario,
                    nombreEscenarioSeleccionado: this.nombreEscenarioSeleccionado,

                    // Parámetros numéricos
                    horas_x_fte_semanal: this.parametros.horas_x_fte_semanal,
                    objetivoRQ: this.objetivoRQ,
                    objetivoEficiencia: this.objetivoEficiencia,
                    parametrosUtilizados: this.parametrosUtilizados,


                    // Parámetros variables según el escenario
                    //tmg: this.parametros.tmg,
                    nivel_servicio: this.parametros.nivel,
                    umbral_nds: this.parametros.umbral,

                    planDiaModelo: this.planDiaModelo,

                    ///preeliminar
                    nivelOptimizacion: this.nivelOptimizacion,
                    resumenMaximos: this.resumenMaximos,
                    programacionSemanal: this.programacionSemanal, // El objeto lógico
                    detallesPorAgente: this.detallesPorAgente,     // Detalles de jornadas
                    itemsProgramaSemanal: this.items,             // Los datos de la tabla visual
                    headersProgramaSemanal: this.headers,
                    matrizAsignacion: this.matrizAsignacion,
                    //descansos
                    itemsConDescanso: this.itemsConDescanso,
                    headersConDescanso: this.headers,

                    //recesos
                    descansosFinales: this.descansosFinales,
                    descansosTransformados: this.descansosTransformados,
                    programacionSemanalFinal: this.programacionSemanalFinal,
                    columnasReceso: this.columnasReceso,

                    //resumen
                    itemsTablaResumen: this.itemsTablaResumen,
                    diasUnicosResumen: this.diasUnicosResumen,


                    //graficasPorDiaPreeliminar: this.graficasPorDiaPreeliminar
                };

                const Entregables = [
                    // NUEVO: Agregamos el entregable de Configuración para poder editar después
                    {
                        nombreDatos: 'ConfiguracionEdicion',
                        headers: ['Campo', 'Valor'],
                        items: snapshotParaEditar,
                        tipo: 'Config'
                    },
                    {
                        nombreDatos: 'ParametrosCalculo',
                        headers: ['Campo', 'Valor'],
                        items: this.parametrosUtilizados, // Aquí va el objeto que armamos antes
                        tipo: 'Parametros'
                    },
                    {
                        nombreDatos: 'ResumenEficiencia',
                        headers: this.headersResumenEficiencia,
                        items: this.tablaResumenPorDia,
                        tipo: 'Tabla'
                    },
                    {
                        nombreDatos: 'Graficas',
                        headers: '',
                        items: this.graficasPorDiaFinal,
                        tipo: 'Grafica'
                    },
                    {
                        nombreDatos: 'TablaRequeridos',
                        headers: this.headersfinal,
                        items: this.requeridosData,
                        tipo: 'Tabla'
                    },
                    {
                        nombreDatos: 'TablaRequeridos+Reductores',
                        headers: this.headersfinal,
                        items: this.programadosData,
                        tipo: 'Tabla'
                    },
                    {
                        nombreDatos: 'TablaProgramados',
                        headers: this.headersfinal,
                        items: this.asignadosData,
                        tipo: 'Tabla'
                    },
                    {
                        nombreDatos: 'TablaProgramados_Requeridos',
                        headers: this.headersfinal,
                        items: this.diferenciaData,
                        tipo: 'Tabla'
                    },
                    {
                        nombreDatos: 'TablaResumenSemanal',
                        headers: this.diasUnicos,
                        items: this.itemsTablaResumen,
                        tipo: 'Tabla'
                    },
                    {
                        nombreDatos: 'ResumenFTE',
                        headers: ['Jornada', 'Agentes', 'Horas', 'FTE', 'Total Operadores', 'Total FTEs'],
                        items: this.resumenFTEsCalculado,
                        tipo: 'Tabla'
                    }
                ];
                const entregablesConServicio = Entregables.map(entregable => ({
                    id_servicio: idServicio,
                    tipo_escenario: tipoEscenario,
                    nombre_datos: entregable.nombreDatos,
                    tipo: entregable.tipo,
                    headers: entregable.headers,
                    items: entregable.items,
                    nombre_programacion: this.nombreProgramacion
                }));

                if (!entregablesConServicio.length) {
                    this.$toast.error('No hay entregables para guardar');
                    return;
                }
                //console.log(entregablesConServicio);


                const res = await this.$axios.post('guardar-entregables', entregablesConServicio);
                if (res.data.status === 'ok') {
                    this.$toast.success('Planeacion guardado con exito');
                    this.planDiaModelo = [];
                    this.nombreProgramacion = '';
                } else {
                    this.$toast.error(res.data.message || 'Error al guardar el turno');
                }
            } catch (error) {
                this.cargandoEdicion = false;
                console.error(error);
                this.$toast.error('Error de conexión');
            }
            finally {
                this.cargandoEdicion = false;
            }
        },
        async guardarEntregables2() {
            // 1. Identificadores base
            const idServicio = this.servicioId;
            const tipoEscenario = this.tipoEscenario;

            // 2. Este es el "ADN" que necesitamos capturar para la edición
            // Aquí agrupamos todo lo que el usuario seleccionó en el paso 1
            const snapshotParaEditar = {
                // Origen
                servicioId: this.servicioId,
                tipoEscenario: this.tipoEscenario,
                nombreEscenarioSeleccionado: this.nombreEscenarioSeleccionado,

                // Parámetros numéricos
                horas_x_fte_semanal: this.parametros.horas_x_fte_semanal,
                objetivoRQ: this.objetivoRQ,
                objetivoEficiencia: this.objetivoEficiencia,

                // Parámetros variables según el escenario
                //tmg: this.parametros.tmg,
                nivel_servicio: this.parametros.nivel,
                umbral_nds: this.parametros.umbral,

                planDiaModelo: this.planDiaModelo,

                ///preeliminar
                nivelOptimizacion: this.nivelOptimizacion,
                resumenMaximos: this.resumenMaximos,
                programacionSemanal: this.programacionSemanal, // El objeto lógico
                detallesPorAgente: this.detallesPorAgente,     // Detalles de jornadas
                itemsProgramaSemanal: this.items,             // Los datos de la tabla visual
                headersProgramaSemanal: this.headers,
                matrizAsignacion: this.matrizAsignacion,
                //descansos
                itemsConDescanso: this.itemsConDescanso,
                headersConDescanso: this.headers,

                //recesos
                descansosFinales: this.descansosFinales,
                descansosTransformados: this.descansosTransformados,
                programacionSemanalFinal: this.programacionSemanalFinal,
                columnasReceso: this.columnasReceso,

                //resumen
                itemsTablaResumen: this.itemsTablaResumen,
                diasUnicosResumen: this.diasUnicosResumen,


                //graficasPorDiaPreeliminar: this.graficasPorDiaPreeliminar
            };

            // 3. Mostramos en consola para AUDITORÍA
            console.log("%c--- AUDITORÍA DE DATOS DE PLANEACIÓN ---", "color: teal; font-weight: bold; font-size: 14px;");
            console.table(snapshotParaEditar); // Esto te lo mostrará como una tablita limpia en la consola

            console.log("Servicio Seleccionado:", this.servicios.find(s => s.id === idServicio)?.nombre);

            // 4. Verificamos los entregables visuales (lo que ya tenías)
            const EntregablesTemp = [
                { nombreDatos: 'ConfiguracionEdicion', items: snapshotParaEditar, tipo: 'Config' },
                { nombreDatos: 'ResumenEficiencia', items: this.tablaResumenPorDia, tipo: 'Tabla' },
                { nombreDatos: 'ResumenFTE', items: this.resumenFTEsCalculado, tipo: 'Tabla' }
            ];

            console.log("Lista de Entregables preparados:", EntregablesTemp);

            // COMENTAMOS EL ENVÍO POR AHORA
            /*
            const res = await this.$axios.post('guardar-entregables', entregablesConServicio);
            this.$toast.success('Simulación de guardado exitosa');
            */

            this.$toast.info('Revisa la consola (F12) para ver los parámetros capturados');
        },
        //PROCESO 1
        limpiardata() {
            this.items = [],
                this.headers = [],
                this.graficasPorDia = {},
                this.itemsConDescanso = [],
                this.columnasReceso = [],
                this.descansosTransformados = [],
                this.graficasPorDiaFinal = {},
                this.diasUnicosResumen = [],
                this.itemsTablaResumen = []
        },
        crearPlanDiaModelo() {
            this.cargandoEdicion = true;
            setTimeout(() => {

                try {
                    if (!this.servicioId) {
                        this.$toast.warning('Por favor, selecciona un servicio.');
                        return;
                    }
                    if (!this.tipoEscenario) {
                        this.$toast.warning('Por favor, selecciona un tipo de escenario.');
                        return;
                    }
                    if (!this.nombreEscenarioSeleccionado) {
                        this.$toast.warning('Debe seleccionar un Escenario Base.');
                        return;
                    }
                    if (this.turnosServicio.length === 0) {
                        this.$toast.warning('El servicio aun no tiene turnos asignados');
                        return;
                    }


                    const servicio = this.servicios.find(s => s.id === this.servicioId);
                    let auxiliares = [];

                    try {
                        auxiliares = JSON.parse(servicio.auxiliares);
                    } catch (error) {
                        this.$toast.error('Error al procesar los auxiliares del servicio.');
                        console.error('Error al parsear auxiliares:', error);
                        return;
                    }

                    if (!Array.isArray(auxiliares) || auxiliares.length === 0) {
                        this.$toast.warning('El servicio no tiene auxiliares configurados.');
                        return;
                    }

                    const camposRequeridos = [
                        'tipo',
                        'duracion',
                        'jornada_max',
                        'jornada_min',
                        'max_antes_fin',
                        'min_desde_inicio',
                        'max_antes_fin_min',
                        'min_desde_inicio_min'
                    ];

                    const auxiliaresCompletos = auxiliares.every(aux => {
                        return camposRequeridos.every(campo => {
                            const valor = aux[campo];
                            if (valor === undefined || valor === null) return false;
                            if (typeof valor === 'string' && valor.trim() === '') return false;
                            if (typeof valor === 'number' && isNaN(valor)) return false;
                            return true;
                        });
                    });

                    if (!auxiliaresCompletos) {
                        this.$toast.warning('Todos los auxiliares deben tener completos y válidos los campos requeridos para la planeación.');
                        return;
                    }


                    if (
                        servicio.utilizacion == null || servicio.ausentismo == null ||
                        servicio.utilizacion === '' || servicio.ausentismo === '' ||
                        parseFloat(servicio.utilizacion) <= 0 || parseFloat(servicio.ausentismo) <= 0
                    ) {
                        this.$toast.warning('El servicio no tiene definidos los valores de utilización o ausentismo.');
                        return;
                    }

                    const utz = parseFloat(servicio.utilizacion) / 100;
                    const abs = parseFloat(servicio.ausentismo) / 100;

                    this.escenariosFiltrados = this.escenarios.filter(item => {
                        return item.tipo === this.tipoEscenario &&
                            item.nombre === this.nombreEscenarioSeleccionado;
                    });

                    if (this.escenariosFiltrados.length === 0) {
                        this.$toast.warning(`No hay escenarios para el servicio "${servicio.nombre}" 
                            con tipo "${this.tipoEscenario}" y nombre "${this.nombreEscenarioSeleccionado}".`);
                        this.planDiaModelo = []; // Limpia resultados anteriores
                        return;
                    }
                    if (!this.parametros.tmg || !this.parametros.nivel || !this.parametros.umbral) {
                        this.$toast.warning('Completa todos los parámetros de configuración.');
                        return;
                    }
                    this.limpiardata();

                    this.planDiaModelo = this.escenariosFiltrados.map(item => {
                        const volumen = item.volumen;
                        const tmgV = item.tmg;
                        //console.log(tmgV);
                        let requeridos = 0;
                        if (this.tipoEscenario === 'transacciones') {
                            const tmgConfig = parseFloat(this.parametros.tmg);

                            const tmg = (tmgV !== null && tmgV !== undefined)
                                ? parseFloat(tmgV)
                                : tmgConfig;          // segundos

                            const nivel = parseFloat(this.parametros.nivel);      // porcentaje
                            const umbral = parseFloat(this.parametros.umbral);    // porcentaje

                            const sla = nivel / 100;
                            const serviceTime = umbral;
                            const callsPerHour = volumen * 2;
                            const aht = tmg;

                            requeridos = this.calcularAgentesErlangC({ sla, serviceTime, callsPerHour, aht });

                        } else if (this.tipoEscenario === 'horas') {
                            const tmgConfig = parseFloat(this.parametros.tmg);
                            const tmg = (tmgV !== null && tmgV !== undefined) ? parseFloat(tmgV) : tmgConfig;
                            const duracionIntervaloSegundos = 30 * 60;
                            requeridos = (volumen * tmg) / duracionIntervaloSegundos;
                            requeridos = parseFloat(requeridos.toFixed(2));
                        } else if (this.tipoEscenario === 'agentes') {
                            requeridos = volumen;
                        }

                        const programados = this.aplicarReductores(requeridos, utz, abs);
                        const diferencia = programados - requeridos;

                        return {
                            ...item,
                            requeridos,
                            programados,
                            diferencia
                        };
                    });
                    //console.log(this.planDiaModelo);
                    this.parametrosUtilizados = {};
                    // 1. Calculamos los totales para la ponderación
                    // Suma de (TMG * Volumen)
                    const sumaProductoTmgVolumen = this.planDiaModelo.reduce((acc, p) => {
                        const tmg = parseFloat(p.tmg) || 0;
                        const vol = parseFloat(p.volumen) || 0;
                        return acc + (tmg * vol);
                    }, 0);

                    // Suma de Volumen Total
                    const sumaVolumenTotal = this.planDiaModelo.reduce((acc, p) => {
                        return acc + (parseFloat(p.volumen) || 0);
                    }, 0);

                    // 2. Determinamos si el TMG fue variable o fijo
                    const listaTmg = this.planDiaModelo.map(p => p.tmg).filter(t => t != null);
                    const tmgMin = listaTmg.length > 0 ? Math.min(...listaTmg) : 0;
                    const tmgMax = listaTmg.length > 0 ? Math.max(...listaTmg) : 0;
                    const esVariable = tmgMin !== tmgMax;

                    // 3. Construimos el objeto de auditoría
                    this.parametrosUtilizados = {
                        tipo_escenario: {
                            'transacciones': 'Transacciones Entrantes',
                            'horas': 'Transacciones Salientes',
                            'agentes': 'Agentes'
                        }[this.tipoEscenario] || this.tipoEscenario,
                        nombre_base: this.nombreEscenarioSeleccionado,
                        tmg_desplegado: this.tipoEscenario != 'agentes'
                            ? (esVariable ? `Variable (${tmgMin}s - ${tmgMax}s)` : `${tmgMin || this.parametros.tmg}s (Fijo)`)
                            : 'N/A',
                        tmg_es_variable: this.tipoEscenario !== 'agentes' ? esVariable : false,
                        tmg_promedio: (this.tipoEscenario !== 'agentes' && sumaVolumenTotal > 0)
                            ? (sumaProductoTmgVolumen / sumaVolumenTotal).toFixed(2)
                            : '0.00',
                        // Solo incluimos estos si es transacciones
                        nivel_servicio: this.tipoEscenario === 'transacciones' ? `${this.parametros.nivel}%` : 'N/A',
                        umbral: this.tipoEscenario === 'transacciones' ? `${this.parametros.umbral}s` : 'N/A',
                        fecha_ejecucion: new Date().toLocaleString(),
                        objetivoRQ: this.objetivoRQ,
                        objetivoEficiencia: this.objetivoEficiencia
                    };

                    // 4. Console log detallado para tu revisión
                    //console.log("%c INFO: PARÁMETROS UTILIZADOS EN EL CÁLCULO", "color: #2196F3; font-weight: bold; font-size: 12px;");
                    //console.table(this.parametrosUtilizados);

                    // --- FIN DE CAPTURA ---
                    //this.calcularAsignacionPorTurno();
                    //this.calcularAsignacionVBAEstatico();
                } catch (error) {
                    this.$toast.error('Ocurrió un error inesperado al generar el plan del día.');
                    console.error('Error en crearPlanDiaModelo:', error);
                } finally {
                    this.cargandoEdicion = false;
                }
            }, 100);
        },
        //PROCESO 2
        calcularAsignacionVBAEstatico() {
            //console.log(this.planDiaModelo);
            //console.log(this.turnosServicio);
            const hojaDeDatos = this.planDiaModelo;
            const turnosServicioDinamicos = this.turnosServicio;


            const limiteBase = 13;
            const MAX_ITERACIONES = 4;
            const asignacionPorTurno = {};
            let iteraciones = 0;

            const convertirAHorasEnMinutos = (time) => {
                if (typeof time !== 'string' || !time) return 0;

                const timePart = time.substring(0, 5);
                if (timePart === '00:00') return 24 * 60;

                const partes = timePart.split(':');
                if (partes.length < 2) return 0;

                const [h, m] = partes.map(Number);
                return h * 60 + m;
            };

            const turnoCubreIntervalo = (turno, item) => {
                let inicioInt = convertirAHorasEnMinutos(item.intervalo_inicio);
                let finInt = convertirAHorasEnMinutos(item.intervalo_fin);
                let turnoInicio = convertirAHorasEnMinutos(turno.intervalo_inicio);
                let turnoFin = convertirAHorasEnMinutos(turno.intervalo_fin);
                return turnoInicio < finInt && turnoFin > inicioInt;
            };

            const simularFaltanteTotal = (asignacion) => {
                let maxDeficit = 0;
                hojaDeDatos.forEach(item => {
                    const demandaRequerida = item.programados;
                    let coberturaActual = 0;

                    turnosServicioDinamicos.filter(t => turnoCubreIntervalo(t, item))
                        .forEach(t => {
                            const clave = `${t.id}-${item.dia_semana}`;
                            coberturaActual += asignacion[clave] || 0;
                        });
                    maxDeficit = Math.max(maxDeficit, demandaRequerida - coberturaActual);
                });
                return Math.ceil(Math.max(0, maxDeficit));
            };

            const turnosDisponibles = turnosServicioDinamicos.filter(turno =>
                convertirAHorasEnMinutos(turno.intervalo_inicio) % 60 === 0
            );

            while (iteraciones < MAX_ITERACIONES) {

                hojaDeDatos.forEach(item => {
                    const dia = item.dia_semana;
                    const intervaloHora = item.intervalo_inicio;
                    const demandaRequerida = item.programados;

                    let coberturaActualEnIntervalo = 0;
                    turnosServicioDinamicos.filter(t => turnoCubreIntervalo(t, item))
                        .forEach(t => {
                            const clave = `${t.id}-${dia}`;
                            coberturaActualEnIntervalo += asignacionPorTurno[clave] || 0;
                        });

                    const demandaFaltanteActual = Math.max(0, demandaRequerida - coberturaActualEnIntervalo);

                    if (demandaFaltanteActual > 0) {

                        const turnosCandidatos = turnosDisponibles.filter(turno =>
                            convertirAHorasEnMinutos(turno.intervalo_inicio) ===
                            convertirAHorasEnMinutos(intervaloHora)
                        );

                        if (turnosCandidatos.length > 0) {

                            let turnoDestino = null;
                            let turnoIndex = 0;

                            while (turnoIndex < turnosCandidatos.length) {
                                const turnoActual = turnosCandidatos[turnoIndex];
                                const claveDestino = `${turnoActual.id}-${dia}`;
                                const asignacionActual = asignacionPorTurno[claveDestino] || 0;

                                if (asignacionActual >= limiteBase) {
                                    turnoIndex++; // Saltar al siguiente candidato
                                    continue;
                                } else {
                                    turnoDestino = turnoActual;
                                    break;
                                }
                            }

                            if (turnoDestino) {
                                const claveDestino = `${turnoDestino.id}-${dia}`;
                                const asignacionActual = asignacionPorTurno[claveDestino] || 0;

                                const incremento = Math.round(demandaFaltanteActual) / 2;

                                asignacionPorTurno[claveDestino] = Math.round(asignacionActual + incremento);
                            }
                        }
                    }
                });

                simularFaltanteTotal(asignacionPorTurno);
                iteraciones++;
            }

            //console.log(asignacionPorTurno);
            //this.generarMatrizAsignacion(asignacionPorTurno);
        },
        /*calcularAsignacionPorTurno() {
            this.cargando = true;
            const asignacionPorTurno = {};
            //console.log(this.planDiaModelo);

            this.planDiaModelo.forEach(item => {
                const dia = item.dia_semana;
                const demanda = item.programados;
                let inicioIntervalo = this.convertirAHorasEnMinutos(item.intervalo_inicio);
                let finIntervalo = this.convertirAHorasEnMinutos(item.intervalo_fin);

                if (finIntervalo <= inicioIntervalo) {
                    finIntervalo += 1440;
                }

                if (inicioIntervalo < 300) {
                    inicioIntervalo += 1440;
                    finIntervalo += 1440;
                }



                const turnosActivos = this.turnosServicio.filter(turno => {
                    if (!turno.dias_aplicables.includes(dia)) return false;

                    let turnoInicio = this.convertirAHorasEnMinutos(turno.intervalo_inicio);
                    let turnoFin = this.convertirAHorasEnMinutos(turno.intervalo_fin);
                    if (turnoFin <= turnoInicio) {
                        turnoFin += 1440;
                    }

                    /*if (turnoInicio < 300) {
                        turnoInicio += 1440;
                        turnoFin += 1440;
                    }*/

        /*return turnoInicio < finIntervalo && turnoFin > inicioIntervalo;
    });
    //console.log('Antes: ', turnosActivos, dia);

    let yaAsignados = 0;
    turnosActivos.forEach(turno => {
        const clave = `${turno.id}-${dia}`;
        yaAsignados += asignacionPorTurno[clave] || 0;
    });
    //console.log('Despues: ', turnosActivos, dia);

    const faltantes = Math.max(0, demanda - yaAsignados);
    //console.log(faltantes);

    if (faltantes > 0 && turnosActivos.length > 0) {
        const turnoDestino = turnosActivos[turnosActivos.length - 1];
        const claveDestino = `${turnoDestino.id}-${dia}`;
        if (!asignacionPorTurno[claveDestino]) asignacionPorTurno[claveDestino] = 0;
        asignacionPorTurno[claveDestino] += faltantes;
    }
});

//const asignacionBalanceada = this.ajustarBalanceoPorTransferencia(asignacionPorTurno);
// Llamamos a la función que construye la matriz
//console.log(asignacionPorTurno);
this.generarMatrizAsignacion(asignacionPorTurno);
this.cargando = false;
},*/
        calcularAsignacionPorTurno2() {
            this.cargando = true;
            const asignacionPorTurno = {};
            const todasLasDemandas = this.planDiaModelo.map(i => i.programados);
            const minGlobal = Math.min(...todasLasDemandas);

            const dias = [...new Set(this.planDiaModelo.map(i => i.dia_semana))];

            dias.forEach(dia => {
                const intervalosDelDia = this.planDiaModelo.filter(i => i.dia_semana === dia);

                intervalosDelDia.forEach(item => {
                    const demandaOriginal = item.programados;
                    const factores = { 0: 0.0, 1: 0.5, 2: 1.0 };
                    const factor = factores[this.nivelOptimizacion];

                    // Aplicamos optimización solo sobre lo que supera la base mínima
                    let demandaOptimizada = demandaOriginal;
                    if (demandaOriginal > minGlobal) {
                        demandaOptimizada = minGlobal + ((demandaOriginal - minGlobal) * factor);
                    }

                    let iIn = this.convertirAHorasEnMinutos(item.intervalo_inicio);
                    let iFi = this.convertirAHorasEnMinutos(item.intervalo_fin);
                    if (iFi <= iIn) iFi += 1440;

                    const turnosActivos = this.turnosServicio.filter(t => {
                        if (!t.dias_aplicables.includes(dia)) return false;
                        let tIn = this.convertirAHorasEnMinutos(t.intervalo_inicio);
                        let tFi = this.convertirAHorasEnMinutos(t.intervalo_fin);
                        if (tFi <= tIn) tFi += 1440;
                        return tIn < iFi && tFi > iIn;
                    }).sort((a, b) => this.convertirAHorasEnMinutos(a.intervalo_inicio) - this.convertirAHorasEnMinutos(b.intervalo_inicio));

                    if (turnosActivos.length === 0) return;

                    let yaAsignado = 0;
                    turnosActivos.forEach(t => {
                        const clave = `${t.id}-${dia}`;
                        yaAsignado += asignacionPorTurno[clave] || 0;
                    });

                    const faltante = Math.max(0, Math.ceil(demandaOptimizada) - yaAsignado);

                    if (faltante > 0) {
                        // Asignamos al último turno para cubrir el hueco actual
                        const turnoDestino = turnosActivos[turnosActivos.length - 1];
                        const claveDestino = `${turnoDestino.id}-${dia}`;
                        if (!asignacionPorTurno[claveDestino]) asignacionPorTurno[claveDestino] = 0;

                        // IMPORTANTE: Incrementamos la capacidad del turno para que cubra este pico
                        asignacionPorTurno[claveDestino] += faltante;
                    }
                });
            });

            this.generarMatrizAsignacion(asignacionPorTurno);
            this.cargando = false;
        },
        calcularAsignacionPorTurno3() {
            this.cargando = true;
            const asignacionPorTurno = {};
            const todasLasDemandas = this.planDiaModelo.map(i => i.programados);
            const minGlobal = Math.min(...todasLasDemandas);
            const dias = [...new Set(this.planDiaModelo.map(i => i.dia_semana))];

            dias.forEach(dia => {
                const intervalosDelDia = this.planDiaModelo.filter(i => i.dia_semana === dia);

                intervalosDelDia.forEach(item => {
                    const demandaOriginal = item.programados;
                    //const factores = { 0: 0.0, 1: 0.5, 2: 1.0 };
                    //const factor = factores[this.nivelOptimizacion];
                    const factor = parseFloat(this.nivelOptimizacion);

                    let demandaOptimizada = demandaOriginal;
                    if (demandaOriginal > minGlobal) {
                        demandaOptimizada = minGlobal + ((demandaOriginal - minGlobal) * factor);
                    }

                    let iIn = this.convertirAHorasEnMinutos(item.intervalo_inicio);
                    let iFi = this.convertirAHorasEnMinutos(item.intervalo_fin);
                    if (iFi <= iIn) iFi += 1440;

                    // 1. CALCULAR COBERTURA ACTUAL: ¿Cuánta gente ya tengo trabajando en este intervalo?
                    let coberturaActual = 0;
                    this.turnosServicio.forEach(t => {
                        if (!t.dias_aplicables.includes(dia)) return;

                        let tIn = this.convertirAHorasEnMinutos(t.intervalo_inicio);
                        let tFi = this.convertirAHorasEnMinutos(t.intervalo_fin);
                        if (tFi <= tIn) tFi += 1440;

                        // Si este turno cubre el intervalo actual, sumamos lo que ya se le asignó antes
                        if (tIn <= iIn && tFi >= iFi) {
                            const clave = `${t.id}-${dia}`;
                            coberturaActual += (asignacionPorTurno[clave] || 0);
                        }
                    });

                    // 2. Determinar si realmente falta gente
                    const faltante = Math.max(0, Math.ceil(demandaOptimizada) - coberturaActual);

                    if (faltante > 0) {
                        // Buscamos turnos que EMPIECEN en este intervalo o estén activos
                        const turnosQueInician = this.turnosServicio.filter(t => {
                            if (!t.dias_aplicables.includes(dia)) return false;
                            let tIn = this.convertirAHorasEnMinutos(t.intervalo_inicio);
                            // Priorizamos turnos que arrancan ahora para cubrir la nueva demanda
                            return tIn >= iIn && tIn < iFi;
                        });

                        // Si no hay turnos empezando, usamos los activos
                        const turnosDisponibles = turnosQueInician.length > 0 ? turnosQueInician :
                            this.turnosServicio.filter(t => {
                                if (!t.dias_aplicables.includes(dia)) return false;
                                let tIn = this.convertirAHorasEnMinutos(t.intervalo_inicio);
                                let tFi = this.convertirAHorasEnMinutos(t.intervalo_fin);
                                if (tFi <= tIn) tFi += 1440;
                                return tIn <= iIn && tFi >= iFi;
                            });

                        if (turnosDisponibles.length > 0) {
                            // Asignamos al primer turno disponible (el más cercano al inicio del bache)
                            const turnoDestino = turnosDisponibles[0];
                            const claveDestino = `${turnoDestino.id}-${dia}`;
                            if (!asignacionPorTurno[claveDestino]) asignacionPorTurno[claveDestino] = 0;

                            asignacionPorTurno[claveDestino] += faltante;
                        }
                    }
                });
            });

            this.generarMatrizAsignacion(asignacionPorTurno);
            this.cargando = false;
        },
        calcularAsignacionPorTurno() {
            this.cargandoEdicion = true;
            setTimeout(() => {
                try {
                    const asignacionPorTurno = {};
                    const dias = [...new Set(this.planDiaModelo.map(i => i.dia_semana))];
                    this.turnosServicio.sort((a, b) => {
                        // Calculamos duración de cada turno
                        const duracionA = this.calcularDuracionEnMinutos(a);
                        const duracionB = this.calcularDuracionEnMinutos(b);

                        // PRIORIDAD 1: El más largo primero (9h antes que 4h)
                        if (duracionB !== duracionA) {
                            return duracionB - duracionA;
                        }

                        // PRIORIDAD 2: El que empiece más temprano
                        const inicioA = this.convertirAHorasEnMinutos(a.intervalo_inicio);
                        const inicioB = this.convertirAHorasEnMinutos(b.intervalo_inicio);
                        return inicioA - inicioB;
                    });
                    //console.log(this.turnosServicio);

                    dias.forEach(dia => {
                        const intervalos = this.planDiaModelo.filter(i => i.dia_semana === dia);

                        let demandaPendiente = intervalos.map(inv => {
                            let baseSlider = inv.programados * parseFloat(this.nivelOptimizacion);

                            // Aplicamos un factor de relevo interno (1.15 es un estándar seguro para 6x1)
                            let factorRelevoInterno = 1.15;

                            return {
                                inicio: this.convertirAHorasEnMinutos(inv.intervalo_inicio),
                                fin: this.convertirAHorasEnMinutos(inv.intervalo_fin),
                                valor: baseSlider * factorRelevoInterno
                            };
                        });

                        // SEGURO: Máximo de iteraciones para evitar bucles infinitos (ej. 500 agentes)
                        let iteraciones = 0;
                        const MAX_AGENTES = 1000;

                        while (demandaPendiente.some(d => d.valor >= 0.8) && iteraciones < MAX_AGENTES) {
                            iteraciones++;

                            // 1. Buscamos el intervalo con mayor demanda pendiente
                            const maxIntervalo = demandaPendiente.reduce((prev, current) =>
                                (prev.valor > current.valor) ? prev : current
                            );

                            // --- INICIO DEL DEBUG ---
                            /*if (maxIntervalo.inicio < 300) { // Si el pico detectado es antes de las 05:00 AM
                                console.log("%c--- ANALIZANDO MADRUGADA ---", "color: orange; font-weight: bold;");
                                console.log("Hora del Pico:", this.convertirMinutosAHoras(maxIntervalo.inicio));
                                console.log("Valor de Demanda:", maxIntervalo.valor);
                            }*/
                            // --- FIN DEL DEBUG ---

                            // 2. Buscamos turnos que REALMENTE cubran este intervalo específico
                            const turnosCandidatos = this.turnosServicio.filter(t => {
                                if (!t.dias_aplicables.includes(dia)) return false;
                                let tIn = this.convertirAHorasEnMinutos(t.intervalo_inicio);
                                let tFi = this.convertirAHorasEnMinutos(t.intervalo_fin);
                                let hPico = maxIntervalo.inicio;

                                // Si el turno cruza medianoche, usamos lógica circular
                                if (tFi <= tIn) {
                                    return hPico >= tIn || hPico < tFi;
                                }
                                // Si es un turno normal, se mantiene la lógica que ya te funcionaba
                                return tIn <= hPico && tFi > hPico;
                            });

                            ///
                            // --- SEGUNDO DEBUG: VER SI EL TURNO APARECE ---
                            if (maxIntervalo.inicio < 300) {
                                //console.log("Turnos Candidatos encontrados:", turnosCandidatos.map(t => t.intervalo_inicio + " a " + t.intervalo_fin));
                                if (turnosCandidatos.length === 0) {
                                    //console.error("¡ERROR!: No hay turnos para esta hora.");
                                }
                            }
                            ///

                            // Si no hay turnos para este bache, bajamos la demanda artificialmente para saltarlo
                            if (turnosCandidatos.length === 0) {
                                maxIntervalo.valor = 0;
                                continue;
                            }

                            // 3. Elegimos el mejor turno por aptitud
                            const mejorTurno = turnosCandidatos.sort((a, b) => {
                                const scoreA = this.calcularAptitudTurno(a, maxIntervalo, demandaPendiente);
                                const scoreB = this.calcularAptitudTurno(b, maxIntervalo, demandaPendiente);
                                return scoreB - scoreA;
                            })[0];

                            // 4. Asignamos
                            const clave = `${mejorTurno.id}-${dia}`;
                            asignacionPorTurno[clave] = (asignacionPorTurno[clave] || 0) + 1;

                            // 5. Restamos capacidad en toda la franja del turno
                            let tIn = this.convertirAHorasEnMinutos(mejorTurno.intervalo_inicio);
                            let tFi = this.convertirAHorasEnMinutos(mejorTurno.intervalo_fin);

                            demandaPendiente.forEach(inv => {
                                let h = inv.inicio;
                                let cubierto = (tFi <= tIn) ? (h >= tIn || h < tFi) : (h >= tIn && h < tFi);

                                if (cubierto) {
                                    inv.valor -= 1;
                                }
                            });
                        }
                    });

                    //console.log(asignacionPorTurno);
                    this.generarMatrizAsignacion(asignacionPorTurno);
                } catch (error) {
                    console.error("Error en el cálculo:", error);
                } finally {
                    this.cargandoEdicion = false;
                }
            }, 200);
        },

        // Función para elegir el turno que menos "desperdicio" genere
        calcularAptitudTurno(turno, intervaloPico, demandaTotal) {
            let tIn = this.convertirAHorasEnMinutos(turno.intervalo_inicio);
            let tFi = this.convertirAHorasEnMinutos(turno.intervalo_fin);
            let esNocturno = tFi <= tIn;

            let coberturaUtil = 0;
            let desperdicio = 0;

            demandaTotal.forEach(inv => {
                let h = inv.inicio;
                // Lógica de pertenencia circular
                let estaEnTurno = esNocturno ? (h >= tIn || h < tFi) : (h >= tIn && h < tFi);

                if (estaEnTurno) {
                    if (inv.valor > 0.8) {
                        coberturaUtil += 1;
                    } else {
                        // Penalizamos el triple el desperdicio para que la barra azul
                        // no se despegue de la línea roja
                        desperdicio += 3;
                    }
                }
            });

            let score = coberturaUtil - desperdicio;

            // BONO QUIRÚRGICO: Solo damos bono si el pico actual es de madrugada
            // Esto evita que un turno nocturno se use para cubrir la tarde por error
            if (esNocturno && intervaloPico.inicio < 300) {
                score += 20;
            }

            return score;
        },
        calcularAptitudTurno1(turno, intervaloPico, demandaTotal) {
            let tIn = this.convertirAHorasEnMinutos(turno.intervalo_inicio);
            let tFi = this.convertirAHorasEnMinutos(turno.intervalo_fin);
            let esNocturno = tFi <= tIn;

            let coberturaUtil = 0;
            let desperdicio = 0;

            demandaTotal.forEach(inv => {
                let h = inv.inicio;
                let estaEnTurno = esNocturno ? (h >= tIn || h < tFi) : (h >= tIn && h < tFi);

                if (estaEnTurno) {
                    if (inv.valor > 0.8) {
                        coberturaUtil += 1;
                    } else {
                        desperdicio += 1;
                    }
                }
            });

            let score = coberturaUtil - desperdicio;

            // Si el turno cubre la madrugada, le damos prioridad para que se asigne 
            // antes de que se agoten los agentes en los picos de la mañana.
            if (esNocturno) score += 100;

            return score;
        },
        calcularAptitudTurno2(turno, intervaloPico, demandaTotal) {
            let tIn = this.convertirAHorasEnMinutos(turno.intervalo_inicio);
            let tFi = this.convertirAHorasEnMinutos(turno.intervalo_fin);
            if (tFi <= tIn) tFi += 1440;

            // Si el turno ni siquiera cubre el pico, aptitud 0
            if (!(tIn <= intervaloPico.inicio && tFi > intervaloPico.inicio)) return -1;

            let coberturaUtil = 0;
            let desperdicio = 0;

            demandaTotal.forEach(inv => {
                if (inv.inicio >= tIn && inv.inicio < tFi) {
                    if (inv.valor > 0) {
                        coberturaUtil += 1; // El agente está trabajando en algo necesario
                    } else {
                        desperdicio += 1; // El agente está sobrando aquí (Overstaffing)
                    }
                }
            });

            return coberturaUtil - desperdicio; // Queremos mucha utilidad y poco desperdicio
        },

        // Función auxiliar para saber si un intervalo cae dentro de un turno
        calcularDuracionEnMinutos(turno) {
            let tIn = this.convertirAHorasEnMinutos(turno.intervalo_inicio);
            let tFi = this.convertirAHorasEnMinutos(turno.intervalo_fin);
            if (tFi <= tIn) tFi += 1440; // Manejo de medianoche
            return tFi - tIn;
        },
        /*calcularAsignacionPorTurno() {
            const asignacionPorTurno = {};
            //console.log(this.planDiaModelo);

            this.planDiaModelo.forEach(item => {
                const dia = item.dia_semana;
                const demanda = item.programados;
                let inicioIntervalo = this.convertirAHorasEnMinutos(item.intervalo_inicio);
                let finIntervalo = this.convertirAHorasEnMinutos(item.intervalo_fin);

                if (finIntervalo <= inicioIntervalo) {
                    finIntervalo += 1440;
                }

                if (inicioIntervalo < 300) {
                    inicioIntervalo += 1440;
                    finIntervalo += 1440;
                }



                const turnosActivos = this.turnosServicio.filter(turno => {
                    if (!turno.dias_aplicables.includes(dia)) return false;

                    let turnoInicio = this.convertirAHorasEnMinutos(turno.intervalo_inicio);
                    let turnoFin = this.convertirAHorasEnMinutos(turno.intervalo_fin);
                    if (turnoFin <= turnoInicio) {
                        turnoFin += 1440;
                    }

                    //if (turnoInicio < 300) {
                        //turnoInicio += 1440;
                        //turnoFin += 1440;
                    //}

                    return turnoInicio < finIntervalo && turnoFin > inicioIntervalo;
                });

                // 1. Mostrar qué turnos están activos para el intervalo.
                console.log(`[${dia} ${item.intervalo_inicio}-${item.intervalo_fin}] Turnos activos (IDs):`, turnosActivos.map(t => t.id).join(', '));

                let yaAsignados = 0;
                turnosActivos.forEach(turno => {
                    const clave = `${turno.id}-${dia}`;
                    yaAsignados += asignacionPorTurno[clave] || 0;
                });

                const faltantes = Math.max(0, demanda - yaAsignados);

                // 2. Mostrar la demanda pendiente.
                console.log(`[${dia} ${item.intervalo_inicio}-${item.intervalo_fin}] Demanda Faltante: ${faltantes}`);

                if (faltantes > 0 && turnosActivos.length > 0) {

                    // 3. Mostrar el turno que se selecciona.
                    const turnoDestino = turnosActivos[turnosActivos.length - 1]; // <-- ¡Último turno seleccionado!
                    const claveDestino = `${turnoDestino.id}-${dia}`;

                    // 4. Mostrar la asignación.
                    console.log(`🚨 ASIGNANDO: Turno ${turnoDestino.id} recibe ${faltantes} para el día ${dia}.`);

                    if (!asignacionPorTurno[claveDestino]) asignacionPorTurno[claveDestino] = 0;
                    asignacionPorTurno[claveDestino] += faltantes; // <-- Toda la asignación va aquí.
                }
            });

            //const asignacionBalanceada = this.ajustarBalanceoPorTransferencia(asignacionPorTurno);
            // Llamamos a la función que construye la matriz
            console.log('\n--- Resultado Final ---');
            console.log(asignacionPorTurno);
            this.generarMatrizAsignacion(asignacionPorTurno);
        },*/
        ajustarBalanceoPorTransferencia(asignacionPorTurno) {
            const AGENTES_A_TRANSFERIR = 4;

            const diasSemana = Array.from(new Set(
                Object.keys(asignacionPorTurno).map(clave => clave.split('-')[1])
            ));

            diasSemana.forEach(dia => {

                let listaTurnos = [];
                this.turnosServicio.forEach(turno => {
                    const clave = `${turno.id}-${dia}`;
                    listaTurnos.push({
                        clave: clave,
                        carga: asignacionPorTurno[clave] || 0,
                    });
                });

                listaTurnos.sort((a, b) => a.carga - b.carga);

                const turnoPobre = listaTurnos[0];

                const turnoRico = listaTurnos[listaTurnos.length - 1];

                if (turnoPobre && turnoRico && turnoPobre.carga < turnoRico.carga) {

                    const cantidad = AGENTES_A_TRANSFERIR;


                    if (turnoRico.carga >= cantidad) {
                        asignacionPorTurno[turnoRico.clave] -= cantidad;

                        asignacionPorTurno[turnoPobre.clave] += cantidad;
                    }
                }

            });

            return asignacionPorTurno;
        },
        //PROCESO 3
        generarMatrizAsignacion(asignacionPorTurno) {
            this.matrizAsignacion = this.turnosServicio.map(turno => {
                const fila = {
                    turno: `${turno.intervalo_inicio} - ${turno.intervalo_fin}`
                };

                this.diasDisponibles.forEach(dia => {
                    const clave = `${turno.id}-${dia}`;
                    fila[dia] = turno.dias_aplicables.includes(dia)
                        ? Math.round(asignacionPorTurno[clave] || 0)
                        : null;
                });

                return fila;
            });
            //console.log(this.matrizAsignacion);
            this.calcularMaximoPorTurno();
        },
        //PROCESO 4
        calcularMaximoPorTurno() {
            //console.log(this.turnosServicio);
            const resumen = this.turnosServicio.map(turno => {
                let maximo = 0;

                this.diasDisponibles.forEach(dia => {
                    if (!turno.dias_aplicables.includes(dia)) return;

                    const fila = this.matrizAsignacion.find(f =>
                        f.turno === `${turno.intervalo_inicio} - ${turno.intervalo_fin}`
                    );

                    const agentes = parseInt(fila?.[dia]) || 0;
                    maximo = Math.max(maximo, agentes);
                });

                return {
                    turno: `${turno.intervalo_inicio} - ${turno.intervalo_fin}`,
                    requerido: maximo
                };
            });

            this.resumenMaximos = resumen;
            //console.log(this.resumenMaximos);
            this.generarDatosGraficasPorDiaPreeliminar();
            this.generarProgramacionSemanalPorAgente();
            this.actualizarTablaDesdeProgramacion();
            //this.generarProgramacionConDescansos(this.programacionSemanal);
            /*this.programacionConDescansos = this.generarProgramacionConDescansos(this.programacionSemanal);
            this.$nextTick(() => {
                this.actualizarTablaConDescansos(this.programacionConDescansos);
            });
            //this.actualizarTablaConDescansos();*/
        },
        //PROCESO 5
        generarDatosGraficasPorDiaPreeliminar() {
            const graficasPorDia = {}
            let maximoGlobal = 0

            //console.log(this.resumenMaximos);
            this.diasDisponibles.forEach(dia => {
                const diaEscenarios = this.planDiaModelo.filter(item => item.dia_semana === dia)

                const intervalos = diaEscenarios.map(e => e.intervalo_inicio)
                const programados = diaEscenarios.map(e => Math.round(e.programados))
                const requeridos = diaEscenarios.map(e => Math.round(e.requeridos))


                const asignados = diaEscenarios.map(e => {
                    let intervaloInicio = this.convertirAHorasEnMinutos(e.intervalo_inicio)
                    let intervaloFin = this.convertirAHorasEnMinutos(e.intervalo_fin)

                    if (intervaloFin <= intervaloInicio) {
                        intervaloFin += 1440;
                    }

                    if (intervaloInicio < 300) {
                        intervaloInicio += 1440;
                        intervaloFin += 1440;
                    }


                    const total = this.resumenMaximos.reduce((suma, r) => {
                        const [inicioStr, finStr] = r.turno.split(' - ')
                        let turnoInicio = this.convertirAHorasEnMinutos(inicioStr)
                        let turnoFin = this.convertirAHorasEnMinutos(finStr)

                        if (turnoFin <= turnoInicio) {
                            turnoFin += 1440;
                        }

                        /*if (turnoInicio < 300) {
                            turnoInicio += 1440;
                            turnoFin += 1440;
                        }*/


                        const cubre = turnoInicio < intervaloFin && turnoFin > intervaloInicio
                        return cubre ? suma + (r.requerido || 0) : suma
                    }, 0)


                    return total
                })

                const maxDia = Math.max(...programados, ...requeridos, ...asignados)
                if (maxDia > maximoGlobal) {
                    maximoGlobal = maxDia
                }
                graficasPorDia[dia] = {
                    intervalos,
                    asignados,
                    programados,
                    requeridos
                }
            })

            this.maxEjeYPreeliminar = Math.ceil(maximoGlobal * 1.1);

            this.graficasPorDiaPreeliminar = graficasPorDia;
            //console.log(this.graficasPorDiaPreeliminar);
        },
        generarDatosGraficasPorDiaDescansos() {
            const graficasPorDia = {};
            let maximoGlobal = 0;

            // Iteramos sobre los días (Lunes, Martes, etc.)
            this.diasDisponibles.forEach(dia => {
                // 1. Obtenemos la demanda de ese día desde el modelo base
                const diaEscenarios = this.planDiaModelo.filter(item => item.dia_semana === dia);

                const intervalos = diaEscenarios.map(e => e.intervalo_inicio);
                const programados = diaEscenarios.map(e => Math.round(e.programados));
                const requeridos = diaEscenarios.map(e => Math.round(e.requeridos));

                // 2. Calculamos los agentes ASIGNADOS basándonos en itemsConDescanso
                const asignados = diaEscenarios.map(e => {
                    let intervaloInicio = this.convertirAHorasEnMinutos(e.intervalo_inicio);
                    let intervaloFin = this.convertirAHorasEnMinutos(e.intervalo_fin);

                    // Ajuste de medianoche para el intervalo
                    if (intervaloFin <= intervaloInicio) intervaloFin += 1440;
                    if (intervaloInicio < 300) {
                        intervaloInicio += 1440;
                        intervaloFin += 1440;
                    }

                    let totalEnIntervalo = 0;

                    // Recorremos cada agente para ver si su turno de ese día cubre este intervalo
                    this.itemsConDescanso.forEach(agente => {
                        const diaKey = dia.toLowerCase(); // Aseguramos que coincida con "lunes", "martes"...
                        const horarioRaw = agente[diaKey];

                        // Si es Día de Descanso (DS) o está vacío, no suma
                        if (!horarioRaw || horarioRaw === "DS" || horarioRaw === "—") return;

                        // Separamos el inicio y fin del turno del agente (soporta "-" y "–")
                        const separador = horarioRaw.includes('–') ? '–' : '-';
                        const [turnoInicioStr, turnoFinStr] = horarioRaw.split(separador);

                        let turnoInicio = this.convertirAHorasEnMinutos(turnoInicioStr);
                        let turnoFin = this.convertirAHorasEnMinutos(turnoFinStr);

                        // Ajuste de medianoche para el turno del agente
                        if (turnoFin <= turnoInicio) turnoFin += 1440;
                        if (turnoInicio < 300) {
                            turnoInicio += 1440;
                            turnoFin += 1440;
                        }

                        // Verificamos si el turno se cruza con el intervalo actual
                        const cubre = turnoInicio < intervaloFin && turnoFin > intervaloInicio;

                        if (cubre) {
                            totalEnIntervalo++;
                        }
                    });

                    return totalEnIntervalo;
                });

                const maxDia = Math.max(...programados, ...requeridos, ...asignados);
                if (maxDia > maximoGlobal) {
                    maximoGlobal = maxDia
                }

                // 3. Calculamos la diferencia (Sobrante/Faltante)
                //const diferencia = asignados.map((valor, i) => valor - requeridos[i]);

                // 4. Guardamos el objeto para la gráfica de este día
                graficasPorDia[dia] = {
                    intervalos,
                    asignados,
                    programados,
                    requeridos,
                    //diferencia
                };
            });


            this.maxEjeYDescansos = Math.ceil(maximoGlobal * 1.1);
            this.graficasPorDiaDescansos = graficasPorDia;
        },
        generarDatosGraficasPorDiaRecesos2() {
            //console.log(this.descansosFinales);
            const graficasPorDia = {};

            // Iteramos sobre los días (Lunes, Martes, etc.)
            this.diasDisponibles.forEach(dia => {
                // 1. Obtenemos la demanda y base de ese día
                const diaEscenarios = this.planDiaModelo.filter(item => item.dia_semana === dia);

                const intervalos = diaEscenarios.map(e => e.intervalo_inicio);
                const requeridos = diaEscenarios.map(e => Math.round(e.requeridos));
                const programados = diaEscenarios.map(e => Math.round(e.programados)); // Capacidad teórica original

                // 2. Calculamos la Cobertura Neta (restando recesos)
                const asignadosConReceso = diaEscenarios.map(e => {
                    let intervaloInicio = this.convertirAHorasEnMinutos(e.intervalo_inicio);
                    let intervaloFin = this.convertirAHorasEnMinutos(e.intervalo_fin);

                    // Tus ajustes de medianoche
                    if (intervaloFin <= intervaloInicio) intervaloFin += 1440;
                    if (intervaloInicio < 300) {
                        intervaloInicio += 1440;
                        intervaloFin += 1440;
                    }

                    let agentesTrabajando = 0;

                    // Recorremos la programación original para ver quiénes tienen turno
                    Object.entries(this.programacionSemanalFinal).forEach(([nombre, semana]) => {
                        const horarioRaw = semana[dia];
                        if (!horarioRaw || horarioRaw === "DS" || horarioRaw === "—") return;

                        const separador = horarioRaw.includes('–') ? '–' : '-';
                        const [tInicioStr, tFinStr] = horarioRaw.split(separador);
                        let tInicio = this.convertirAHorasEnMinutos(tInicioStr);
                        let tFin = this.convertirAHorasEnMinutos(tFinStr);

                        if (tFin <= tInicio) tFin += 1440;
                        if (tInicio < 300) {
                            tInicio += 1440;
                            tFin += 1440;
                        }

                        // ¿El agente debería estar trabajando según su turno?
                        const enTurno = tInicio < intervaloFin && tFin > intervaloInicio;

                        if (enTurno) {
                            // 3. Verificamos si este agente tiene un RECESO en este intervalo exacto
                            // Buscamos en descansosFinales
                            const enReceso = this.descansosFinales.some(d => {
                                if (d.agente === nombre && d.dia === dia) {
                                    const [rInicioStr, rFinStr] = d.bloque.split('–');
                                    let rInicio = this.convertirAHorasEnMinutos(rInicioStr);
                                    let rFin = this.convertirAHorasEnMinutos(rFinStr);

                                    // Ajuste medianoche para el receso
                                    if (rFin <= rInicio) rFin += 1440;
                                    if (rInicio < 300) {
                                        rInicio += 1440;
                                        rFin += 1440;
                                    }

                                    // Si el receso se cruza con el intervalo, el agente NO está trabajando
                                    return rInicio < intervaloFin && rFin > intervaloInicio;
                                }
                                return false;
                            });

                            if (!enReceso) {
                                agentesTrabajando++;
                            }
                        }
                    });

                    return agentesTrabajando;
                });

                // 4. Guardamos el objeto para la gráfica
                graficasPorDia[dia] = {
                    intervalos,
                    asignados: asignadosConReceso, // Esta es la curva real con el "bocado" del receso
                    programados,
                    requeridos
                };
            });

            this.graficasPorDiaRecesos = graficasPorDia;

        },
        generarDatosGraficasPorDiaRecesos() {
            //console.log(this.descansosFinales);
            const graficasPorDia = {};
            let maximoGlobal = 0;

            this.diasDisponibles.forEach(dia => {
                const diaEscenarios = this.planDiaModelo.filter(item => item.dia_semana === dia);
                const intervalos = diaEscenarios.map(e => e.intervalo_inicio);
                const requeridos = diaEscenarios.map(e => Math.round(e.requeridos));
                const programados = diaEscenarios.map(e => Math.round(e.programados));

                const asignadosConReceso = diaEscenarios.map(e => {
                    let intervaloInicio = this.convertirAHorasEnMinutos(e.intervalo_inicio);
                    let intervaloFin = this.convertirAHorasEnMinutos(e.intervalo_fin);

                    if (intervaloFin <= intervaloInicio) intervaloFin += 1440;
                    if (intervaloInicio < 300) {
                        intervaloInicio += 1440;
                        intervaloFin += 1440;
                    }

                    let agentesTrabajando = 0;

                    Object.entries(this.programacionSemanalFinal).forEach(([nombre, semana]) => {
                        const horarioRaw = semana[dia];
                        if (!horarioRaw || horarioRaw === "DS" || horarioRaw === "—") return;

                        const separador = horarioRaw.includes('–') ? '–' : '-';
                        const [tInicioStr, tFinStr] = horarioRaw.split(separador);
                        let tInicio = this.convertirAHorasEnMinutos(tInicioStr);
                        let tFin = this.convertirAHorasEnMinutos(tFinStr);

                        if (tFin <= tInicio) tFin += 1440;
                        if (tInicio < 300) {
                            tInicio += 1440;
                            tFin += 1440;
                        }

                        const enTurno = tInicio < intervaloFin && tFin > intervaloInicio;

                        if (enTurno) {
                            let peso = 1.0;

                            // Buscamos los recesos de este agente para este día
                            const recesosAgente = this.descansosFinales.filter(d => d.agente === nombre && d.dia === dia);

                            recesosAgente.forEach(d => {
                                const [rInicioStr, rFinStr] = d.bloque.split('–');
                                let rInicio = this.convertirAHorasEnMinutos(rInicioStr);
                                let rFin = this.convertirAHorasEnMinutos(rFinStr);

                                if (rFin <= rInicio) rFin += 1440;
                                if (rInicio < 300) {
                                    rInicio += 1440;
                                    rFin += 1440;
                                }

                                // Cálculo de solapamiento proporcional
                                const overlap = Math.max(0, Math.min(rFin, intervaloFin) - Math.max(rInicio, intervaloInicio));
                                const duracionInt = intervaloFin - intervaloInicio;

                                if (duracionInt > 0) {
                                    const porcentajeReceso = overlap / duracionInt;
                                    if (porcentajeReceso >= 0.75) {
                                        peso = 0;
                                    } else {
                                        peso -= porcentajeReceso;
                                    }
                                }
                            });

                            agentesTrabajando += Math.max(0, peso);
                        }
                    });

                    return parseFloat(agentesTrabajando.toFixed(2));
                });

                const maxDia = Math.max(...programados, ...requeridos, ...asignadosConReceso);

                if (maxDia > maximoGlobal) {
                    maximoGlobal = maxDia;
                }

                graficasPorDia[dia] = {
                    intervalos,
                    asignados: asignadosConReceso,
                    programados,
                    requeridos
                };
            });

            this.maxEjeYRecesos = Math.ceil(maximoGlobal * 1.1);
            this.graficasPorDiaRecesos = graficasPorDia;
        },
        generarDatosGraficasPorDiaFinal2() {
            const graficasPorDia = {}
            this.diasDisponibles.forEach(dia => {
                const diaEscenarios = this.planDiaModelo.filter(item => item.dia_semana === dia)

                const intervalos = diaEscenarios.map(e => e.intervalo_inicio)
                const programados = diaEscenarios.map(e => Math.round(e.programados))
                const requeridos = diaEscenarios.map(e => Math.round(e.requeridos))

                const asignados = diaEscenarios.map(e => {
                    let intervaloInicio = this.convertirAHorasEnMinutos(e.intervalo_inicio)
                    let intervaloFin = this.convertirAHorasEnMinutos(e.intervalo_fin)

                    if (intervaloFin <= intervaloInicio) intervaloFin += 1440
                    if (intervaloInicio < 300) {
                        intervaloInicio += 1440
                        intervaloFin += 1440
                    }

                    let total = 0

                    //console.log(this.itemsTablaResumen);
                    this.itemsTablaResumen.forEach(agente => {
                        const diaKey = dia.toLowerCase();
                        const horarioRaw = agente[`${diaKey}_horario`]

                        const recesosDisponibles = [
                            agente[`${diaKey}_receso60`],
                            agente[`${diaKey}_receso30`],
                            agente[`${diaKey}_receso15`]
                        ].filter(r => r && r !== "DS" && r !== "—");

                        if (horarioRaw === "DS" || horarioRaw === "—") return

                        const [turnoInicioStr, turnoFinStr] = horarioRaw.split("–")
                        let turnoInicio = this.convertirAHorasEnMinutos(turnoInicioStr)
                        let turnoFin = this.convertirAHorasEnMinutos(turnoFinStr)

                        if (turnoFin <= turnoInicio) turnoFin += 1440
                        if (turnoInicio < 300) {
                            turnoInicio += 1440
                            turnoFin += 1440
                        }

                        const cubre = turnoInicio < intervaloFin && turnoFin > intervaloInicio
                        if (!cubre) return

                        let peso = 1 // valor por defecto

                        recesosDisponibles.forEach(recesoRaw => {
                            if (peso === 0) return;

                            const [recesoInicioStr, recesoFinStr] = recesoRaw.split("–")
                            let recesoInicio = this.convertirAHorasEnMinutos(recesoInicioStr)
                            let recesoFin = this.convertirAHorasEnMinutos(recesoFinStr)

                            if (recesoFin <= recesoInicio) recesoFin += 1440
                            if (recesoInicio < 300) {
                                recesoInicio += 1440
                                recesoFin += 1440
                            }

                            const minutosSuperpuestos = Math.max(0, Math.min(recesoFin, intervaloFin) - Math.max(recesoInicio, intervaloInicio))
                            const duracionIntervalo = intervaloFin - intervaloInicio
                            const porcentajeReceso = minutosSuperpuestos / duracionIntervalo

                            if (porcentajeReceso >= 0.75) {
                                peso = 0;
                            }
                            else if (porcentajeReceso >= 0.25 && porcentajeReceso < 0.75 && peso === 1) {
                                peso = 0.5;
                            }
                        })

                        total += peso
                    })


                    return total
                })
                const diferencia = asignados.map((valor, i) => valor - requeridos[i])


                graficasPorDia[dia] = {
                    intervalos,
                    asignados,
                    programados,
                    requeridos,
                    diferencia
                }
            })

            this.graficasPorDiaFinal = graficasPorDia
            //console.log(this.graficasPorDiaFinal);
        },
        generarDatosGraficasPorDiaFinal() {
            const graficasPorDia = {}
            let maximoGlobal = 0

            this.diasDisponibles.forEach(dia => {
                const diaEscenarios = this.planDiaModelo.filter(item => item.dia_semana === dia)

                const intervalos = diaEscenarios.map(e => e.intervalo_inicio)
                const programados = diaEscenarios.map(e => Math.round(e.programados))
                const requeridos = diaEscenarios.map(e => Math.round(e.requeridos))

                const asignados = diaEscenarios.map(e => {
                    let intervaloInicio = this.convertirAHorasEnMinutos(e.intervalo_inicio)
                    let intervaloFin = this.convertirAHorasEnMinutos(e.intervalo_fin)

                    if (intervaloFin <= intervaloInicio) intervaloFin += 1440
                    if (intervaloInicio < 300) {
                        intervaloInicio += 1440
                        intervaloFin += 1440
                    }

                    let total = 0

                    this.itemsTablaResumen.forEach(agente => {
                        const diaKey = dia.toLowerCase();
                        const horarioRaw = agente[`${diaKey}_horario`]

                        if (horarioRaw === "DS" || horarioRaw === "—" || !horarioRaw) return

                        // Usamos el separador que tenías originalmente (probablemente el guion largo – o normal -)
                        // Intentamos con ambos para asegurar que no se rompa
                        const separador = horarioRaw.includes("–") ? "–" : "-";
                        const partes = horarioRaw.split(separador);
                        if (partes.length < 2) return;

                        let turnoInicio = this.convertirAHorasEnMinutos(partes[0].trim())
                        let turnoFin = this.convertirAHorasEnMinutos(partes[1].trim())

                        if (turnoFin <= turnoInicio) turnoFin += 1440
                        if (turnoInicio < 300) {
                            turnoInicio += 1440
                            turnoFin += 1440
                        }

                        const cubre = turnoInicio < intervaloFin && turnoFin > intervaloInicio
                        if (!cubre) return

                        let peso = 1

                        // Lista de recesos del agente
                        const recesosDisponibles = [
                            agente[`${diaKey}_receso60`],
                            agente[`${diaKey}_receso30`],
                            agente[`${diaKey}_receso15`]
                        ].filter(r => r && r !== "DS" && r !== "—");

                        recesosDisponibles.forEach(recesoRaw => {
                            if (peso <= 0) return;

                            const sepR = recesoRaw.includes("–") ? "–" : "-";
                            const partesR = recesoRaw.split(sepR);
                            if (partesR.length < 2) return;

                            let recesoInicio = this.convertirAHorasEnMinutos(partesR[0].trim())
                            let recesoFin = this.convertirAHorasEnMinutos(partesR[1].trim())

                            if (recesoFin <= recesoInicio) recesoFin += 1440
                            if (recesoInicio < 300) {
                                recesoInicio += 1440
                                recesoFin += 1440
                            }

                            // Cálculo de solapamiento
                            const overlap = Math.max(0, Math.min(recesoFin, intervaloFin) - Math.max(recesoInicio, intervaloInicio))
                            const duracionInt = intervaloFin - intervaloInicio

                            if (duracionInt > 0) {
                                const porcentajeReceso = overlap / duracionInt
                                // Mantenemos tu lógica de umbrales pero más fluida
                                if (porcentajeReceso >= 0.75) {
                                    peso = 0;
                                } else if (porcentajeReceso > 0) {
                                    peso -= porcentajeReceso;
                                }
                            }
                        })

                        total += Math.max(0, peso)
                    })

                    return parseFloat(total.toFixed(2))
                })

                const maxDia = Math.max(...programados, ...requeridos, ...asignados);
                if (maxDia > maximoGlobal) maximoGlobal = maxDia;

                const diferencia = asignados.map((valor, i) => parseFloat((valor - programados[i]).toFixed(2))) //SE HIZO EL CAMBIO DE REQUERIDOS A PROGRAMADOS

                graficasPorDia[dia] = {
                    intervalos,
                    asignados,
                    programados,
                    requeridos,
                    diferencia
                }
            })

            this.maxEjeYFinal = Math.ceil(maximoGlobal * 1.15);
            this.graficasPorDiaFinal = graficasPorDia
        },
        //PROCESO 6
        generarProgramacionSemanalPorAgente() {
            const tabla = {};
            const agentesDisponibles = [];
            let agenteIndex = 1;
            const agentesDetalles = [];
            //console.log(this.resumenMaximos);

            this.resumenMaximos.forEach(turnoResumen => {
                const [inicio, fin] = turnoResumen.turno.split(" - ");
                const requerido = turnoResumen.requerido;

                this.diasDisponibles.forEach(dia => {
                    const turnoActivo = this.turnosServicio.find(t =>
                        t.intervalo_inicio === inicio &&
                        t.intervalo_fin === fin &&
                        t.dias_aplicables.includes(dia)
                    );

                    if (!turnoActivo) return;

                    const servicio = this.servicios.find(s => s.id === this.servicioId);

                    let auxiliaresParsed = servicio.auxiliares;

                    if (typeof auxiliaresParsed === 'string') {
                        try {
                            auxiliaresParsed = JSON.parse(auxiliaresParsed);
                        } catch (e) {
                            console.error('Error al parsear auxiliares:', e);
                            auxiliaresParsed = [];
                        }
                    }


                    let agentesAsignados = 0;
                    const horario = `${inicio}-${fin}`;
                    const jornadaHoras = this.calcularHoras(inicio, fin);
                    const recesos = this.obtenerRecesos(jornadaHoras, auxiliaresParsed);



                    for (const agente of agentesDisponibles) {
                        if (agentesAsignados >= requerido) break;

                        if (!tabla[agente][dia] && Object.values(tabla[agente]).includes(horario)) {
                            tabla[agente][dia] = horario;
                            agentesAsignados++;
                            agentesDetalles.push({ nombre: agente, dia, horario, jornada: jornadaHoras, recesos });
                        }
                    }

                    while (agentesAsignados < requerido) {
                        const nuevo = `Agente${String(agenteIndex).padStart(2, "0")}`;
                        agenteIndex++;

                        tabla[nuevo] = { [dia]: `${inicio}-${fin}` };
                        agentesDisponibles.push(nuevo);
                        agentesAsignados++;
                        agentesDetalles.push({ nombre: nuevo, dia, horario, jornada: jornadaHoras, recesos });
                    }
                });
            });

            this.programacionSemanal = tabla;
            this.detallesPorAgente = agentesDetalles;
            //this.asignarHorarioDeRecesoPorDemanda();

            //console.log(this.programacionSemanal);
        },
        //PROCESO 7
        asignarDescansosSemanales(programacion) {
            //console.log("Asignar:", programacion);
            const ordenDias = {
                "Domingo": 0,
                "Sábado": 1,
                "Viernes": 2,
                "Jueves": 3,
                "Miércoles": 4,
                "Martes": 5,
                "Lunes": 6
            };
            const servicio = this.servicios.find(s => s.id === this.servicioId);
            const descansosRequeridosPorAgente = servicio?.max_descansos_por_agente || 1;
            const demandaPorDia = this.calcularCargaPorDiaDesdeAsignacion();

            const coberturaPorDiaTurno = {};
            const descansosPorDiaTurno = {};
            const resultado = {};

            Object.entries(demandaPorDia).forEach(([dia, turnos]) => {
                coberturaPorDiaTurno[dia] = {};
                descansosPorDiaTurno[dia] = {};
                Object.keys(turnos).forEach(turnoRaw => {
                    const turno = this.normalizarTurno(turnoRaw);
                    coberturaPorDiaTurno[dia][turno] = 0;
                    descansosPorDiaTurno[dia][turno] = 0;
                });
            });

            Object.values(programacion).forEach(semana => {
                Object.entries(semana).forEach(([dia, turnoRaw]) => {
                    if (turnoRaw !== "—" && turnoRaw !== "DS") {
                        const turno = this.normalizarTurno(turnoRaw);
                        coberturaPorDiaTurno[dia][turno] += 1;
                    }
                });
            });

            const todosLosDias = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];

            const diasConDemandaCero = Object.entries(demandaPorDia)
                .filter(([, turnos]) => Object.values(turnos).every(demanda => demanda === 0))
                .map(([dia]) => dia);

            const diasFaltantes = todosLosDias.filter(dia => !(dia in demandaPorDia));

            const diasSinDemanda = [...diasFaltantes, ...diasConDemandaCero];


            Object.entries(programacion).forEach(([agente, semana]) => {
                const nuevaSemana = { ...semana };

                let descansosActuales = Object.values(nuevaSemana).filter(turno =>
                    turno === "—" || turno === "DS"
                ).length;

                if (descansosActuales >= descansosRequeridosPorAgente) {
                    resultado[agente] = nuevaSemana;
                    return;
                }

                let faltantes = descansosRequeridosPorAgente - descansosActuales;

                /*for (const dia of diasSinDemanda) {
                    const turnoRaw = nuevaSemana[dia];

                    if (faltantes > 0 && (turnoRaw === undefined || (turnoRaw !== "—" && turnoRaw !== "DS"))) {

                        nuevaSemana[dia] = "DS";
                        faltantes--;
                        descansosActuales++;

                        if (dia in demandaPorDia) {
                            const turno = this.normalizarTurno(turnoRaw);
                            if (coberturaPorDiaTurno[dia] && coberturaPorDiaTurno[dia][turno] !== undefined) {
                                coberturaPorDiaTurno[dia][turno] -= 1;
                                descansosPorDiaTurno[dia][turno] += 1;
                            }
                        }
                    }
                }*/
                for (const dia of diasSinDemanda) {
                    const turnoRaw = nuevaSemana[dia];

                    // 1. Forzamos que cualquier día sin demanda sea "DS" visualmente
                    if (turnoRaw === undefined || turnoRaw === "—") {
                        nuevaSemana[dia] = "DS";

                        // 2. Solo si al agente LE FALTABAN descansos, descontamos de la cuota
                        if (faltantes > 0) {
                            faltantes--;
                            descansosActuales++;
                        }
                    }
                    // 3. Si el día tiene un turno asignado pero el día es "Sin Demanda",
                    // también lo convertimos a descanso para liberar al agente.
                    else if (turnoRaw !== "DS") {
                        nuevaSemana[dia] = "DS";

                        if (faltantes > 0) {
                            faltantes--;
                            descansosActuales++;
                        }

                        // Actualizamos contadores de cobertura si el turno existía
                        if (dia in demandaPorDia) {
                            const turno = this.normalizarTurno(turnoRaw);
                            if (coberturaPorDiaTurno[dia] && coberturaPorDiaTurno[dia][turno] !== undefined) {
                                coberturaPorDiaTurno[dia][turno] -= 1;
                                descansosPorDiaTurno[dia][turno] += 1;
                            }
                        }
                    }
                }

                if (descansosActuales >= descansosRequeridosPorAgente) {
                    resultado[agente] = nuevaSemana;
                    return;
                }


                /*const opcionesViables = Object.entries(nuevaSemana).filter(([dia, turnoRaw]) => {
                    if (turnoRaw === "—" || turnoRaw === "DS") return false;

                    if (!(dia in demandaPorDia)) return false;

                    const turno = this.normalizarTurno(turnoRaw);
                    const demanda = demandaPorDia[dia][turno];

                    if (demanda === 0) return false;

                    const cobertura = coberturaPorDiaTurno[dia][turno];
                    return cobertura > demanda;
                });*/
                const opcionesViables = Object.entries(nuevaSemana).filter(([dia, turnoRaw]) => {
                    if (turnoRaw === "—" || turnoRaw === "DS") return false;
                    const turno = this.normalizarTurno(turnoRaw);

                    const cobertura = coberturaPorDiaTurno[dia][turno];
                    const demanda = demandaPorDia[dia][turno];

                    // EL CAMBIO CLAVE:
                    // En lugar de cobertura > demanda, permitimos cobertura >= demanda.
                    // Esto permite que el agente descanse aunque la línea azul quede 
                    // EXACTAMENTE igual a la roja.
                    //return cobertura >= demanda;
                    return cobertura > 0;
                });


                /*// Recorremos cada agente
                Object.entries(programacion).forEach(([agente, semana]) => {
                    const nuevaSemana = { ...semana };
    
                    let descansosActuales = Object.values(nuevaSemana).filter(turno =>
                        turno === "—" || turno === "DS"
                    ).length;
                    // Si ya tiene suficientes descansos, no modificar
                    if (descansosActuales >= descansosRequeridosPorAgente) {
                        resultado[agente] = nuevaSemana;
                        return;
                    }
    
                    // Buscar días viables para descansar
                    //console.log(nuevaSemana);
                    const opcionesViables = Object.entries(nuevaSemana).filter(([dia, turnoRaw]) => {
                        if (turnoRaw === "—" || turnoRaw === "DS") return false;
                        const turno = this.normalizarTurno(turnoRaw);
                        const cobertura = coberturaPorDiaTurno[dia][turno];
                        const demanda = demandaPorDia[dia][turno];
                        const descansosTurno = descansosPorDiaTurno[dia][turno];
                        const margen = cobertura - demanda;
    
                        return margen > 0 && descansosTurno <= margen;
                    });*/

                opcionesViables.sort((a, b) => {
                    const diaA = a[0];
                    const turnoA = this.normalizarTurno(a[1]);
                    const diaB = b[0];
                    const turnoB = this.normalizarTurno(b[1]);

                    //const demandaA = demandaPorDia[a[0]][turnoA];
                    //const demandaB = demandaPorDia[b[0]][turnoB];
                    const holguraA = coberturaPorDiaTurno[diaA][turnoA] - demandaPorDia[diaA][turnoA];
                    const holguraB = coberturaPorDiaTurno[diaB][turnoB] - demandaPorDia[diaB][turnoB];
                    //return demandaA - demandaB;
                    if (holguraA !== holguraB) {
                        return holguraB - holguraA; // Descendente: de más sobra a menos sobra
                    }

                    // 2. Si la holgura es igual, priorizamos el que tenga MENOR demanda absoluta
                    const demandaA = demandaPorDia[diaA][turnoA];
                    const demandaB = demandaPorDia[diaB][turnoB];
                    if (demandaA !== demandaB) {
                        return demandaA - demandaB;
                    }

                });
                /*opcionesViables.sort((a, b) =>
                    descansosPorDiaTurno[a[0]][this.normalizarTurno(a[1])] -
                    descansosPorDiaTurno[b[0]][this.normalizarTurno(b[1])]
                );*/

                // Asignar descansos faltantes
                //let faltantes = descansosRequeridosPorAgente - descansosActuales;
                while (faltantes > 0 && opcionesViables.length > 0) {
                    const [diaSeleccionado, turnoRaw] = opcionesViables.shift();
                    const turno = this.normalizarTurno(turnoRaw);

                    nuevaSemana[diaSeleccionado] = "DS";
                    coberturaPorDiaTurno[diaSeleccionado][turno] -= 1;
                    descansosPorDiaTurno[diaSeleccionado][turno] += 1;
                    faltantes--;
                }

                resultado[agente] = nuevaSemana;
            });
            //console.log("Cobertura calculada:", coberturaPorDiaTurno["Domingo"]["07:00:00-13:00:00"]);
            return resultado;

        },
        generarProgramacionConDescansos(programacionOriginal, esEdicionManual = false) {
            return new Promise((resolve) => {
                this.cargandoEdicion = true;
                setTimeout(() => {
                    try {
                        //console.log("Inicio de la función de asignación de Descansos.");
                        //console.log("Programacion original:", programacionOriginal);
                        const servicio = this.servicios.find(s => s.id === this.servicioId);
                        //console.log("Servicio:", servicio);
                        const descansosRequeridosPorAgente = servicio?.max_descansos_por_agente || 1;
                        //console.log("Descansos requeridos:", descansosRequeridosPorAgente);
                        let programacion = this.asignarDescansosSemanales(programacionOriginal);
                        //console.log("Programacion:", programacion);

                        if (!esEdicionManual) {
                            let agentesFaltantes = Object.entries(programacion).filter(([_, semana]) => {
                                const descansos = Object.values(semana).filter(t => t === "DS" || t === "—").length;
                                return descansos < descansosRequeridosPorAgente;
                            });
                            //console.log("agentes Faltantes:", agentesFaltantes);

                            let contador = 1;

                            while (agentesFaltantes.length > 0) {
                                //console.log(`Bucle WHILE: Iteración ${contador}. Faltan: ${agentesFaltantes.length}`);
                                const turnoBase = Object.values(agentesFaltantes[0][1]).find(t => t !== "DS" && t !== "—");
                                //console.log(turnoBase);
                                const turnoAsignado = this.normalizarTurno(turnoBase);
                                const nuevoAgente = `AgenteExtra_${contador++}`;
                                programacion[nuevoAgente] = {};

                                Object.keys(agentesFaltantes[0][1]).forEach(dia => {
                                    programacion[nuevoAgente][dia] = turnoAsignado;
                                });

                                programacion = this.asignarDescansosSemanales(programacion);
                                //console.log('programacion', programacion);

                                if (contador > 500) {
                                    console.error("ALERTA: Bucle de asignación forzada excede 500 iteraciones. Deteniendo.");
                                    break;
                                }
                                contador++;

                                // Verificamos si aún hay agentes sin descanso
                                agentesFaltantes = Object.entries(programacion).filter(([_, semana]) => {
                                    const descansos = Object.values(semana).filter(t => t === "DS" || t === "—").length;
                                    return descansos < descansosRequeridosPorAgente;
                                });
                            }
                        } else {
                            console.log("Modo edición manual detectado: No se crearán agentes extra.");
                        }

                        const programacionOrdenada = this.ordenarProgramacionPorTurno(programacion);
                        //console.log(programacionOrdenada);
                        this.programacionSemanalFinal = programacionOrdenada;
                        const diasSemana = [
                            ...new Set(
                                Object.values(this.programacionSemanalFinal)
                                    .flatMap(semana => Object.keys(semana))
                            )
                        ];

                        diasSemana.forEach(dia => {
                            this.resumenRealFinal[dia] = this.generarResumenDesdeProgramacionFinal(this.programacionSemanalFinal, dia);
                        });

                        //console.log(this.resumenRealFinal);
                        this.detalleRealFinal = this.generarDetalleDesdeResumenRealFinalMultiDia();
                        const resumenAgentes = {};

                        this.detalleRealFinal.forEach(a => {
                            const clave = a.nombre;

                            if (!resumenAgentes[clave]) {
                                resumenAgentes[clave] = {
                                    nombre: a.nombre,
                                    horario: a.horario,
                                    jornada: a.jornada.toFixed(2),
                                    recesos: a.recesos.map(r => `${r.tipo} (${r.duracion})`),
                                    dias: [a.dia]
                                };
                            } else {
                                resumenAgentes[clave].dias.push(a.dia);
                            }
                        });

                        this.itemsAgente = Object.values(resumenAgentes).map(a => ({
                            ...a,
                            recesos: a.recesos.join(', '),
                            dias: [...new Set(a.dias)].join(', ')
                        }));
                        this.programacionConDescansos = programacionOrdenada;
                        //console.log(this.programacionConDescansos);
                        this.$nextTick(() => {
                            //console.log('pasaremos a recesos');
                            this.actualizarTablaConDescansos(this.programacionConDescansos);
                            this.generarDatosGraficasPorDiaDescansos();
                            resolve();
                            //this.asignarHorarioDeRecesoPorDemanda3(this.programacionSemanalFinal);
                        });
                    } catch (error) {
                        console.error("Error al generar programación con descansos:", error);
                        resolve();
                    } finally {
                        this.cargandoEdicion = false;
                    }
                }, 200);
            });
        },
        resetearDescansos(programacion) {
            const gruposPorTurno = {};
            const nuevaProgramacion = {};

            Object.entries(programacion).forEach(([agente, semana]) => {
                nuevaProgramacion[agente] = {};

                // Detectar el turno base del agente (el más repetido)
                const turnosValidos = Object.values(semana).filter(t => t !== "DS" && t !== "—");
                const turnoBase = turnosValidos[0] || "07:00:00-13:00:00"; // fallback

                Object.entries(semana).forEach(([dia, turno]) => {
                    if (turno === "DS" || turno === "—") {
                        nuevaProgramacion[agente][dia] = turnoBase;
                    } else {
                        nuevaProgramacion[agente][dia] = turno;
                    }
                });
            });

            return nuevaProgramacion;
        },
        ordenarProgramacionPorTurno(programacion) {
            const gruposPorTurno = {};
            const nombreMapeado = {};

            Object.entries(programacion).forEach(([agente, semana]) => {
                const turnosValidos = Object.values(semana).filter(t => t !== "DS" && t !== "—");
                const turnoBase = turnosValidos[0] || "07:00:00-13:00:00";

                if (!gruposPorTurno[turnoBase]) gruposPorTurno[turnoBase] = [];

                gruposPorTurno[turnoBase].push({ agente, semana });
            });

            const programacionOrdenada = {};
            let contador = 1;

            const ordenMap = new Map();
            this.turnosServicio.forEach((turno, index) => {
                const turnoKey = `${turno.intervalo_inicio}-${turno.intervalo_fin}`;
                // La clave es el string del turno, el valor es su posición (índice)
                ordenMap.set(turnoKey, index);
            });

            // 3. ORDENAMIENTO USANDO EL MAPA DE PRIORIDAD
            const turnosOrdenados = Object.keys(gruposPorTurno).sort((a, b) => {
                // Obtener el índice del turno del mapa. Si no se encuentra, usa Infinity para enviarlo al final.
                const indexA = ordenMap.has(a) ? ordenMap.get(a) : Infinity;
                const indexB = ordenMap.has(b) ? ordenMap.get(b) : Infinity;

                return indexA - indexB;
            });

            /*const turnosOrdenados = Object.keys(gruposPorTurno).sort((a, b) => {
                const horaA = a.split("-")[0];
                const horaB = b.split("-")[0];
                return horaA.localeCompare(horaB);
            });*/
            //const turnosOrdenados = Object.keys(gruposPorTurno);


            turnosOrdenados.forEach(turno => {
                const grupo = gruposPorTurno[turno];

                grupo.sort((a, b) => {
                    const esExtraA = a.agente.startsWith("AgenteExtra_");
                    const esExtraB = b.agente.startsWith("AgenteExtra_");
                    return esExtraA - esExtraB; // titulares primero
                });

                grupo.forEach(({ agente, semana }) => {
                    const nuevoNombre = `Agente${String(contador).padStart(2, "0")}`;
                    nombreMapeado[agente] = nuevoNombre;
                    programacionOrdenada[nuevoNombre] = semana;
                    contador++;
                });
            });
            //console.log(programacionOrdenada);
            return programacionOrdenada;
        },
        generarResumenDesdeProgramacionFinal(programacion, diaObjetivo) {
            const resumen = {};

            for (const agente in programacion) {
                const dias = programacion[agente];
                const turno = dias[diaObjetivo];

                if (!turno || turno === 'DS') continue; // Ignorar descansos

                const clave = turno.trim();
                resumen[clave] = (resumen[clave] || 0) + 1;
            }

            // Convertir a array tipo resumenMaximos
            const resultado = Object.entries(resumen).map(([turno, requerido]) => ({
                turno: turno.replace("-", " - "),
                requerido
            }));

            return resultado;
        },
        generarDetalleDesdeResumenRealFinalMultiDia() {
            const agentesDetalles = [];
            const tabla = {};
            const agentesDisponibles = [];
            let agenteIndex = 1;

            Object.entries(this.resumenRealFinal).forEach(([dia, resumenTurnos]) => {
                resumenTurnos.forEach(turnoResumen => {
                    const [inicio, fin] = turnoResumen.turno.split(" - ");
                    const requerido = turnoResumen.requerido;

                    const turnoActivo = this.turnosServicio.find(t =>
                        t.intervalo_inicio === inicio &&
                        t.intervalo_fin === fin &&
                        t.dias_aplicables.includes(dia)
                    );

                    if (!turnoActivo) return;

                    const servicio = this.servicios.find(s => s.id === this.servicioId);
                    let auxiliaresParsed = typeof servicio.auxiliares === 'string'
                        ? JSON.parse(servicio.auxiliares)
                        : servicio.auxiliares;

                    const horario = `${inicio}-${fin}`;
                    const jornadaHoras = this.calcularHoras(inicio, fin);
                    const recesos = this.obtenerRecesos(jornadaHoras, auxiliaresParsed);

                    let agentesAsignados = 0;

                    // Buscar agentes activos ese día
                    const agentesActivos = Object.entries(this.programacionSemanalFinal)
                        .filter(([nombre, dias]) => dias[dia] && dias[dia] !== "DS")
                        .map(([nombre]) => nombre);

                    for (const agente of agentesDisponibles) {
                        if (agentesAsignados >= requerido) break;
                        if (!tabla[agente]?.[dia] && Object.values(tabla[agente] || {}).includes(horario)) {
                            tabla[agente][dia] = horario;
                            agentesAsignados++;
                            agentesDetalles.push({ nombre: agente, dia, horario, jornada: jornadaHoras, recesos });
                        }
                    }

                    // Crear nuevos agentes si faltan
                    while (agentesAsignados < requerido) {
                        const nuevo = `Agente${String(agenteIndex).padStart(2, "0")}`;
                        agenteIndex++;

                        tabla[nuevo] = { [dia]: horario };
                        agentesDisponibles.push(nuevo);
                        agentesAsignados++;
                        agentesDetalles.push({ nombre: nuevo, dia, horario, jornada: jornadaHoras, recesos });
                    }
                });
            });

            return agentesDetalles;

        },
        //PROCESO 8
        /////////PRUEBAS DE NUEVA LOGICA
        asignarHorarioDeRecesoPorDemanda3(programacionBase) {
            this.cargandoEdicion = true;
            setTimeout(() => {
                try {
                    const programacion = JSON.parse(JSON.stringify(programacionBase));
                    this.descansosFinales = [];
                    this.agentesSinReceso = [];

                    const servicio = this.servicios.find(s => s.id === this.servicioId);
                    if (!servicio) {
                        this.cargandoEdicion = false;
                        return;
                    }

                    this.auxiliaresParsed = typeof servicio.auxiliares === 'string'
                        ? JSON.parse(servicio.auxiliares)
                        : servicio.auxiliares;

                    const mapaCapacidad = this.generarMapaCapacidad(programacion);
                    const agentesADistribuir = this.prepararListaAgentes(programacion);
                    //console.log("agentesADistribuir:", agentesADistribuir);

                    // PASO A: BLOQUEO PREVENTIVO (Respetar lo que ya existe en la tabla)
                    agentesADistribuir.forEach(agente => {
                        agente.recesos.forEach(regla => {
                            const duracionMin = this.convertirDuracionAHorasEnMinutos2(regla.duracion);
                            const valorEnTabla = agente.recesosActualesEnTabla[duracionMin];
                            // ESTE LOG TE DIRÁ LA VERDAD
                            //console.log(`Buscando bloqueo para ${agente.nombre} (${agente.dia}): Encontrado en tabla -> "${valorEnTabla}"`);
                            // Si ya tiene un horario (No es guion ni descanso)
                            if (valorEnTabla && valorEnTabla !== "—" && valorEnTabla !== "-" && valorEnTabla !== "DS") {
                                //console.log("✅ BLOQUEO EXITOSO para:", agente.nombre);
                                const partes = valorEnTabla.split(/[–-]/).map(h => h.trim());
                                const inicioMin = this.convertirAHorasEnMinutos2(partes[0]);
                                const finMin = this.convertirAHorasEnMinutos2(partes[1]);

                                this.descansosFinales.push({
                                    agente: agente.nombre,
                                    dia: agente.dia,
                                    bloque: valorEnTabla,
                                    duracion: duracionMin
                                });

                                // Bloqueamos el espacio en el mapa antes de que cualquier otro agente busque
                                this.actualizarMapaCapacidad(mapaCapacidad, agente.dia, inicioMin, finMin);
                                regla._yaAsignadoFijo = true; // Marca interna
                            }
                            else {
                                //console.log("❌ NO SE BLOQUEÓ: Se calculará de nuevo.");
                                regla._yaAsignadoFijo = false;
                            }
                        });
                    });

                    // PASO B: ASIGNACIÓN POR DEMANDA (Solo para los que tienen "—")
                    agentesADistribuir.forEach(agente => {
                        agente.recesos.forEach(regla => {
                            if (regla._yaAsignadoFijo) return; // Saltamos los que ya bloqueamos arriba

                            const duracionMin = this.convertirDuracionAHorasEnMinutos2(regla.duracion);
                            const mejorMomento = this.buscarMejorHueco(agente, regla, duracionMin, mapaCapacidad);

                            if (mejorMomento) {
                                const bloqueFinal = `${this.convertirMinutosAHoras2(mejorMomento.inicio)}–${this.convertirMinutosAHoras2(mejorMomento.fin)}`;

                                this.descansosFinales.push({
                                    agente: agente.nombre,
                                    dia: agente.dia,
                                    bloque: bloqueFinal,
                                    duracion: duracionMin
                                });

                                this.actualizarMapaCapacidad(mapaCapacidad, agente.dia, mejorMomento.inicio, mejorMomento.fin);
                                agente.recesos_asignados.push(duracionMin);
                            } else {
                                this.agentesSinReceso.push({
                                    nombre: agente.nombre,
                                    dia: agente.dia,
                                    duracionFaltante: duracionMin
                                });
                            }
                        });
                    });

                    this.procesarTabla();
                    this.generarDatosGraficasPorDiaRecesos();
                    this.$set(this, 'descansosFinales', [...this.descansosFinales]);
                } catch (e) {
                    console.error('Error al asignar horario de receso por demanda:', e);
                } finally {
                    this.cargandoEdicion = false;
                }
            }, 200);
        },
        asignarHorarioDeRecesoPorDemanda35(programacionBase) {
            console.log("Iniciando asignación de recesos protegida...");
            this.cargando = true;

            const programacion = JSON.parse(JSON.stringify(programacionBase));
            this.descansosFinales = [];
            this.agentesSinReceso = [];

            const servicio = this.servicios.find(s => s.id === this.servicioId);
            if (!servicio) {
                console.error("No se encontró el servicio");
                this.cargando = false;
                return;
            }

            let auxiliaresParsed = typeof servicio.auxiliares === 'string'
                ? JSON.parse(servicio.auxiliares)
                : servicio.auxiliares;

            this.auxiliaresParsed = auxiliaresParsed;

            // 1. Generamos el mapa de capacidad inicial (basado en turnos totales)
            const mapaCapacidad = this.generarMapaCapacidad(programacion);

            // 2. Preparamos la lista de agentes (esta ya trae recesosActualesEnTabla)
            const agentesADistribuir = this.prepararListaAgentes(programacion);


            // --- FASE 1: BLOQUEO DE RECESOS EXISTENTES ---
            // Recorremos todos los agentes para encontrar quién ya tiene horario en la tabla
            agentesADistribuir.forEach(agente => {
                agente.recesos.forEach(regla => {
                    const duracionMin = this.convertirDuracionAHorasEnMinutos2(regla.duracion);
                    const valorEnTabla = agente.recesosActualesEnTabla[duracionMin];

                    // Si el valor NO es un guion o descanso, es un horario fijo que debemos respetar
                    if (valorEnTabla && valorEnTabla !== "—" && valorEnTabla !== "-" && valorEnTabla !== "DS") {
                        const partes = valorEnTabla.split(/[–-]/).map(h => h.trim());
                        const inicioMin = this.convertirAHorasEnMinutos2(partes[0]);
                        const finMin = this.convertirAHorasEnMinutos2(partes[1]);

                        // Lo añadimos directamente a los resultados finales sin pasar por buscarMejorHueco
                        this.descansosFinales.push({
                            agente: agente.nombre,
                            dia: agente.dia,
                            bloque: valorEnTabla,
                            duracion: duracionMin
                        });

                        // RESTAMOS la capacidad del mapa para que los agentes nuevos NO elijan este hueco
                        this.actualizarMapaCapacidad(mapaCapacidad, agente.dia, inicioMin, finMin);

                        // Marcamos la regla como "procesada" para ignorarla en la Fase 2
                        regla._yaProcesado = true;
                    }
                });
            });

            // --- FASE 2: ASIGNACIÓN POR DEMANDA PARA HUECOS VACÍOS ("—") ---
            // Ahora procesamos solo lo que falta (como tu nuevo Agente 71)
            agentesADistribuir.forEach(agente => {
                agente.recesos.forEach(regla => {
                    // Si ya fue bloqueado en la Fase 1, saltamos
                    if (regla._yaProcesado) return;

                    const duracionMin = this.convertirDuracionAHorasEnMinutos2(regla.duracion);

                    // Buscamos el mejor hueco basado en lo que quedó LIBRE en el mapa
                    const mejorMomento = this.buscarMejorHueco(agente, regla, duracionMin, mapaCapacidad);

                    if (mejorMomento) {
                        const bloqueFinal = `${this.convertirMinutosAHoras2(mejorMomento.inicio)}–${this.convertirMinutosAHoras2(mejorMomento.fin)}`;

                        this.descansosFinales.push({
                            agente: agente.nombre,
                            dia: agente.dia,
                            bloque: bloqueFinal,
                            duracion: duracionMin
                        });

                        // Actualizamos el mapa con el nuevo receso
                        this.actualizarMapaCapacidad(mapaCapacidad, agente.dia, mejorMomento.inicio, mejorMomento.fin);
                        agente.recesos_asignados.push(duracionMin);
                    } else {
                        // Si no hay espacio ni rompiendo cobertura
                        this.agentesSinReceso.push({
                            nombre: agente.nombre,
                            dia: agente.dia,
                            duracionFaltante: duracionMin
                        });
                    }
                });
            });

            // 3. Finalizamos el proceso
            this.procesarTabla();
            this.generarDatosGraficasPorDiaRecesos();
            this.cargando = false;

            // Forzamos la reactividad de Vue
            this.$set(this, 'descansosFinales', [...this.descansosFinales]);
        },
        asignarHorarioDeRecesoPorDemanda34(programacionBase) {
            console.log(programacionBase);
            this.cargando = true;
            const programacion = JSON.parse(JSON.stringify(programacionBase));
            this.descansosFinales = [];
            this.agentesSinReceso = [];

            const servicio = this.servicios.find(s => s.id === this.servicioId);
            if (!servicio) {
                console.error("No se encontró el servicio");
                this.cargando = false;
                return;
            }

            let auxiliaresParsed = typeof servicio.auxiliares === 'string'
                ? JSON.parse(servicio.auxiliares)
                : servicio.auxiliares;

            this.auxiliaresParsed = auxiliaresParsed;

            const mapaCapacidad = this.generarMapaCapacidad(programacion);

            const agentesADistribuir = this.prepararListaAgentes(programacion);

            agentesADistribuir.sort(() => Math.random() - 0.5);
            agentesADistribuir.sort((a, b) => a.recesos.length - b.recesos.length);

            agentesADistribuir.forEach(agente => {
                agente.recesos.forEach(regla => {
                    const duracionMin = this.convertirDuracionAHorasEnMinutos2(regla.duracion);

                    const valorEnTabla = agente.recesosActualesEnTabla[duracionMin];
                    let bloqueFinal = null;
                    let inicioMin = null;
                    let finMin = null;

                    if (valorEnTabla && valorEnTabla !== "—" && valorEnTabla !== "DS") {
                        // CASO 1: RESPETAR EXISTENTE
                        bloqueFinal = valorEnTabla;
                        const partes = valorEnTabla.split(/[–-]/).map(h => h.trim());
                        inicioMin = this.convertirAHorasEnMinutos2(partes[0]);
                        finMin = this.convertirAHorasEnMinutos2(partes[1]);
                    } else {
                        // CASO 2: BUSCAR HUECO POR DEMANDA
                        const mejorMomento = this.buscarMejorHueco(agente, regla, duracionMin, mapaCapacidad);
                        if (mejorMomento) {
                            bloqueFinal = `${this.convertirMinutosAHoras2(mejorMomento.inicio)}–${this.convertirMinutosAHoras2(mejorMomento.fin)}`;
                            inicioMin = mejorMomento.inicio;
                            finMin = mejorMomento.fin;
                        }
                    }

                    if (bloqueFinal) {
                        this.descansosFinales.push({
                            agente: agente.nombre,
                            dia: agente.dia,
                            bloque: bloqueFinal,
                            duracion: duracionMin
                        });

                        this.actualizarMapaCapacidad(mapaCapacidad, agente.dia, inicioMin, finMin);
                        agente.recesos_asignados.push(duracionMin);
                    } else {
                        this.agentesSinReceso.push({
                            nombre: agente.nombre,
                            dia: agente.dia,
                            duracionFaltante: duracionMin
                        });
                    }
                });
            });

            this.procesarTabla();
            this.generarDatosGraficasPorDiaRecesos();
            this.cargando = false;
            this.$set(this, 'descansosFinales', [...this.descansosFinales]);
            //console.log(this.descansosFinales);
        },

        // --- FUNCIONES AUXILIARES DE APOYO ---

        generarMapaCapacidad(programacion) {
            const mapa = {};
            if (!this.planDiaModelo) return {};

            this.planDiaModelo.forEach(it => {
                // Normalizamos la hora de la demanda: "07:00:00" -> "07:00"
                const horaDemanda = it.intervalo_inicio.substring(0, 5);
                const clave = `${it.dia_semana}-${horaDemanda}`;

                // Filtramos agentes activos en este intervalo
                const agentesEnTurno = Object.values(programacion).filter(semana => {
                    const turno = semana[it.dia_semana];
                    if (!turno || turno === "DS" || turno === "—") return false;
                    return this.turnoCubreIntervalo(turno, horaDemanda);
                }).length;

                // Holgura = Programados en turnos - Requeridos por demanda
                mapa[clave] = agentesEnTurno - (it.requeridos || 0);
            });
            return mapa;
        },

        buscarMejorHueco(agente, regla, duracion, mapa) {
            const [inicioT, finT] = agente.horario.split("-").map(h => this.convertirAHorasEnMinutos2(h));
            let finAjustado = finT <= inicioT ? finT + 1440 : finT;

            const ventanaInicio = inicioT + (regla.min_desde_inicio_min || 60);
            const ventanaFin = finAjustado - (regla.max_antes_fin_min || 60) - duracion;

            let mejorInicio = null;
            let maximaPuntuacion = -Infinity;
            let rompeCoberturaEnMejorOpcion = false;

            for (let t = ventanaInicio; t <= ventanaFin; t += 15) {
                let holguraSuma = 0;
                let penalizacionCobertura = 0;
                let intervalosContados = 0;
                let detectadaRupturaEnEstePunto = false;

                for (let check = t; check < t + duracion; check += 30) {
                    const clave = `${agente.dia}-${this.convertirMinutosAHoras2(check)}`;
                    const holguraActual = (mapa[clave] || 0);

                    // --- LÓGICA DE PROTECCIÓN ---
                    if (holguraActual <= 0) {
                        // Penalizamos el score pero marcamos que aquí se rompe la línea
                        penalizacionCobertura -= 1000;
                        detectadaRupturaEnEstePunto = true;
                    } else if (holguraActual === 1) {
                        penalizacionCobertura -= 100;
                    }

                    holguraSuma += holguraActual;
                    intervalosContados++;
                }

                const holguraMedia = holguraSuma / intervalosContados;
                const puntuacionActual = holguraMedia + penalizacionCobertura + (Math.random() * 0.1);

                if (puntuacionActual >= maximaPuntuacion) {
                    maximaPuntuacion = puntuacionActual;
                    mejorInicio = t;
                    // Guardamos si la opción ganadora es "peligrosa"
                    rompeCoberturaEnMejorOpcion = detectadaRupturaEnEstePunto;
                }
            }

            // --- LA ALERTA DE CONSOLA ---
            if (rompeCoberturaEnMejorOpcion && mejorInicio !== null) {
                /*console.warn(
                    `⚠️ RUPTURA DE COBERTURA: El agente ${agente.agente} tomará su receso de ${duracion} min el ${agente.dia} a las ${this.convertirMinutosAHoras2(mejorInicio)} ` +
                    `porque NO hay agentes extra disponibles en ninguna de sus ventanas permitidas.`
                );*/
            }

            return mejorInicio !== null ? { inicio: mejorInicio, fin: mejorInicio + duracion } : null;
        },

        actualizarMapaCapacidad(mapa, dia, inicio, fin) {
            for (let t = inicio; t < fin; t += 30) {
                const clave = `${dia}-${this.convertirMinutosAHoras2(t)}`;
                if (mapa[clave] !== undefined) mapa[clave] -= 1; // Restamos la capacidad del agente en receso
            }
        },
        turnoCubreIntervalo(horarioTurno, horaEvaluar) {
            // Limpiamos formatos: "07:00:00-13:00:00" -> ["07:00", "13:00"]
            const partes = horarioTurno.split("-").map(h => h.trim().substring(0, 5));
            if (partes.length < 2) return false;

            const inicio = this.convertirAHorasEnMinutos2(partes[0]);
            const fin = this.convertirAHorasEnMinutos2(partes[1]);
            const actual = this.convertirAHorasEnMinutos2(horaEvaluar.substring(0, 5));

            let finAjustado = fin <= inicio ? fin + 1440 : fin;
            let actualAjustado = (actual < inicio && finAjustado > 1440) ? actual + 1440 : actual;

            return actualAjustado >= inicio && actualAjustado < finAjustado;
        },

        prepararListaAgentes(programacion) {
            //console.log('programacion', programacion);
            //console.log('itemsTablaResumen', this.itemsTablaResumen);
            const lista = [];
            const dias = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];

            Object.entries(programacion).forEach(([nombre, semana]) => {
                const agenteResumen = this.itemsTablaResumen.find(a => {
                    // Quitamos espacios y pasamos a minúsculas AMBOS nombres antes de comparar
                    const nombreEnResumen = a.agente.toString().replace(/\s+/g, '').toLowerCase();
                    const nombreEnProgramacion = nombre.toString().replace(/\s+/g, '').toLowerCase();

                    return nombreEnResumen === nombreEnProgramacion;
                });
                /*if (agenteResumen) {
                    console.log("Datos encontrados para bloqueo:", agenteResumen);
                }*/

                dias.forEach(dia => {
                    const turno = semana[dia];
                    if (turno && turno !== "DS" && turno !== "—") {
                        const [hInicio, hFin] = turno.split("-").map(h => h.trim().substring(0, 5));
                        const duracionJornada = this.calcularHoras2(hInicio, hFin);

                        // Obtener reglas (Asegúrate que this.auxiliaresParsed esté cargado)
                        const reglas = this.obtenerRecesos(duracionJornada, this.auxiliaresParsed) || [];

                        const key = dia.toLowerCase();
                        const recesosActualesEnTabla = {
                            60: agenteResumen ? agenteResumen[`${key}_receso60`] : "—",
                            30: agenteResumen ? agenteResumen[`${key}_receso30`] : "—",
                            15: agenteResumen ? agenteResumen[`${key}_receso15`] : "—"
                        };

                        lista.push({
                            nombre,
                            dia,
                            horario: turno,
                            recesos: JSON.parse(JSON.stringify(reglas)),
                            recesos_asignados: [],
                            recesosActualesEnTabla
                        });
                    }
                });
            });
            return lista;
        },

        // Convierte duración (ej: "00:30") a minutos enteros (30)
        convertirDuracionAHorasEnMinutos2(duracion) {
            if (!duracion) return 0;
            const [hrs, min] = duracion.split(':').map(Number);
            return (hrs * 60) + min;
        },
        convertirAHorasEnMinutos2(h) {
            const [hrs, min] = h.split(':').map(Number);
            return (hrs * 60) + min;
        },

        convertirMinutosAHoras2(totalMinutos) {
            let m = totalMinutos % 1440;
            if (m < 0) m += 1440;
            const hrs = Math.floor(m / 60);
            const min = m % 60;
            return `${hrs.toString().padStart(2, '0')}:${min.toString().padStart(2, '0')}`;
        },

        calcularHoras2(inicio, fin) {
            const start = this.convertirAHorasEnMinutos2(inicio);
            const end = this.convertirAHorasEnMinutos2(fin);
            let diff = end - start;
            if (diff < 0) diff += 1440; // Manejo de cruce de medianoche
            return diff / 60;
        },

        ///////////////////////////////////
        asignarHorarioDeRecesoPorDemanda33(programacionBase) {
            const programacion = JSON.parse(JSON.stringify(programacionBase));
            //console.log(programacion);

            const agentesConReceso = new Set();
            const descansosFinales = [];


            const ordenDias = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];

            const planOrdenado = [...this.planDiaModelo].sort((a, b) => {
                return ordenDias.indexOf(a.dia_semana) - ordenDias.indexOf(b.dia_semana);
            });
            const servicio = this.servicios.find(s => s.id === this.servicioId);
            let auxiliaresParsed = typeof servicio.auxiliares === 'string'
                ? JSON.parse(servicio.auxiliares)
                : servicio.auxiliares;
            this.auxiliaresParsed = auxiliaresParsed;

            const agentesDisponiblesTodos = Object.entries(programacion)
                .map(([nombre, semana]) => {
                    return ordenDias.map(dia => {
                        const turno = semana[dia];
                        if (!turno || turno === "DS" || turno === "—") return null;

                        const [inicioTurno, finTurno] = turno.split("-");
                        const jornadaHoras = this.calcularHoras(inicioTurno, finTurno);
                        const recesos = this.obtenerRecesos(jornadaHoras, this.auxiliaresParsed) || [];
                        //console.log(recesos);

                        return {
                            nombre,
                            dia,
                            horario: turno,
                            jornada: jornadaHoras,
                            recesos,
                            recesos_asignados_duracion: new Set(),
                            tiempos_receso_asignados: []
                        };
                    }).filter(Boolean);
                }).flat(); // ← Aplanamos para tener un solo array

            const todosLosRecesos = agentesDisponiblesTodos.flatMap(a => a.recesos || []);
            //console.log(todosLosRecesos);

            if (todosLosRecesos.length > 0) {

                //console.log(planOrdenado);
                //console.log(this.programacionSemanalFinal);
                const bloquesDe60 = [];

                for (let i = 0; i < planOrdenado.length - 1; i++) {
                    const b1 = planOrdenado[i];
                    const b2 = planOrdenado[i + 1];

                    if (b1.dia_semana !== b2.dia_semana) continue;

                    const finB1 = this.convertirAHorasEnMinutos(b1.intervalo_fin);
                    const inicioB2 = this.convertirAHorasEnMinutos(b2.intervalo_inicio);

                    if (finB1 === inicioB2) {
                        bloquesDe60.push({
                            dia: b1.dia_semana,
                            intervalo: `${b1.intervalo_inicio}–${b2.intervalo_fin}`,
                            inicioBloque: this.convertirAHorasEnMinutos(b1.intervalo_inicio),
                            finBloque: this.convertirAHorasEnMinutos(b2.intervalo_fin),
                            demandaTotal: b1.programados + b2.programados,
                            bloques: [b1, b2]
                        });
                    }
                }
                //console.log(bloquesDe60);

                planOrdenado.forEach(item => {
                    const dia = item.dia_semana;
                    //console.log(dia);
                    const demanda = item.programados;
                    //console.log(demanda);
                    const intervalo = `${item.intervalo_inicio}–${item.intervalo_fin}`;
                    //console.log(intervalo);

                    let inicioBloque = this.convertirAHorasEnMinutos(item.intervalo_inicio);
                    let finBloque = this.convertirAHorasEnMinutos(item.intervalo_fin);
                    // Ajuste si el bloque cruza medianoche
                    let inicioBloqueAjustado = inicioBloque;
                    let finBloqueAjustado = finBloque;

                    if (finBloque <= inicioBloque) {
                        finBloqueAjustado += 1440;
                    }

                    // Ajuste si el bloque está en la madrugada
                    if (inicioBloque < 300) {
                        inicioBloqueAjustado += 1440;
                        finBloqueAjustado += 1440;
                    }

                    let duracionBloque = finBloqueAjustado - inicioBloqueAjustado;

                    //console.log(agentesDisponiblesTodos);
                    const agentesDisponibles = agentesDisponiblesTodos.filter(a => {
                        if (a.dia !== dia) return false;
                        const [inicioTurno, finTurno] = a.horario.split("-");
                        let minInicioTurno = this.convertirAHorasEnMinutos(inicioTurno);
                        let minFinTurno = this.convertirAHorasEnMinutos(finTurno);

                        // Ajuste si el turno cruza medianoche
                        if (minFinTurno <= minInicioTurno) {
                            minFinTurno += 1440;
                        }

                        // Ajuste si el turno está en la madrugada
                        if (minInicioTurno < 300) {
                            minInicioTurno += 1440;
                            minFinTurno += 1440;
                        }

                        return minInicioTurno <= inicioBloqueAjustado && minFinTurno >= finBloqueAjustado;
                    });
                    // 💡 Lógica de asignación de recesos
                    const MARGEN_SEGURIDAD = 3;

                    // 2. Reduce la Demanda Original para el CÁLCULO DE ASIGNACIÓN
                    // Usamos Math.max(0, ...) para asegurarnos de que la demanda nunca sea negativa
                    const demandaParaAsignacion = Math.max(0, demanda - MARGEN_SEGURIDAD);

                    //const margen = agentesDisponibles.length - demandaParaAsignacion;
                    const margenReal = agentesDisponibles.length - demandaParaAsignacion;

                    if (margenReal > 0) {
                        const factorDistribucion = 0.3;
                        let maximoAsignableEnEsteBloque = Math.max(1, Math.floor(margenReal * factorDistribucion));

                        let margenConsumido = 0;
                        const duracionesRecesos = [30, 15];

                        duracionesRecesos.forEach(duracionMin => {
                            //console.log(duracionMin);
                            const elegibles = agentesDisponibles.filter(a => {
                                //console.log(agentesConReceso);
                                if (agentesConReceso.has(`${a.nombre}-${dia}-${inicioBloqueAjustado}`)) return false;

                                const duracionStr = this.convertirMinutosADuracion(duracionMin);
                                if (a.recesos_asignados_duracion.has(duracionStr)) return false;

                                const receso = a.recesos.find(r => this.convertirDuracionAHorasEnMinutos(r.duracion) === duracionMin);
                                if (!receso) return false;

                                const [inicioTurno, finTurno] = a.horario.split("-");
                                let minInicioTurno = this.convertirAHorasEnMinutos(inicioTurno);
                                let minFinTurno = this.convertirAHorasEnMinutos(finTurno);

                                if (minFinTurno <= minInicioTurno) minFinTurno += 1440;
                                if (minInicioTurno < 300) {
                                    minInicioTurno += 1440;
                                    minFinTurno += 1440;
                                }

                                const minDesdeInicio = receso?.min_desde_inicio_min || 0;
                                const maxAntesFin = receso?.max_antes_fin_min || 0;

                                let puntoInicialForzado = minInicioTurno + minDesdeInicio;

                                // 1. Si el agente ya tiene recesos asignados, el límite es el final del último receso + el margen (maxAntesFin).
                                if (a.tiempos_receso_asignados && a.tiempos_receso_asignados.length > 0) {
                                    const ultimoFinReceso = a.tiempos_receso_asignados[a.tiempos_receso_asignados.length - 1];

                                    // Se asegura de tomar el punto de inicio más tarde: el límite de la jornada O el límite del espaciamiento.
                                    puntoInicialForzado = Math.max(
                                        puntoInicialForzado, // Límite por minDesdeInicio
                                        ultimoFinReceso + maxAntesFin // Límite por Espaciamiento Mínimo (maxAntesFin)
                                    );
                                }
                                // --- 💡 FIN: LÓGICA DE PUNTO DE PARTIDA FORZADO ---

                                // ❌ REEMPLAZO: Aplicar el punto de inicio forzado
                                // La línea anterior: if (inicioBloqueAjustado < minInicioTurno + minDesdeInicio) return false;
                                if (inicioBloqueAjustado < puntoInicialForzado) return false;

                                if (minFinTurno < finBloqueAjustado + maxAntesFin) return false;

                                if (duracionMin > duracionBloque) return false;

                                return true;
                            });

                            if (margenConsumido >= maximoAsignableEnEsteBloque || elegibles.length === 0) return;

                            elegibles.forEach((a) => {
                                if (margenConsumido >= maximoAsignableEnEsteBloque) return;
                                let recesoAsignado, costoMargen;

                                if (duracionMin === 30) {
                                    const horaInicio = this.convertirMinutosAHoras(inicioBloqueAjustado);
                                    const horaFin = this.convertirMinutosAHoras(finBloqueAjustado);
                                    recesoAsignado = `${horaInicio}–${horaFin}`;
                                    costoMargen = 1;
                                }
                                else if (duracionMin === 15) {
                                    const offset = (margenConsumido % 1 < 0.5) ? 0 : 15;
                                    const horaInicio = this.convertirMinutosAHoras(inicioBloqueAjustado + offset);
                                    const horaFin = this.convertirMinutosAHoras(inicioBloqueAjustado + offset + 15);
                                    recesoAsignado = `${horaInicio}–${horaFin}`;
                                    costoMargen = 0.5;
                                } else {
                                    return;
                                }
                                a.recesos_asignados_duracion.add(this.convertirMinutosADuracion(duracionMin));
                                const recesoFinMinutos = inicioBloqueAjustado + duracionMin;
                                a.tiempos_receso_asignados.push(recesoFinMinutos);
                                a.tiempos_receso_asignados.sort((m1, m2) => m1 - m2);
                                agentesConReceso.add(`${a.nombre}-${a.dia}-${inicioBloqueAjustado}`); // Bloquea este agente para este intervalo de 30 min
                                //console.log(agentesConReceso);
                                descansosFinales.push({ agente: a.nombre, dia: a.dia, bloque: recesoAsignado, duracion: duracionMin });
                                //console.log(descansosFinales);
                                margenConsumido += costoMargen;
                            });
                        });
                    }


                });

                const intervalosUsados = new Map();
                const duracionReceso60 = this.convertirMinutosADuracion(60);
                bloquesDe60.forEach(b60 => {
                    //console.log('entre en receso de 60')
                    const { dia, inicioBloque, finBloque, demandaTotal, intervalo } = b60;
                    //console.log(b60);

                    const agentesDisponibles = agentesDisponiblesTodos.filter(a => {
                        if (a.dia !== dia) return false;
                        const [inicioTurno, finTurno] = a.horario.split("-");
                        let minInicioTurno = this.convertirAHorasEnMinutos(inicioTurno);
                        let minFinTurno = this.convertirAHorasEnMinutos(finTurno);

                        if (minFinTurno <= minInicioTurno) minFinTurno += 1440;
                        if (minInicioTurno < 300) {
                            minInicioTurno += 1440;
                            minFinTurno += 1440;
                        }

                        return minInicioTurno <= inicioBloque && minFinTurno >= finBloque;
                    });
                    const agentesDisponibles1 = agentesDisponiblesTodos.filter(a => {
                        if (a.dia !== dia) return false;
                        const [inicioTurno, finTurno] = a.horario.split("-");
                        let minInicioTurno = this.convertirAHorasEnMinutos(inicioTurno);
                        let minFinTurno = this.convertirAHorasEnMinutos(finTurno);

                        if (minFinTurno <= minInicioTurno) minFinTurno += 1440;
                        if (minInicioTurno < 300) {
                            minInicioTurno += 1440;
                            minFinTurno += 1440;
                        }

                        const subBloqueInicio = inicioBloque;
                        const subBloqueFin = inicioBloque + 30;

                        return minInicioTurno <= subBloqueInicio && minFinTurno >= subBloqueFin;
                    });

                    const agentesDisponibles2 = agentesDisponiblesTodos.filter(a => {
                        if (a.dia !== dia) return false;
                        const [inicioTurno, finTurno] = a.horario.split("-");
                        let minInicioTurno = this.convertirAHorasEnMinutos(inicioTurno);
                        let minFinTurno = this.convertirAHorasEnMinutos(finTurno);

                        if (minFinTurno <= minInicioTurno) minFinTurno += 1440;
                        if (minInicioTurno < 300) {
                            minInicioTurno += 1440;
                            minFinTurno += 1440;
                        }

                        const subBloqueInicio = finBloque - 30;
                        const subBloqueFin = finBloque;

                        return minInicioTurno <= subBloqueInicio && minFinTurno >= subBloqueFin;
                    });

                    //console.log(`Agentes ${agentesDisponibles.length}`);

                    let margenBloque1 = agentesDisponibles1.length - b60.bloques[0].programados;
                    //console.log(`Margen primero: ${margenBloque1}`);
                    let margenBloque2 = agentesDisponibles2.length - b60.bloques[1].programados;
                    //console.log(`Margen Segundo: ${margenBloque2}`);
                    if (margenBloque1 < 1 || margenBloque2 < 1) return;

                    const claveBloque1 = `${dia}-${b60.bloques[0].intervalo_inicio}`;
                    const claveBloque2 = `${dia}-${b60.bloques[1].intervalo_inicio}`;

                    const usadoBloque1 = intervalosUsados.get(claveBloque1) || 0;
                    //console.log(`Margen Usado: ${usadoBloque1}`);
                    const usadoBloque2 = intervalosUsados.get(claveBloque2) || 0;

                    if (usadoBloque1 >= margenBloque1 || usadoBloque2 >= margenBloque2) {
                        //console.log(`⛔ Margen agotado en ${claveBloque1} o ${claveBloque2}`);
                        return;
                    }


                    const elegibles = agentesDisponibles.filter(a => {
                        if (a.recesos_asignados_duracion.has(duracionReceso60)) return false;

                        const claveBloque1 = `${a.nombre}-${a.dia}-${b60.bloques[0].inicioBloque}`;
                        const claveBloque2 = `${a.nombre}-${a.dia}-${b60.bloques[1].inicioBloque}`;
                        if (agentesConReceso.has(claveBloque1) || agentesConReceso.has(claveBloque2)) return false;

                        const receso = a.recesos.find(r => r.duracion === duracionReceso60);
                        if (!receso) return false;

                        const [inicioTurno, finTurno] = a.horario.split("-");
                        let minInicioTurno = this.convertirAHorasEnMinutos(inicioTurno);
                        let minFinTurno = this.convertirAHorasEnMinutos(finTurno);

                        if (minFinTurno <= minInicioTurno) minFinTurno += 1440;
                        if (minInicioTurno < 300) {
                            minInicioTurno += 1440;
                            minFinTurno += 1440;
                        }

                        const minDesdeInicio = receso?.min_desde_inicio_min || 0;
                        const maxAntesFin = receso?.max_antes_fin_min || 0;

                        if (inicioBloque < minInicioTurno + minDesdeInicio) return false;
                        if (minFinTurno < finBloque + maxAntesFin) return false;

                        return true;
                    });

                    let margenConsumido = 0;
                    const margenDisponibleBloque1 = margenBloque1 - (intervalosUsados.get(claveBloque1) || 0);
                    //console.log(margenDisponibleBloque1);
                    const margenDisponibleBloque2 = margenBloque2 - (intervalosUsados.get(claveBloque2) || 0);
                    //console.log(margenDisponibleBloque2);

                    const margenMaximoAsignable = Math.min(margenDisponibleBloque1, margenDisponibleBloque2);
                    //console.log(margenMaximoAsignable);

                    elegibles.forEach(a => {
                        //if (margenConsumido >= margenBloque1) return;
                        if (margenConsumido >= margenMaximoAsignable) return;


                        const horaInicio = this.convertirMinutosAHoras(inicioBloque);
                        const horaFin = this.convertirMinutosAHoras(finBloque);
                        const recesoAsignado = `${horaInicio}–${horaFin}`;

                        a.recesos_asignados_duracion.add(duracionReceso60);
                        agentesConReceso.add(`${a.nombre}-${a.dia}-${b60.bloques[0].inicioBloque}`); // Bloquea el primer sub-bloque
                        agentesConReceso.add(`${a.nombre}-${a.dia}-${b60.bloques[1].inicioBloque}`); // Bloquea el segundo sub-bloque

                        a.tiempos_receso_asignados.push(b60.finBloque);
                        a.tiempos_receso_asignados.sort((m1, m2) => m1 - m2);
                        descansosFinales.push({ agente: a.nombre, dia: a.dia, bloque: recesoAsignado, duracion: 60 });

                        margenConsumido++;
                        margenBloque2--;
                        intervalosUsados.set(claveBloque1, (intervalosUsados.get(claveBloque1) || 0) + 1);
                        intervalosUsados.set(claveBloque2, (intervalosUsados.get(claveBloque2) || 0) + 1);

                        //console.log(`✅ Receso de 60 min asignado a ${a.nombre} en ${dia}: ${recesoAsignado} (margen usado: ${margenConsumido}, margen bloque2 restante: ${margenBloque2})`);

                    });
                });


                this.descansosFinales = descansosFinales;
                //console.log('Descansos: ', this.descansosFinales);
                const descansosAsignados = this.descansosFinales || [];

                // 🔍 Detectar agentes sin receso
                //console.log(programacion);
                this.agentesSinReceso = Object.entries(programacion)
                    .flatMap(([nombre, semana]) => {
                        // En lugar de usar la programacion original, usamos agentesDisponiblesTodos
                        // para tener acceso a los recesos requeridos.
                        const agenteData = agentesDisponiblesTodos.filter(a => a.nombre === nombre);

                        return agenteData.map(a => {
                            const turno = semana[a.dia];
                            // Solo si está trabajando ese día
                            if (turno !== "DS" && turno !== "—") {
                                const recesosRequeridos = a.recesos.map(r => this.convertirDuracionAHorasEnMinutos(r.duracion));
                                const recesosAsignados = Array.from(a.recesos_asignados_duracion).map(d => this.convertirDuracionAHorasEnMinutos(d));

                                // Si la cantidad de recesos asignados es menor que la cantidad requerida
                                if (recesosAsignados.length < recesosRequeridos.length) {
                                    // O si algún receso requerido no está en la lista de asignados
                                    const recesosFaltantes = recesosRequeridos.filter(req => !recesosAsignados.includes(req));

                                    if (recesosFaltantes.length > 0) {
                                        return { nombre, dia: a.dia, turno, recesosFaltantes };
                                    }
                                }
                            }
                            return null;
                        });
                    })
                    .filter(Boolean);

                //console.log('Agentes sin recesos:', this.agentesSinReceso);
                const copiaProgramacionOriginal = JSON.parse(JSON.stringify(programacion));
                const copiaDescansosOriginal = JSON.parse(JSON.stringify(this.descansosFinales));
                if (this.agentesSinReceso.length) {

                    //this.reforzarProgramacionParaRecesos(programacion);
                    //this.reforzarPrimerTurno(programacion, copiaProgramacionOriginal, copiaDescansosOriginal);
                    //console.log('falta agentes');
                } /*else {
                    const agentesExtra = Object.keys(programacion)
                        .filter(nombre => nombre.startsWith("AgenteExtra_"));
                    //console.log(agentesExtra);
                    if (agentesExtra.length > 0) {
                        const MAX_REASIGNACIONES = 20;
                        if (this.contadorReasignaciones >= MAX_REASIGNACIONES) {
                            this.$toast.warning(`⚠️ ALERTA: Se esta generando bucle infinito por asignacion.Deteniendo el proceso.... Procesando tabla final.`);

                            // Llama a una función para procesar la solución actual
                            //this.procesarTablaConsolidada(programacion, agentesExtra);
                            this.procesarTabla();
                            //this.$nextTick(() => {
                            //this.generarTablaResumenPorAgente();
                            //this.generarHeadersTablaResumen();
                            //});

                        } else {
                            const ordenado = this.ordenarProgramacionPorTurno(programacion);
                            const reseteo = this.resetearDescansos(ordenado);

                            this.agregarAsignacion();

                            this.generarProgramacionConDescansos(reseteo);
                        }
                    } else {
                        //console.log(this.descansosFinales);
                        this.procesarTabla();
                        //this.$nextTick(() => {
                        //this.generarTablaResumenPorAgente();
                        //this.generarHeadersTablaResumen();
                        //});
                    }
                }*/
            } else {
                // No hay recesos, inicializar valores vacíos

                this.$toast.info('No se procesaron los recesos porque las reglas de auxiliares no están correctamente definidas. Por favor revisa la configuración.');
                this.descansosFinales = [];
                this.procesarTabla();
                //this.$nextTick(() => {
                //this.generarTablaResumenPorAgente();
                //this.generarHeadersTablaResumen();
                //});
            }

        },
        agregarAsignacion() {
            this.contadorReasignaciones += 1;
        },
        generarResumen() {
            this.cargandoEdicion = true;
            setTimeout(() => {
                this.generarTablaResumenPorAgente();
                this.generarHeadersTablaResumen();
                this.cargandoEdicion = false;
            }, 200);

        },
        iniciarAsignacionDeRecesos(programacionBase) {
            this.cargando = true;
            setTimeout(() => {
                let programacion = JSON.parse(JSON.stringify(programacionBase));
                const MAX_INTENTOS = 10;
                let intento = 0;

                do {
                    intento++;

                    this.asignarHorarioDeRecesoPorDemanda3(programacion);

                    const agentesFaltantes = this.agentesSinReceso.length;
                    //console.log(agentesFaltantes);

                    if (agentesFaltantes === 0) {
                        //console.log(`✅ Asignación finalizada después de ${intento} intento(s).`);
                        break;
                    }

                    if (intento >= MAX_INTENTOS) {
                        this.$toast.error(`⚠️ ALERTA: Máximo de ${MAX_INTENTOS} intentos alcanzado. Faltan ${agentesFaltantes} recesos. Deteniendo refuerzo.`);
                        break;
                    }

                    //console.log(`⚠️ Faltan ${agentesFaltantes} recesos. Terminando asignación para permitir refuerzo externo. (Intento ${intento})`);

                    this.reforzarPrimerTurno(programacion);



                } while (this.agentesSinReceso.length > 0);
                //console.log(programacion);
                const agentesExtra = Object.keys(programacion)
                    .filter(nombre => nombre.startsWith("AgenteExtra_"));
                //console.log(agentesExtra);
                if (agentesExtra.length > 0) {
                    //console.log(`✨ Se encontraron ${agentesExtra.length} agentes extra. Reordenando y consolidando programación...`);
                    const ordenado = this.ordenarProgramacionPorTurno(programacion);
                    //console.log(ordenado);
                    //const reseteo = this.resetearDescansos(ordenado);
                    //console.log(reseteo);
                    this.generarProgramacionConDescansos(ordenado);
                }
                this.procesarTabla();
                this.generarDatosGraficasPorDiaRecesos();
                this.cargando = false;
            }, 100);
        },
        /*reforzarPrimerTurno(programacion) {
            const ordenDias = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
            let agenteIndex = Object.keys(programacion).length + 1;
 
            // Agrupar agentes sin receso por turno
            const agrupadosPorTurno = {};
            this.agentesSinReceso.forEach(({ turno }) => {
                agrupadosPorTurno[turno] = agrupadosPorTurno[turno] || { turno, cantidad: 0 };
                agrupadosPorTurno[turno].cantidad++;
            });
            console.log(this.agentesSinReceso);
 
            // Obtener el primer turno que necesita refuerzo
            const primerTurno = Object.keys(agrupadosPorTurno)[0];
            if (!primerTurno) return;
 
            let agentesPendientes = this.agentesSinReceso.filter(a => a.turno === primerTurno);
            console.log(agentesPendientes);
 
            while (agentesPendientes.length > 0) {
                const nuevoAgente = `AgenteExtra_${String(agenteIndex).padStart(2, "0")}`;
                agenteIndex++;
 
                programacion[nuevoAgente] = {};
                ordenDias.forEach(diaSemana => {
                    if (diaSemana === 'Domingo') {
                        programacion[nuevoAgente][diaSemana] = 'DS';
                    } else {
                        programacion[nuevoAgente][diaSemana] = primerTurno;
                    }
                });
 
                console.log(` Agregado ${nuevoAgente} con turno ${primerTurno} toda la semana`);
 
                this.asignarHorarioDeRecesoPorDemanda3(programacion);
 
                agentesPendientes = this.agentesSinReceso.filter(a => a.turno === primerTurno);
                //console.log(agentesPendientes);
 
                console.log(` sin receso en turno ${primerTurno}:`, agentesPendientes.map(a => `${a.nombre}-${a.dia}`));
            }
 
            console.log(`âœ… Todos los agentes con turno ${primerTurno} ya tienen receso`);
        },*/

        reforzarPrimerTurno(programacion) {
            const ordenDias = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
            let agenteIndex = Object.keys(programacion).length + 1;

            // 1. Agrupar y obtener el primer turno a reforzar
            const agrupadosPorTurno = {};
            this.agentesSinReceso.forEach(({ turno }) => {
                agrupadosPorTurno[turno] = (agrupadosPorTurno[turno] || 0) + 1;
            });
            const primerTurno = Object.keys(agrupadosPorTurno)[0];
            if (!primerTurno) return;

            // 2. Calcular cuántos agentes extra agregar (Basado en el déficit total del turno)
            const totalRecesosFaltantes = agrupadosPorTurno[primerTurno];
            const FACTOR_LIBERACION = 6;
            const agentesAñadir = Math.ceil(totalRecesosFaltantes / FACTOR_LIBERACION);

            const agentesOriginales = Object.keys(programacion).filter(key => !key.startsWith("AgenteExtra_"));

            let diasDeCierreDelServicio = [];
            if (agentesOriginales.length > 0) {
                // Obtenemos los días donde TODOS los agentes originales tienen 'DS'
                diasDeCierreDelServicio = ordenDias.filter(dia => {
                    return agentesOriginales.every(agente => programacion[agente][dia] === 'DS');
                });
            }

            //console.log(`--- INICIO REFUERZO AUTOMÁTICO ---`);
            //console.log(`💡 Se requieren ${agentesAñadir} agentes extra para liberar ${totalRecesosFaltantes} recesos.`);

            // 3. Añadir todos los agentes extra necesarios de golpe
            for (let i = 0; i < agentesAñadir; i++) {
                const nuevoAgente = `AgenteExtra_${String(agenteIndex).padStart(2, "0")}`;
                agenteIndex++;

                programacion[nuevoAgente] = {};
                ordenDias.forEach(diaSemana => {
                    if (diasDeCierreDelServicio.includes(diaSemana)) {
                        programacion[nuevoAgente][diaSemana] = 'DS';
                    } else {
                        programacion[nuevoAgente][diaSemana] = primerTurno;
                    };
                });

                //console.log(`- Agregado ${nuevoAgente} (Turno: ${primerTurno} L-S).`);
            }

            // 4. ELIMINAR EL BUCLE WHILE QUE TENÍAS AQUÍ. SOLO RETORNA EL CONTROL.
            //console.log(`--- FIN REFUERZO AUTOMÁTICO ---`);
        },
        //PROCESO 9
        generarTablaResumenPorAgente() {
            const diasUnicos = [
                ...new Set(
                    Object.values(this.programacionConDescansos)
                        .flatMap(semana => Object.keys(semana))
                        .map(d => d.toLowerCase())
                )
            ];

            const resumen = {};

            Object.entries(this.programacionConDescansos).forEach(([agente, semana]) => {
                if (!resumen[agente]) {
                    resumen[agente] = {
                        agente,
                        selected: false
                    };
                    diasUnicos.forEach(d => {
                        resumen[agente][`${d}_horario`] = "—";
                        //resumen[agente][`${d}_receso`] = "—";
                        resumen[agente][`${d}_receso60`] = "—";
                        resumen[agente][`${d}_receso30`] = "—";
                        resumen[agente][`${d}_receso15`] = "—";
                    });
                }

                Object.entries(semana).forEach(([dia, turnoRaw]) => {
                    const diaKey = dia.toLowerCase();
                    if (turnoRaw === "DS" || turnoRaw === "—") {
                        resumen[agente][`${diaKey}_horario`] = "DS";
                        resumen[agente][`${diaKey}_receso60`] = "DS";
                        resumen[agente][`${diaKey}_receso30`] = "DS";
                        resumen[agente][`${diaKey}_receso15`] = "DS";
                    } else {
                        const formato = turnoRaw.split("-").map(h => h.slice(0, 5)).join("–");
                        //const formato = turnoRaw.split("–").map(h => h.trim().slice(0, 5)).join("-");
                        resumen[agente][`${diaKey}_horario`] = formato;
                        //resumen[agente][`${diaKey}_receso`] = "DS";
                    }
                });
            });

            this.descansosFinales.forEach(({ agente, dia, bloque, duracion }) => {
                const diaKey = dia.toLowerCase();
                const formato = bloque.split("–").map(h => h.slice(0, 5)).join("–");
                if (
                    resumen[agente] &&
                    resumen[agente][`${diaKey}_horario`] !== "DS"
                ) {
                    const valueKey = `${diaKey}_receso${duracion}`;
                    resumen[agente][valueKey] = formato;
                    //resumen[agente][`${diaKey}_receso`] = formato;
                }

            });

            // Guardar tabla y días únicos
            this.itemsTablaResumen = Object.values(resumen);

            //console.log(this.itemsTablaResumen);
            this.diasUnicosResumen = diasUnicos;
            if (this.itemsTablaResumen && this.itemsTablaResumen.length > 0) {
                this.generarDatosGraficasPorDiaFinal();
                this.recordHistory();
            }

        },
        generarTablaResumenPorAgente2() {
            const diasUnicos = [
                ...new Set(
                    Object.values(this.programacionConDescansos)
                        .flatMap(semana => Object.keys(semana))
                        .map(d => d.toLowerCase())
                )
            ];

            const resumen = {};

            Object.entries(this.programacionConDescansos).forEach(([agente, semana]) => {
                if (!resumen[agente]) {
                    resumen[agente] = { agente };
                    diasUnicos.forEach(d => {
                        resumen[agente][`${d}_horario`] = "—";
                        resumen[agente][`${d}_receso`] = "—";
                    });
                }

                Object.entries(semana).forEach(([dia, turnoRaw]) => {
                    const diaKey = dia.toLowerCase();
                    if (turnoRaw === "DS" || turnoRaw === "—") {
                        resumen[agente][`${diaKey}_horario`] = "DS";
                        resumen[agente][`${diaKey}_receso`] = "DS";
                    } else {
                        const formato = turnoRaw.split("-").map(h => h.slice(0, 5)).join("–");
                        resumen[agente][`${diaKey}_horario`] = formato;
                        //resumen[agente][`${diaKey}_receso`] = "DS";
                    }
                });
            });

            this.descansosFinales.forEach(({ agente, dias }) => {
                dias.forEach(({ dia, bloque15, bloque30, bloque60 }) => {
                    const diaKey = dia.toLowerCase();

                    // Unimos todos los bloques en un solo arreglo
                    const todosLosBloques = [
                        ...bloque15,
                        ...bloque30,
                        ...bloque60
                    ];

                    // Formateamos cada bloque como "HH:MM–HH:MM (tipo)"
                    const recesos = todosLosBloques.map(({ inicio, fin, tipo }) => {
                        const formatoHora = `${inicio.slice(0, 5)}–${fin.slice(0, 5)}`;
                        return `${formatoHora}`;
                    });

                    // Unimos los recesos en una sola cadena separada por comas
                    const formatoFinal = recesos.join(", ");

                    // Asignamos al resumen si el horario no es "DS"
                    if (
                        resumen[agente] &&
                        resumen[agente][`${diaKey}_horario`] !== "DS"
                    ) {
                        resumen[agente][`${diaKey}_receso`] = formatoFinal;
                    }
                });
            });
            /*this.descansosFinales.forEach(({ agente, dia, bloque }) => {
                const diaKey = dia.toLowerCase();
                const formato = bloque.split("–").map(h => h.slice(0, 5)).join("–");
                if (
                    resumen[agente] &&
                    resumen[agente][`${diaKey}_horario`] !== "DS"
                ) {
                    resumen[agente][`${diaKey}_receso`] = formato;
                }
 
            });*/

            // Guardar tabla y días únicos
            this.itemsTablaResumen = Object.values(resumen);
            this.diasUnicosResumen = diasUnicos;
            if (this.itemsTablaResumen && this.itemsTablaResumen.length > 0) {
                //this.generarDatosGraficasPorDiaFinal()
            }

        },



        ////////////// PROCESOS COMPLEMENTARIOS ///////////////
        calcularAgentesErlangC({ sla, serviceTime, callsPerHour, aht }) {
            const birthRate = callsPerHour;
            const deathRate = 3600 / aht;
            const trafficRate = birthRate / deathRate;

            const erlangs = (birthRate * aht) / 3600;
            let noAgents = Math.max(1, Math.floor(erlangs));
            let utilisation = trafficRate / noAgents;


            while (utilisation >= 1) {
                noAgents++;
                utilisation = trafficRate / noAgents;
            }

            const maxIterate = noAgents * 100;
            const maxAccuracy = 0.01;

            for (let count = 1; count <= maxIterate; count++) {
                utilisation = trafficRate / noAgents;
                if (utilisation < 1) {
                    const C = this.calcularErlangC(noAgents, trafficRate);
                    let slQueued = 1 - C * Math.exp((trafficRate - noAgents) * serviceTime / aht);
                    slQueued = Math.max(0, slQueued);

                    if (slQueued >= sla || slQueued > 1 - maxAccuracy) break;
                }
                noAgents++;
            }

            return noAgents;
        },
        calcularErlangB(servers, intensity) {
            let B = 1;
            for (let i = 1; i <= servers; i++) {
                B = (intensity * B) / (i + intensity * B);
            }
            return this.minMax(B, 0, 1);
        },
        calcularErlangC(servers, intensity) {
            const B = this.calcularErlangB(servers, intensity);
            const utilisation = intensity / servers;

            const C = B / ((utilisation * B) + (1 - utilisation));
            return this.minMax(C, 0, 1);
        },
        minMax(val, min, max) {
            return Math.max(min, Math.min(val, max));
        },
        aplicarReductores(agentes, utz, abs) {
            if (utz <= 0 || abs >= 1) return agentes;

            const k12 = (agentes / 2) / utz;

            const t12 = Math.round((k12 * 2) / (1 - abs));

            return t12;

        },
        convertirAHorasEnMinutos(horaStr) {
            if (!horaStr || typeof horaStr !== 'string') return 0;

            const partes = horaStr.split(":");
            if (partes.length < 2) return 0;

            const [h, m] = partes.map(Number);

            if (isNaN(h) || isNaN(m)) return 0;

            return h * 60 + m; // ignoramos los segundos para comparaciones

        },
        convertirMinutosAHoras(minutos) {
            const horas = Math.floor(minutos / 60);
            const mins = minutos % 60;

            // Asegura formato HH:MM con ceros a la izquierda
            const formatoHoras = horas.toString().padStart(2, '0');
            const formatoMinutos = mins.toString().padStart(2, '0');

            return `${formatoHoras}:${formatoMinutos}`;
        },
        calcularHoras(inicio, fin) {
            const [h1, m1] = inicio.split(":").map(Number);
            const [h2, m2] = fin.split(":").map(Number);

            const inicioMin = h1 * 60 + m1;
            let finMin = h2 * 60 + m2;

            // Ajuste si el turno cruza la medianoche
            if (finMin <= inicioMin) {
                finMin += 1440;
            }

            const duracionHoras = (finMin - inicioMin) / 60;
            return duracionHoras; // Devuelve horas con decimales
        },
        obtenerRecesos(jornada, auxiliares) {
            return auxiliares.filter(aux => {
                const min = parseFloat(aux.jornada_min);
                const max = parseFloat(aux.jornada_max);
                return jornada >= min && jornada <= max;
            });
        },
        convertirDuracionAHorasEnMinutos(duracionStr) {
            const [horas, minutos, segundos] = duracionStr.split(':').map(Number);
            return horas * 60 + minutos + Math.floor(segundos / 60);
        },
        /*procesarTabla() {
            // Paso 1: Extraer días únicos
            this.diasUnicosRecesos = [
                ...new Set(this.descansosFinales.map(({ dia }) => dia.toLowerCase()))
            ];
 
            // Paso 2: Generar columnas dinámicas
            this.columnasReceso = [
                { text: 'Agente', value: 'agente' },
                ...this.diasUnicos.map(dia => ({
                    text: dia.charAt(0).toUpperCase() + dia.slice(1),
                    value: dia
                }))
            ];
 
            // Paso 3: Agrupar por agente
            const agrupados = [];
 
            this.descansosFinales.forEach(({ agente, dia, bloque, duracion }) => {
                const diaKey = dia.toLowerCase();
                let fila = agrupados.find(x => x.agente === agente);
                if (!fila) {
                    fila = { agente };
                    this.diasUnicosRecesos.forEach(d => (fila[d] = ''));
                    agrupados.push(fila);
                }
                const formatoHorario = bloque.split('–').map(t => t.slice(0, 5)).join('–');
                fila[diaKey] = formatoHorario;
 
            });
            agrupados.sort((a, b) => {
                const numA = parseInt(a.agente.match(/\d+/)[0]);
                const numB = parseInt(b.agente.match(/\d+/)[0]);
                return numA - numB;
            });
            this.descansosTransformados = agrupados;
        },*/
        procesarTabla() {
            // Paso 1: Extraer días únicos y duraciones únicas
            const duracionesUnicas = [
                ...new Set(this.descansosFinales.map(({ duracion }) => duracion))
            ].sort((a, b) => b - a); // Ordenar de mayor a menor (60, 30, 15)

            // Asumiendo que 'this.diasUnicos' contiene ['Lunes', 'Martes', ...]
            const diasUnicos = this.diasUnicos;

            // Paso 2: Generar columnas dinámicas (Agente + [Día (Duración)])
            this.columnasReceso = [
                { text: 'Agente', value: 'agente', fixed: true }, // Columna fija de Agente
                // 💡 Generar una columna por cada combinación de Día y Duración
                ...diasUnicos.flatMap(dia =>
                    duracionesUnicas.map(duracion => {
                        const diaKey = dia.toLowerCase();
                        const valueKey = `${diaKey}_${duracion}`; // Ej: "lunes_30"
                        return {
                            text: `${dia} (${duracion})`,
                            value: valueKey
                        };
                    })
                )
            ];

            // Paso 3: Agrupar por agente y asignar recesos a la columna específica
            const agrupados = [];

            this.descansosFinales.forEach(({ agente, dia, bloque, duracion }) => {
                const diaKey = dia.toLowerCase();
                // 💡 Clave única de columna: "dia_duracion"
                const valueKey = `${diaKey}_${duracion}`;

                let fila = agrupados.find(x => x.agente === agente);

                if (!fila) {
                    fila = { agente };

                    // 💡 Inicializar TODAS las celdas de la fila con un guion largo (—)
                    this.columnasReceso.forEach(col => {
                        if (col.value !== 'agente') {
                            fila[col.value] = '—';
                        }
                    });
                    agrupados.push(fila);
                }

                // Formato de hora (ej. '07:00–13:00')
                const formatoHorario = bloque.split('–').map(t => t.slice(0, 5)).join('–');

                // Asignar el valor a la celda correcta (ej. fila["lunes_30"])
                // Nota: Si el agente tiene múltiples recesos de la misma duración en un día, se concatenarán.
                if (fila[valueKey] !== '—') {
                    fila[valueKey] += ` / ${formatoHorario}`;
                } else {
                    fila[valueKey] = formatoHorario;
                }
            });

            // Paso 4: Ordenar (sin cambios)
            agrupados.sort((a, b) => {
                const numA = parseInt(a.agente.match(/\d+/)[0]);
                const numB = parseInt(b.agente.match(/\d+/)[0]);
                return numA - numB;
            });

            this.descansosTransformados = agrupados;
        },
        procesarTabla2() {
            // Paso 1: Extraer días únicos
            const diasSet = new Set();
            this.descansosFinales.forEach(({ dias }) => {
                dias.forEach(({ dia }) => diasSet.add(dia.toLowerCase()));
            });
            this.diasUnicosRecesos = [...diasSet];

            // Paso 2: Generar columnas dinámicas
            this.columnasReceso = [
                { text: 'Agente', value: 'agente' },
                ...this.diasUnicosRecesos.map(dia => ({
                    text: dia.charAt(0).toUpperCase() + dia.slice(1),
                    value: dia
                }))
            ];

            // Paso 3: Agrupar por agente
            const agrupados = [];

            this.descansosFinales.forEach(({ agente, dias }) => {
                let fila = { agente };
                this.diasUnicosRecesos.forEach(d => (fila[d] = ''));

                /*dias.forEach(({ dia, bloque15, bloque30, bloque60 }) => {
                    const diaKey = dia.toLowerCase();
                    const bloques = [...bloque15, ...bloque30, ...bloque60];
 
                    const formato = bloques.map(({ inicio, fin }) => {
                        return `${inicio.slice(0, 5)}–${fin.slice(0, 5)}`;
                    }).join(', ');
 
                    fila[diaKey] = formato;
                });*/
                dias.forEach(({ dia, bloque15, bloque30, bloque60 }) => {
                    const diaKey = dia.toLowerCase();
                    const bloques = [
                        ...bloque15.map(b => ({ ...b, tipo: b.tipo || 'Break(15min)' })),
                        ...bloque30.map(b => ({ ...b, tipo: b.tipo || 'Break(30min)' })),
                        ...bloque60.map(b => ({ ...b, tipo: b.tipo || 'Break(60min)' }))
                    ];

                    const formato = bloques.map(({ inicio, fin, tipo }) => {
                        const horaInicio = inicio.slice(0, 5);
                        const horaFin = fin.slice(0, 5);
                        return `${horaInicio}–${horaFin} (${tipo})`;
                    }).join(', ');

                    fila[diaKey] = formato;
                });


                agrupados.push(fila);
            });

            // Paso 4: Ordenar por número en el nombre del agente
            agrupados.sort((a, b) => {
                const numA = parseInt(a.agente.match(/\d+/)?.[0] || '0');
                const numB = parseInt(b.agente.match(/\d+/)?.[0] || '0');
                return numA - numB;
            });

            this.descansosTransformados = agrupados;
            //console.log(this.descansosTransformados);
        },
        actualizarTablaDesdeProgramacion() {
            const diasOrden = ["lunes", "martes", "miércoles", "jueves", "viernes", "sábado", "domingo"];
            const agentes = Object.entries(this.programacionSemanal);
            //console.log('aqui', agentes);

            this.items = agentes.map(([agente, dias], index) => {
                const fila = { id: index + 1, agente };
                diasOrden.forEach(dia => {
                    const clave = Object.keys(dias).find(k => k.toLowerCase() === dia);
                    fila[dia] = clave ? dias[clave] : "—";
                });

                return fila;
            });
            //console.log('items: ', this.items);

            this.headers = [
                { text: "Agente", value: "agente" },
                ...diasOrden.map(dia => ({ text: dia.charAt(0).toUpperCase() + dia.slice(1), value: dia }))
            ];
        },
        calcularCargaPorDiaDesdeAsignacion() {
            const carga = {};
            //console.log(this.matrizAsignacion);
            this.matrizAsignacion.forEach(fila => {
                const turnoOriginal = fila.turno;
                const turno = this.normalizarTurno(turnoOriginal);


                Object.keys(fila).forEach(dia => {
                    if (dia === "turno") return;

                    if (!carga[dia]) carga[dia] = {};
                    if (!carga[dia][turno]) carga[dia][turno] = 0;

                    carga[dia][turno] += fila[dia] || 0;
                });
            });

            return carga;
        },
        actualizarTablaConDescansos(prog) {
            const diasOrden = ["lunes", "martes", "miércoles", "jueves", "viernes", "sábado", "domingo"];
            const agentes = Object.entries(prog);
            this.tablaKey++; // ← fuerza el re-render

            let colorIndex = 0;
            let turnoAnterior = null;


            this.itemsConDescanso = agentes.map(([agente, dias], index) => {
                const fila = { id: index + 1, agente };

                // Detectar turno base (primer turno válido)
                const turnosValidos = diasOrden
                    .map(dia => {
                        const clave = Object.keys(dias).find(k => k.toLowerCase() === dia);
                        return clave ? dias[clave] : "—";
                    })
                    .filter(turno => turno !== "DS" && turno !== "—" && turno !== "");

                const turnoBase = turnosValidos[0] || "—";

                // Comparar con el turno anterior
                if (turnoBase !== turnoAnterior) {
                    colorIndex++; // cambia de color si el turno es distinto
                    turnoAnterior = turnoBase;
                }

                fila.turnoBase = turnoBase;
                fila.colorIndex = colorIndex % 2; // 0 o 1 para alternar colores

                diasOrden.forEach(dia => {
                    const clave = Object.keys(dias).find(k => k.toLowerCase() === dia);
                    fila[dia] = clave ? dias[clave] : "—";
                });
                return fila;
            });

        },
        getGrupoColor(index) {
            //const colores = ["#ffffff", "#e0e0e0"];
            const colores = ["#ffffff", "#f0f0f0"];

            return {
                backgroundColor: colores[index % colores.length]
            };
        },
        normalizarTurno(turno) {
            return turno.replace(/\s*/g, ''); // Elimina todos los espacios
        },
        generarHeadersTablaResumen() {
            const headers = [
                { text: 'Agente', value: 'agente', rowspan: 2 }
            ];
            const duracionesReceso = [60, 30, 15];
            this.diasUnicosResumen.forEach(dia => {
                const diaCapitalizado = dia.charAt(0).toUpperCase() + dia.slice(1);

                headers.push({
                    text: diaCapitalizado,
                    align: 'center',
                    colspan: 1 + duracionesReceso.length,
                    children: [
                        { text: 'Horario', value: `${dia}_horario` },
                        ...duracionesReceso.map(dur => ({
                            text: `Receso (${dur})`,
                            value: `${dia}_receso${dur}`
                        }))
                        //{ text: 'Receso', value: `${dia}_receso` }
                    ]
                });
            });

            this.headersTablaResumen = headers;
            //console.log(this.headersTablaResumen);
        },
        actualizarVolumen(intervalo, dia, nuevoVolumen) {
            // Buscar el item original en planDiaModelo
            const itemOriginal = this.planDiaModelo.find(item => {
                const intervaloTexto = `${item.intervalo_inicio.slice(0, 5)} - ${item.intervalo_fin.slice(0, 5)}`;
                return intervaloTexto === intervalo && item.dia_semana === dia;
            });

            if (itemOriginal) {
                itemOriginal.volumen = parseFloat(nuevoVolumen);

                // Recalcular requeridos, programados y diferencia
                const servicio = this.servicios.find(s => s.id === this.servicioId);
                const utz = parseFloat(servicio.utilizacion) / 100;
                const abs = parseFloat(servicio.ausentismo) / 100;

                let requeridos = 0;

                if (this.tipoEscenario === 'transacciones') {
                    //const tmg = parseFloat(this.parametros.tmg);
                    const tmgConfig = parseFloat(this.parametros.tmg);
                    const tmg = (tmgV !== null && tmgV !== undefined) ? parseFloat(tmgV) : tmgConfig;
                    const nivel = parseFloat(this.parametros.nivel);
                    const umbral = parseFloat(this.parametros.umbral);

                    const sla = nivel / 100;
                    const serviceTime = umbral;
                    const callsPerHour = itemOriginal.volumen * 2;
                    const aht = tmg;

                    requeridos = this.calcularAgentesErlangC({ sla, serviceTime, callsPerHour, aht });

                } else if (this.tipoEscenario === 'horas') {
                    //const tmg = parseFloat(this.parametros.tmg);
                    const tmgConfig = parseFloat(this.parametros.tmg);
                    const tmg = (tmgV !== null && tmgV !== undefined) ? parseFloat(tmgV) : tmgConfig;
                    const duracionIntervaloSegundos = 30 * 60;
                    requeridos = (itemOriginal.volumen * tmg) / duracionIntervaloSegundos;
                    requeridos = parseFloat(requeridos.toFixed(2));
                } else if (this.tipoEscenario === 'agentes') {
                    requeridos = itemOriginal.volumen;
                }

                const programados = this.aplicarReductores(requeridos, utz, abs);
                const diferencia = programados - requeridos;

                itemOriginal.requeridos = requeridos;
                itemOriginal.programados = programados;
                itemOriginal.diferencia = diferencia;

                // Forzar actualización de matriz
                this.$forceUpdate();
                this.calcularAsignacionPorTurno();
            }
        },
        toggleDescanso(index, key) {
            const item = this.itemsConDescanso[index];
            const cellId = `${index}-${key}`;
            const currentValue = item[key];

            if (currentValue === 'DS') {
                // Restaurar valor original si existe
                if (this.valoresOriginales[cellId] !== undefined) {
                    this.$set(item, key, this.valoresOriginales[cellId]);
                    delete this.valoresOriginales[cellId];
                }
            } else {
                // Guardar valor original y poner 'DS'
                this.valoresOriginales[cellId] = currentValue;
                this.$set(item, key, 'DS');
            }
        },
        convertirMinutosADuracion(minutos) {
            if (typeof minutos !== 'number' || minutos < 0) {
                return "00:00:00"; // Manejo de caso inválido
            }

            // Calcula las horas (H), minutos restantes (M) y segundos (S)
            const horas = Math.floor(minutos / 60);
            const minutosRestantes = minutos % 60;
            const segundos = 0; // Asumimos que la duración siempre será en incrementos de minutos

            // Función auxiliar para añadir un cero inicial (padding)
            const pad = (num) => String(num).padStart(2, '0');

            // Retorna la duración en el formato HH:MM:SS
            return `${pad(horas)}:${pad(minutosRestantes)}:${pad(segundos)}`;
        }


    }
}
export default DayPlan